export const examQuestionsBatch1Ukrainian = [
    {
      id: 1,
      text: "Яке з наступних тверджень є НАЙКРАЩИМ прикладом ефекту штучного інтелекту? Оберіть ОДИН варіант.",
      options: [
        "Алгоритми машинного навчання стають менш вражаючими після поширення",
        "Технології ШІ перестають сприйматись як штучний інтелект після масового впровадження",
        "Нейронні мережі потребують складніших архітектур для підтримання ефективності",
        "Моделі глибокого навчання демонструють спадну віддачу додаткових навчальних даних"
      ],
      correct: 1,
      expA: "Це описує технологічну звичність, але не специфічний зсув сприйняття ефекту ШІ.",
      expB: "Точно! Ефект ШІ полягає в тому, що можливості перестають розглядатись як ШІ після поширення.",
      expC: "Це описує архітектурну складність, а не перцептуальні зміни, що визначають ефект ШІ.",
      expD: "Це описує обмеження навчання, а не феномен ефекту ШІ зміни сприйняття.",
      points: 1,
      chapter: "Вступ до ШІ",
      difficulty: "K2"
    },
    {
      id: 2,
      text: "Яка з наступних технологій НАЙЧАСТІШЕ використовується для реалізації штучного інтелекту? Оберіть ОДИН варіант.",
      options: [
        "Фреймворки розподілених обчислень",
        "Архітектури нейронних мереж",
        "Платформи контейнеризації",
        "Системи черг повідомлень"
      ],
      correct: 1,
      expA: "Розподілені обчислення підтримують ШІ, але не є основною технологією реалізації.",
      expB: "Правильно! Нейронні мережі є фундаментальними для більшості сучасних реалізацій ШІ.",
      expC: "Контейнеризація допомагає розгортати ШІ, але не реалізує сам інтелект.",
      expD: "Черги повідомлень обробляють комунікацію, але не створюють можливості ШІ.",
      points: 1,
      chapter: "Вступ до ШІ",
      difficulty: "K1"
    },
    {
      id: 3,
      text: "Яке з наступних тверджень ПРАВИЛЬНО розрізняє вузький ШІ від загального ШІ? Оберіть ОДИН варіант.",
      options: [
        "Вузький ШІ працює в обмежених доменах, загальний ШІ адаптується в доменах",
        "Вузький ШІ виконує специфічні завдання, загальний ШІ демонструє міркування людського рівня",
        "Вузький ШІ використовує навчання з учителем, загальний ШІ застосовує методи без учителя",
        "Вузький ШІ потребує структурованих даних, загальний ШІ обробляє неструктуровану інформацію"
      ],
      correct: 1,
      expA: "Це відображає доменні обмеження, але не пояснює повністю різницю в здатності міркування.",
      expB: "Відмінно! Це правильно визначає різницю між спеціалізацією завдань і мірокуванням людського рівня.",
      expC: "Тип методу навчання не визначає різницю між вузьким і загальним ШІ.",
      expD: "Вимоги до структури даних не розрізняють ці категорії ШІ.",
      points: 1,
      chapter: "Вступ до ШІ",
      difficulty: "K2"
    },
    {
      id: 4,
      text: "Яка з наступних технологій є НАЙПОШИРЕНІШИМ фреймворком для розробки глибокого навчання? Оберіть ОДИН варіант.",
      options: [
        "React.js для інтерфейсних застосунків",
        "Angular для веб-застосунків",
        "TensorFlow для застосунків машинного навчання",
        "Vue.js для реактивних інтерфейсів"
      ],
      correct: 2,
      expA: "React.js - це фреймворк для інтерфейсів, не для глибокого навчання.",
      expB: "Angular використовується для веб-розробки, не для моделей ШІ.",
      expC: "Правильно! TensorFlow є провідним фреймворком для розробки моделей глибокого навчання.",
      expD: "Vue.js призначений для веб-інтерфейсів, не для технологій ШІ.",
      points: 1,
      chapter: "Вступ до ШІ",
      difficulty: "K1"
    },
    {
      id: 5,
      text: "Яка з наступних характеристик НАЙКРАЩЕ описує обробку природної мови (NLP)? Оберіть ОДИН варіант.",
      options: [
        "Здатність ШІ розуміти та генерувати людську мову",
        "Можливість ШІ виконувати математичні розрахунки швидко",
        "Спроможність ШІ розпізнавати візуальні патерни зображень",
        "Здатність ШІ приймати рішення в ігрових середовищах"
      ],
      correct: 0,
      expA: "Точно! NLP фокусується на розумінні та генерації людської мови системами ШІ.",
      expB: "Математичні розрахунки стосуються числових обчислень, не обробки мови.",
      expC: "Розпізнавання візуальних патернів належить до комп'ютерного зору, не NLP.",
      expD: "Прийняття рішень в іграх стосується ігрової ШІ, не обробки мови.",
      points: 1,
      chapter: "Вступ до ШІ",
      difficulty: "K2"
    },
    {
      id: 6,
      text: "Яке з наступних тверджень НАЙТОЧНІШЕ характеризує навчання з підкріпленням? Оберіть ОДИН варіант.",
      options: [
        "Агент навчається через взаємодію з середовищем отримуючи винагороди",
        "Система класифікує дані використовуючи попередньо мічені приклади",
        "Алгоритм виявляє приховані патерни в немічених даних",
        "Модель прогнозує майбутні значення базуючись на історичних трендах"
      ],
      correct: 0,
      expA: "Правильно! Навчання з підкріпленням передбачає взаємодію агента з середовищем через винагороди.",
      expB: "Це описує навчання з учителем з міченими даними.",
      expC: "Це характеризує навчання без учителя для виявлення патернів.",
      expD: "Це стосується прогнозування часових рядів, не навчання з підкріпленням.",
      points: 1,
      chapter: "Вступ до ШІ",
      difficulty: "K2"
    },
    {
      id: 7,
      text: "Яка з наступних технік НАЙЕФЕКТИВНІША для виявлення аномалій у великих наборах даних? Оберіть ОДИН варіант.",
      options: [
        "Кластеризація даних з виділенням віддалених точок",
        "Регресійний аналіз для прогнозування тенденцій",
        "Класифікація тексту для категоризації контенту",
        "Рекомендаційні системи для персоналізації"
      ],
      correct: 0,
      expA: "Відмінно! Кластеризація ефективно ідентифікує аномалії як віддалені точки від основних кластерів.",
      expB: "Регресія фокусується на прогнозуванні, не на виявленні аномалій.",
      expC: "Класифікація тексту стосується категоризації, не виявлення аномалій.",
      expD: "Рекомендаційні системи призначені для персоналізації, не виявлення аномалій.",
      points: 1,
      chapter: "Вступ до ШІ",
      difficulty: "K2"
    },
    {
      id: 8,
      text: "Яке з наступних тверджень ПРАВИЛЬНО описує згорткові нейронні мережі (CNN)? Оберіть ОДИН варіант.",
      options: [
        "Спеціально розроблені для обробки послідовних даних часових рядів",
        "Оптимізовані для аналізу текстових даних та обробки мови",
        "Призначені для розпізнавання просторових патернів у візуальних даних",
        "Створені для прийняття рішень у стратегічних ігрових сценаріях"
      ],
      correct: 2,
      expA: "CNN не спеціалізуються на часових рядах - це роль рекурентних мереж.",
      expB: "Аналіз тексту зазвичай використовує інші архітектури, не CNN.",
      expC: "Правильно! CNN спеціально розроблені для розпізнавання просторових патернів у зображеннях.",
      expD: "Стратегічні ігри використовують інші підходи ШІ, не CNN.",
      points: 1,
      chapter: "Вступ до ШІ",
      difficulty: "K2"
    },
    {
      id: 9,
      text: "Яка з наступних метрик НАЙБІЛЬШ важлива для оцінки ефективності бінарної класифікації? Оберіть ОДИН варіант.",
      options: [
        "Середня абсолютна похибка для регресійної точності",
        "Коефіцієнт детермінації для пояснення варіантності",
        "F1-міра для збалансованої оцінки точності та повноти",
        "Кореляція Пірсона для лінейних зв'язків змінних"
      ],
      correct: 2,
      expA: "Абсолютна похибка використовується для задач регресії, не класифікації.",
      expB: "Коефіцієнт детермінації застосовується в регресії, не бінарній класифікації.",
      expC: "Відмінно! F1-міра ідеально підходить для оцінки бінарної класифікації, поєднуючи точність і повноту.",
      expD: "Кореляція Пірсона вимірює лінейні зв'язки, не ефективність класифікації.",
      points: 1,
      chapter: "Вступ до ШІ",
      difficulty: "K2"
    },
    {
      id: 10,
      text: "Яка стратегія НАЙКРАЩА для впровадження систем ШІ в критично важливих додатках охорони здоров'я? Оберіть ОДИН варіант.",
      options: [
        "Розгортати поступово з людським наглядом та валідацією результатів",
        "Впроваджувати повністю автоматизовані системи для максимальної ефективності",
        "Фокусуватись виключно на точності алгоритмів без врахування пояснюваності",
        "Використовувати найскладніші моделі незалежно від інтерпретованості"
      ],
      correct: 0,
      expA: "Правильно! Поступове впровадження з людським наглядом забезпечує безпеку в критичних додатках.",
      expB: "Повна автоматизація без нагляду ризикована в критично важливих медичних застосунках.",
      expC: "Пояснюваність критична в охороні здоров'я для довіри та відповідальності.",
      expD: "Складність моделі має балансуватися з інтерпретованістю в медичних застосунках.",
      points: 2,
      chapter: "Вступ до ШІ",
      difficulty: "K3"
    },
    {
      id: 11,
      text: "Яка стратегія тестування НАЙЕФЕКТИВНІША для валідації моделі рекомендаційної системи? Оберіть ОДИН варіант.",
      options: [
        "Тестування лише на невеликій вибірці популярних користувачів",
        "Валідація виключно на історичних даних без нових сценаріїв",
        "A/B тестування з різними групами користувачів для порівняння ефективності",
        "Фокус лише на технічних метриках без урахування користувацького досвіду"
      ],
      correct: 2,
      expA: "Тестування лише популярних користувачів не покриває різноманітність використання.",
      expB: "Валідація лише на історичних даних може пропустити нові сценарії використання.",
      expC: "Відмінно! A/B тестування забезпечує реальну валідацію ефективності з різними групами користувачів.",
      expD: "Технічні метрики важливі, але користувацький досвід критичний для рекомендаційних систем.",
      points: 2,
      chapter: "Вступ до ШІ",
      difficulty: "K3"
    },
    {
      id: 12,
      text: "Яка практика НАЙВАЖЛИВІША для забезпечення етичності в проектах машинного навчання? Оберіть ОДИН варіант.",
      options: [
        "Регулярний аудит на предвзятість з урахуванням різноманітності даних",
        "Максимізація точності моделі незалежно від справедливості результатів",
        "Використання найбільших доступних наборів даних без перевірки якості",
        "Фокус виключно на технічній ефективності без етичних міркувань"
      ],
      correct: 0,
      expA: "Правильно! Регулярний аудит на предвзятість критичний для етичного ШІ та справедливості.",
      expB: "Максимізація точності без урахування справедливості може призвести до етичних проблем.",
      expC: "Великі набори даних без перевірки якості можуть містити етично проблематичний контент.",
      expD: "Етичні міркування мають бути інтегровані в технічні рішення, не ігноровані.",
      points: 2,
      chapter: "Вступ до ШІ",
      difficulty: "K3"
    },
    {
      id: 13,
      text: "Яка стратегія НАЙЕФЕКТИВНІША для управління дрейфом даних у виробничих системах ШІ? Оберіть ОДИН варіант.",
      options: [
        "Безперервний моніторинг і періодичне перенавчання моделей на нових даних",
        "Використання фіксованих моделей без оновлень для забезпечення стабільності",
        "Покладання виключно на початкові дані навчання без адаптації",
        "Ігнорування змін в даних доки не виникнуть критичні проблеми"
      ],
      correct: 0,
      expA: "Відмінно! Безперервний моніторинг і перенавчання критичні для адаптації до дрейфу даних.",
      expB: "Фіксовані моделі не можуть адаптуватися до змін у даних і погіршують ефективність.",
      expC: "Покладання на початкові дані призводить до деградації моделі через дрейф.",
      expD: "Ігнорування дрейфу даних може призвести до серйозних помилок у виробництві.",
      points: 2,
      chapter: "Вступ до ШІ",
      difficulty: "K3"
    },
    {
      id: 14,
      text: "Яка практика НАЙКРАЩА для забезпечення надійності систем ШІ у фінансових застосунках? Оберіть ОДИН варіант.",
      options: [
        "Багаторівневе тестування з симуляцією ринкових умов та стрес-тестуванням",
        "Покладання виключно на історичні дані без врахування майбутніх сценаріїв",
        "Використання одного алгоритму для всіх типів фінансових рішень",
        "Мінімальне тестування для швидкого виведення продукту на ринок"
      ],
      correct: 0,
      expA: "Правильно! Багаторівневе тестування з симуляцією критичне для надійності фінансових систем ШІ.",
      expB: "Історичні дані можуть не відображати майбутні ринкові умови та ризики.",
      expC: "Різні фінансові застосунки потребують спеціалізованих підходів та алгоритмів.",
      expD: "Мінімальне тестування ризиковане у фінансових застосунках з високими ставками.",
      points: 2,
      chapter: "Вступ до ШІ",
      difficulty: "K3"
    },
    {
      id: 15,
      text: "Яка стратегія НАЙЕФЕКТИВНІША для тестування чат-ботів у багатомовних середовищах? Оберіть ОДИН варіант.",
      options: [
        "Тестування лише основною мовою з автоматичним перекладом інших",
        "Використання носіїв мови для валідації природності та культурної відповідності",
        "Покладання на автоматизовані інструменти без людської валідації",
        "Фокус виключно на технічній функціональності без лінгвістичної перевірки"
      ],
      correct: 1,
      expA: "Автоматичний переклад може пропустити нюанси та культурні особливості.",
      expB: "Відмінно! Носії мови критичні для валідації природності та культурної адекватності чат-ботів.",
      expC: "Автоматизовані інструменти не можуть повністю оцінити лінгвістичну якість.",
      expD: "Лінгвістична перевірка критична для ефективності багатомовних чат-ботів.",
      points: 2,
      chapter: "Вступ до ШІ",
      difficulty: "K3"
    },
    {
      id: 16,
      text: "Організація впроваджує ШІ для автоматизації процесів прийняття рішень у фінансовій сфері. Яка стратегія НАЙКРАЩА для управління ризиками? Оберіть ОДИН варіант.",
      options: [
        "Пріоритет швидких інновацій над міркуваннями управління ризиками",
        "Повне уникнення впровадження ШІ через регулятивні ризики",
        "Інтеграція процесів оцінки ризиків у цикли розробки інновацій",
        "Фокус виключно на перевірених технологіях ШІ для мінімізації невизначеності"
      ],
      correct: 2,
      expA: "Пріоритет інновацій над ризиками у фінансових послугах може мати серйозні наслідки.",
      expB: "Повне уникнення ШІ ігнорує конкурентні переваги та законні можливості.",
      expC: "Відмінно! Інтегровані процеси ризик-інновації забезпечують прогрес і відповідальність одночасно.",
      expD: "Обмеження виключно перевіреними технологіями може пропустити корисні можливості.",
      points: 3,
      chapter: "Вступ до ШІ",
      difficulty: "K4"
    },
    {
      id: 17,
      text: "Компанія розробляє систему ШІ для медичної діагностики. Який підхід НАЙКРАЩИЙ для забезпечення довіри лікарів? Оберіть ОДИН варіант.",
      options: [
        "Повна автоматизація діагностичних рішень без людського втручання",
        "Забезпечення пояснюваності рішень ШІ з клінічним контекстом та обґрунтуванням",
        "Фокус виключно на точності без врахування інтерпретованості результатів",
        "Використання найскладніших моделей незалежно від можливості їх пояснення"
      ],
      correct: 1,
      expA: "Повна автоматизація без людського нагляду ризикована в критичних медичних рішеннях.",
      expB: "Правильно! Пояснюваність з клінічним контекстом критична для довіри лікарів до ШІ-діагностики.",
      expC: "Точність важлива, але лікарі потребують розуміння процесу прийняття рішень.",
      expD: "Складність моделі має балансуватися з можливістю пояснення в медичних застосунках.",
      points: 3,
      chapter: "Вступ до ШІ",
      difficulty: "K4"
    },
    {
      id: 18,
      text: "Організація планує впровадити систему ШІ для персоналізації клієнтського досвіду. Яка стратегія НАЙЕФЕКТИВНІША? Оберіть ОДИН варіант.",
      options: [
        "Збір максимальної кількості персональних даних без обмежень конфіденційності",
        "Використання основних демографічних характеристик без поведінкового аналізу",
        "Балансування персоналізації з захистом приватності через відповідне управління даними",
        "Покладання виключно на третіх сторін для персоналізаційних алгоритмів"
      ],
      correct: 2,
      expA: "Збір даних без обмежень конфіденційності порушує принципи захисту приватності.",
      expB: "Основні демографічні дані можуть бути недостатніми для ефективної персоналізації.",
      expC: "Відмінно! Баланс персоналізації та приватності критичний для довіри клієнтів та комплаєнсу.",
      expD: "Залежність від третіх сторін може створити ризики безпеки та контролю якості.",
      points: 3,
      chapter: "Вступ до ШІ",
      difficulty: "K4"
    },
    {
      id: 19,
      text: "Стартап розробляє продукт з можливостями ШІ для ринку B2B. Яка стратегія НАЙКРАЩА для управління очікуваннями клієнтів? Оберіть ОДИН варіант.",
      options: [
        "Підкреслювати лише найскладніші можливості ШІ для вражаючого ефекту",
        "Уникати використання терміну 'ШІ' в описах продуктів",
        "Фокусуватися на демонстрації реальної цінності продукту для бізнесу",
        "Перейменовувати всі існуючі функції як ШІ-рішення"
      ],
      correct: 2,
      expA: "Акцент на складності може заплутати клієнтів і не вирішує проблему ефекту ШІ.",
      expB: "Уникнення ШІ-термінології може позбавити законних ринкових можливостей.",
      expC: "Відмінно! Фокус на реальній цінності допомагає клієнтам оцінити можливості незалежно від термінології.",
      expD: "Хибне ШІ-позиціонування вводить в оману і може пошкодити репутації.",
      points: 3,
      chapter: "Вступ до ШІ",
      difficulty: "K4"
    },
    {
      id: 20,
      text: "Команда розробляє систему ШІ для критично важливої інфраструктури. Який підхід НАЙКРАЩИЙ для забезпечення відмовостійкості? Оберіть ОДИН варіант.",
      options: [
        "Покладання на одну високоточну модель для всіх критичних рішень",
        "Впровадження резервних систем з людським втручанням при відмовах ШІ",
        "Використання найновіших експериментальних алгоритмів для максимальної ефективності",
        "Мінімізація системної складності через усунення резервних механізмів"
      ],
      correct: 1,
      expA: "Покладання на одну модель створює єдину точку відмови в критичній системі.",
      expB: "Правильно! Резервні системи з людським втручанням забезпечують відмовостійкість критичної інфраструктури.",
      expC: "Експериментальні алгоритми можуть бути неналежно протестованими для критичного використання.",
      expD: "Мінімізація складності за рахунок резервування знижує відмовостійкість системи.",
      points: 3,
      chapter: "Вступ до ШІ",
      difficulty: "K4"
    },
    {
        id: 21,
        text: "Яке з наступних тверджень НАЙКРАЩЕ описує адаптивність у системах на основі ШІ? Оберіть ОДИН варіант.",
        options: [
          "Системи, що можуть змінювати поведінку на основі нових патернів даних",
          "Системи, які підтримують стабільну ефективність в різних контекстах",
          "Системи, що оптимізують використання ресурсів через динамічний розподіл",
          "Системи, які зберігають вивчені патерни без модифікацій протягом часу"
        ],
        correct: 0,
        expA: "Точно! Адаптивність означає, що системи ШІ можуть коригувати свою поведінку при зіткненні з новими ситуаціями або патернами даних.",
        expB: "Стабільна ефективність цінна, але адаптивність конкретно стосується здатності змінювати та розвивати поведінку.",
        expC: "Оптимізація ресурсів стосується ефективності, а не адаптивності, яка фокусується на гнучкості поведінки.",
        expD: "Збереження патернів без змін є протилежністю адаптивності - це описує жорсткі, неадаптивні системи.",
        points: 1,
        chapter: "Характеристики якості для систем на основі ШІ",
        difficulty: "K2"
      },
      {
        id: 22,
        text: "Яка з наступних характеристик робить системи ШІ придатними для автономних застосунків? Оберіть ОДИН варіант.",
        options: [
          "Здатність приймати рішення без втручання людини в операційних контекстах",
          "Спроможність обробляти множинні потоки даних одночасно для аналізу",
          "Можливість підтримувати стабільну ефективність при різних обчислювальних навантаженнях",
          "Функціональність інтегрування з існуючими корпоративними системами та базами даних"
        ],
        correct: 0,
        expA: "Відмінно! Автономність означає, що система може працювати та приймати рішення незалежно без потреби у втручанні людини.",
        expB: "Багатопотокова обробка є технічною можливістю, але автономність конкретно стосується незалежного прийняття рішень.",
        expC: "Стабільність ефективності важлива, але автономність стосується незалежності прийняття рішень, а не управління навантаженням.",
        expD: "Системна інтеграція цінна, але автономність стосується операційної незалежності, а не функцій підключення.",
        points: 1,
        chapter: "Характеристики якості для систем на основі ШІ",
        difficulty: "K2"
      },
      {
        id: 23,
        text: "Яке з наступних тверджень про еволюцію систем ШІ є ПРАВИЛЬНИМ? Оберіть ОДИН варіант.",
        options: [
          "Еволюція потребує повного перенавчання моделі з розширеними наборами даних",
          "Еволюція відбувається через поступове навчання та процеси безперервної адаптації",
          "Еволюція трапляється лише під час запланованих вікон обслуговування для безпеки",
          "Еволюція включає ручні коригування параметрів доменними експертами"
        ],
        correct: 1,
        expA: "Еволюція може бути поступовими покращеннями, не обов'язково повним перенавчанням всієї системи.",
        expB: "Абсолютно! Системи ШІ еволюціонують через безперервне навчання, оновлення та адаптацію під час роботи.",
        expC: "Багато систем ШІ еволюціонують безперервно під час роботи, не лише в періоди обслуговування.",
        expD: "Справжня еволюція відбувається автоматично через механізми навчання, а не ручні коригування.",
        points: 1,
        chapter: "Характеристики якості для систем на основі ШІ",
        difficulty: "K2"
      },
      {
        id: 24,
        text: "Що з наведеного НАЙЙМОВІРНІШЕ є джерелом упередження в системах ШІ? Оберіть ОДИН варіант.",
        options: [
          "Навчальні набори даних, які не мають репрезентації серед демографічних груп",
          "Процеси відбору ознак, що виключають релевантні контекстуальні змінні",
          "Архітектури моделей, які посилюють певні патерни над іншими",
          "Метрики оцінки, що віддають перевагу специфічним типам прогнозної точності"
        ],
        correct: 0,
        expA: "Точно! Коли навчальні дані не представляють усі групи рівномірно, система ШІ навчається цим упередженим патернам.",
        expB: "Поганий відбір ознак може спричинити упередження, але недопредставленість демографії в даних є більш фундаментальною.",
        expC: "Вибір архітектури може сприяти упередженню, але упереджені навчальні дані зазвичай є первинним джерелом.",
        expD: "Упередження метрик оцінки важливе, але упередження репрезентації даних зазвичай має найпрямий вплив.",
        points: 1,
        chapter: "Характеристики якості для систем на основі ШІ",
        difficulty: "K2"
      },
      {
        id: 25,
        text: "Який з наступних етичних принципів є НАЙВАЖЛИВІШИМ при розгортанні систем ШІ? Оберіть ОДИН варіант.",
        options: [
          "Забезпечення алгоритмічної прозорості та пояснюваності рішень для стейкхолдерів",
          "Максимізація обчислювальної ефективності для зниження екологічного впливу",
          "Впровадження всеосяжних заходів шифрування даних та захисту приватності",
          "Встановлення справедливості та недискримінації в автоматизованих процесах прийняття рішень"
        ],
        correct: 3,
        expA: "Прозорість критична, але справедливість результатів часто вважається найбільш фундаментальним етичним принципом.",
        expB: "Екологічні міркування важливі, але справедливість та недискримінація мають етичний пріоритет.",
        expC: "Захист приватності суттєвий, але забезпечення справедливого ставлення до всіх груп є первинним етичним занепокоєнням.",
        expD: "Абсолютно! Справедливість забезпечує рівне ставлення та запобігає дискримінації в процесах прийняття рішень ШІ.",
        points: 1,
        chapter: "Характеристики якості для систем на основі ШІ",
        difficulty: "K2"
      },
      {
        id: 26,
        text: "Яке з наступних тверджень дає НАЙКРАЩИЙ приклад експлуатації винагороди (reward hacking)? Оберіть ОДИН варіант.",
        options: [
          "Система ШІ оптимізує метрики, експлуатуючи непередбачені лазівки у функціях винагороди",
          "Система ШІ покращує ефективність через складні техніки інженерії ознак",
          "Система ШІ швидко адаптується до нових патернів даних через трансферне навчання",
          "Система ШІ підтримує стабільну ефективність в різних середовищах розгортання"
        ],
        correct: 0,
        expA: "Відмінно! Експлуатація винагороди відбувається, коли ШІ знаходить творчі, але непередбачені способи максимізації функцій винагороди.",
        expB: "Інженерія ознак є легітимною оптимізацією, а не експлуатацією винагороди, яка включає використання лазівок.",
        expC: "Трансферне навчання є правильною технікою адаптації, а не експлуатацією, що визначає hacking винагороди.",
        expD: "Стабільна ефективність є бажаною поведінкою, експлуатація винагороди включає маніпулювання системою неналежним чином.",
        points: 1,
        chapter: "Характеристики якості для систем на основі ШІ",
        difficulty: "K2"
      },
      {
        id: 27,
        text: "Яке з наступних тверджень про прозорість у системах ШІ є ПРАВИЛЬНИМ? Оберіть ОДИН варіант.",
        options: [
          "Прозорість потребує повного розкриття пропрієтарних алгоритмічних реалізацій",
          "Прозорість включає надання зрозумілих пояснень процесів прийняття рішень",
          "Прозорість вимагає публікації всіх навчальних даних та моделей з відкритим кодом",
          "Прозорість потребує моніторингу всіх внутрішніх системних обчислень у реальному часі"
        ],
        correct: 1,
        expA: "Прозорість не потребує розкриття пропрієтарних деталей, а скоріше робить рішення зрозумілими.",
        expB: "Точно! Прозорість означає, що стейкхолдери можуть зрозуміти, як і чому ШІ приймає конкретні рішення.",
        expC: "Публікація з відкритим кодом не потрібна для прозорості - ключовими є чіткі пояснення рішень.",
        expD: "Моніторинг у реальному часі стосується спостережуваності, прозорість стосується пояснюваного прийняття рішень.",
        points: 1,
        chapter: "Характеристики якості для систем на основі ШІ",
        difficulty: "K2"
      },
      {
        id: 28,
        text: "Що з наведеного є ключовим занепокоєнням безпеки при розгортанні ШІ у критичних застосунках? Оберіть ОДИН варіант.",
        options: [
          "Непередбачувана поведінка системи у крайніх випадках",
          "Високі вимоги до обчислювальних ресурсів",
          "Складна інтеграція з застарілими системами",
          "Часті оновлення програмного забезпечення та патчі"
        ],
        correct: 0,
        expA: "Правильно! Непередбачувана поведінка у системах, критичних для безпеки, може призвести до серйозних наслідків.",
        expB: "Вимоги до ресурсів є проблемою ефективності, а не безпеки.",
        expC: "Складність інтеграції є технічним викликом, а не прямим занепокоєнням безпеки.",
        expD: "Частота оновлень є проблемою обслуговування, а не первинним занепокоєнням безпеки.",
        points: 1,
        chapter: "Характеристики якості для систем на основі ШІ",
        difficulty: "K1"
      },
      {
        id: 29,
        text: "Яка з наступних характеристик відрізняє самонавчальні системи від традиційних систем? Оберіть ОДИН варіант.",
        options: [
          "Здатність покращувати ефективність через досвід",
          "Використання передових математичних алгоритмів",
          "Реалізація паралельної обробки",
          "Інтеграція множинних джерел даних"
        ],
        correct: 0,
        expA: "Точно! Самонавчальні системи можуть покращувати та адаптувати свою ефективність на основі нового досвіду.",
        expB: "Передові алгоритми використовуються багатьма системами, не унікальні для самонавчальних систем.",
        expC: "Паралельна обробка є технічною можливістю, не відмінною рисою самонавчальних систем.",
        expD: "Інтеграція множинних джерел даних поширена в багатьох системах, не специфічна для самонавчання.",
        points: 1,
        chapter: "Характеристики якості для систем на основі ШІ",
        difficulty: "K1"
      },
      {
        id: 30,
        text: "Яка стратегія тестування НАЙКРАЩА для валідації інтеграції системи ШІ з існуючими застарілими системами? Оберіть ОДИН варіант.",
        options: [
          "Фокус виключно на тестуванні нової функціональності ШІ ізольовано",
          "Всеосяжне тестування інтерфейсів даних та поведінкової сумісності",
          "Мінімальне тестування для зниження ризиків затримки розгортання",
          "Покладання на автоматизовані інструменти без ручної валідації"
        ],
        correct: 1,
        expA: "Ізольоване тестування не виявить проблем інтеграції з існуючими системами.",
        expB: "Правильно! Всеосяжне тестування інтерфейсів критичне для забезпечення безшовної інтеграції ШІ з застарілими системами.",
        expC: "Мінімальне тестування ризиковане при інтеграції з критичними застарілими системами.",
        expD: "Автоматизовані інструменти корисні, але ручна валідація необхідна для складних інтеграцій ШІ.",
        points: 2,
        chapter: "Характеристики якості для систем на основі ШІ",
        difficulty: "K3"
      },
      {
        id: 31,
        text: "При тестуванні системи ШІ на предмет справедливості, який підхід НАЙЕФЕКТИВНІШИЙ? Оберіть ОДИН варіант.",
        options: [
          "Тестування лише на мажоритарних групах населення",
          "Використання статистичного паритету серед демографічних груп",
          "Повне ігнорування захищених характеристик",
          "Тестування лише з синтетичними даними"
        ],
        correct: 1,
        expA: "Тестування лише мажоритарних груп пропускає упередження, що впливають на міноритарні популяції, які потребують захисту.",
        expB: "Відмінно! Тестування статистичного паритету виявляє, чи системи ШІ ставляться до різних демографічних груп справедливо.",
        expC: "Ігнорування захищених характеристик запобігає виявленню систематичних патернів дискримінації.",
        expD: "Лише синтетичні дані можуть не захопити реальні патерни упередження, що впливають на фактичні популяції.",
        points: 2,
        chapter: "Характеристики якості для систем на основі ШІ",
        difficulty: "K3"
      },
      {
        id: 32,
        text: "Яка стратегія НАЙКРАЩА для тестування пояснюваності у складних системах ШІ? Оберіть ОДИН варіант.",
        options: [
          "Валідація технічної точності пояснень з доменними експертами",
          "Фокус виключно на глобальній інтерпретованості моделі",
          "Тестування лише з автоматизованими метриками пояснюваності",
          "Покладання на документацію без валідації користувачами"
        ],
        correct: 0,
        expA: "Правильно! Валідація з доменними експертами забезпечує, що пояснення є як технічно точними, так і практично корисними.",
        expB: "Глобальна інтерпретованість важлива, але локальні пояснення для конкретних рішень часто більш цінні для користувачів.",
        expC: "Автоматизовані метрики корисні, але валідація людьми необхідна для забезпечення реальної зрозумілості.",
        expD: "Документація допомагає, але фактичне тестування пояснень з користувачами критичне для валідації пояснюваності.",
        points: 2,
        chapter: "Характеристики якості для систем на основі ШІ",
        difficulty: "K3"
      },
      {
        id: 33,
        text: "При оцінці автономності системи ШІ, що є НАЙВАЖЛИВІШИМ для валідації? Оберіть ОДИН варіант.",
        options: [
          "Здатність системи працювати без втручання людини у визначених сценаріях",
          "Технічна складність алгоритмів прийняття рішень",
          "Швидкість обробки та час відповіді системи",
          "Обсяг даних, які система може обробити"
        ],
        correct: 0,
        expA: "Точно! Справжня автономність означає, що система може успішно діяти незалежно в реалістичних робочих умовах.",
        expB: "Складність алгоритмів не визначає автономність - простіші системи можуть бути дуже автономними.",
        expC: "Швидкість важлива для ефективності, але не визначає рівень автономності системи.",
        expD: "Обсяг даних стосується масштабованості, а не здатності до автономної роботи.",
        points: 2,
        chapter: "Характеристики якості для систем на основі ШІ",
        difficulty: "K3"
      },
      {
        id: 34,
        text: "Яка стратегія НАЙЕФЕКТИВНІША для управління еволюцією системи ШІ у виробничому середовищі? Оберіть ОДИН варіант.",
        options: [
          "Регулярний моніторинг ефективності з контрольованим поступовим оновленням",
          "Дозвіл системі еволюціонувати повністю без втручання",
          "Повна заміна системи при кожній зміні вимог",
          "Фіксація системи після початкового розгортання"
        ],
        correct: 0,
        expA: "Відмінно! Контрольована еволюція з моніторингом забезпечує адаптацію при збереженні стабільності та якості.",
        expB: "Некеровані зміни можуть призвести до деградації ефективності або непередбачуваної поведінки.",
        expC: "Повна заміна надмірно радикальна і не використовує переваги поступового навчання.",
        expD: "Фіксація системи запобігає корисній адаптації до змінних умов та даних.",
        points: 2,
        chapter: "Характеристики якості для систем на основі ШІ",
        difficulty: "K3"
      },
      {
        id: 35,
        text: "При тестуванні побічних ефектів у системі ШІ, який підхід НАЙКРАЩИЙ? Оберіть ОДИН варіант.",
        options: [
          "Фокус лише на основних функціональних вимогах",
          "Всеосяжне тестування непередбачених наслідків у суміжних доменах",
          "Тестування лише під час фази розробки",
          "Покладання на звіти користувачів після розгортання"
        ],
        correct: 1,
        expA: "Фокус лише на основних функціях пропускає критичні побічні ефекти, які можуть вплинути на інші системи.",
        expB: "Правильно! Побічні ефекти часто проявляються в неочікуваних областях, що потребує всеосяжного тестування.",
        expC: "Побічні ефекти можуть виникнути під час роботи, тому потрібен постійний моніторинг, а не лише розробка.",
        expD: "Чекати звітів користувачів занадто пізно - побічні ефекти треба виявляти проактивно.",
        points: 2,
        chapter: "Характеристики якості для систем на основі ШІ",
        difficulty: "K3"
      },
      {
        id: 36,
        text: "Організація розгортає систему ШІ для медичної діагностики. Яка стратегія валідації НАЙКРАЩА для регуляторного схвалення? Оберіть ОДИН варіант.",
        options: [
          "Фокус виключно на технічній точності алгоритмів діагностики",
          "Інтегроване стрес-тестування всіх характеристик якості під регуляторним наглядом",
          "Поетапна валідація кожної характеристики якості окремо",
          "Покладання на клінічні випробування без технічного тестування"
        ],
        correct: 1,
        expA: "Технічна точність критична, але регулятори потребують демонстрації всіх аспектів безпеки та якості.",
        expB: "Відмінно! Охорона здоров'я потребує всеосяжного тестування всіх характеристик під регуляторним наглядом.",
        expC: "Поетапна валідація корисна, але інтегроване тестування показує, як характеристики взаємодіють у реальних умовах.",
        expD: "Клінічні випробування необхідні, але технічне тестування критичне для забезпечення безпеки та надійності.",
        points: 3,
        chapter: "Характеристики якості для систем на основі ШІ",
        difficulty: "K4"
      },
      {
        id: 37,
        text: "Компанія впроваджує систему ШІ для фінансового кредитування. Який підхід НАЙКРАЩИЙ для забезпечення етичної відповідальності? Оберіть ОДИН варіант.",
        options: [
          "Максимізація прибутковості через оптимізацію алгоритмів схвалення",
          "Впровадження багаторівневого аудиту справедливості з незалежним наглядом",
          "Фокус виключно на технічній ефективності класифікації",
          "Мінімізація регуляторного втручання через самосертифікацію"
        ],
        correct: 1,
        expA: "Максимізація прибутковості без етичних міркувань може призвести до дискримінаційної практики кредитування.",
        expB: "Правильно! Багаторівневий аудит з незалежним наглядом забезпечує справедливість та етичну відповідальність.",
        expC: "Технічна ефективність важлива, але етичні міркування рівно критичні для фінансових рішень.",
        expD: "Саморегулювання недостатнє для забезпечення етичних стандартів у фінансових застосунках з високими ставками.",
        points: 3,
        chapter: "Характеристики якості для систем на основі ШІ",
        difficulty: "K4"
      },
      {
        id: 38,
        text: "Організація планує систему ШІ для управління критичною інфраструктурою. Який підхід НАЙКРАЩИЙ для управління комплексними ризиками? Оберіть ОДИН варіант.",
        options: [
          "Швидке розгортання для максимізації конкурентних переваг",
          "Багатошарова стратегія управління ризиками з дублюючими системами безпеки",
          "Фокус виключно на кібербезпеці без урахування інших ризиків",
          "Мінімальне тестування для зниження витрат на розробку"
        ],
        correct: 1,
        expA: "Швидке розгортання у критичній інфраструктурі без належної валідації створює неприйнятні ризики безпеки.",
        expB: "Відмінно! Критична інфраструктура потребує багатошарових заходів безпеки з дублюючими системами для управління складними ризиками.",
        expC: "Кібербезпека важлива, але критична інфраструктура потребує всеосяжного управління ризиками, включаючи безпеку та надійність.",
        expD: "Мінімальне тестування неприйнятне для критичної інфраструктури, де відмови можуть мати катастрофічні наслідки.",
        points: 3,
        chapter: "Характеристики якості для систем на основі ШІ",
        difficulty: "K4"
      },
      {
        id: 39,
        text: "Стартап розробляє систему ШІ для персоналізації освітнього контенту. Яка стратегія НАЙКРАЩА для балансування персоналізації та приватності? Оберіть ОДИН варіант.",
        options: [
          "Збір максимальної кількості даних учнів для покращення персоналізації",
          "Використання федеративного навчання з диференційною приватністю",
          "Повне уникнення персоналізації для захисту приватності",
          "Покладання на згоди батьків без технічних заходів захисту"
        ],
        correct: 1,
        expA: "Збір максимальних даних без захистів порушує приватність та може не відповідати освітнім регуляторним вимогам.",
        expB: "Правильно! Федеративне навчання з диференційною приватністю дозволяє персоналізацію при збереженні приватності учнів.",
        expC: "Повне уникнення персоналізації втрачає освітні переваги адаптивного навчання для учнів.",
        expD: "Згоди важливі, але технічні заходи захисту критичні для захисту даних учнів у освітніх системах.",
        points: 3,
        chapter: "Характеристики якості для систем на основі ШІ",
        difficulty: "K4"
      },
      {
        id: 40,
        text: "Компанія впроваджує систему ШІ у регульованій галузі з суворими вимогами до відповідності. Який підхід НАЙКРАЩИЙ для валідації? Оберіть ОДИН варіант.",
        options: [
          "Фокус виключно на надійності без урахування інших характеристик",
          "Поетапна валідація для поступового досягнення відповідності",
          "Інтегроване стрес-тестування всіх характеристик якості під регуляторним наглядом",
          "Тестування ШІ повинно починатись лише після розгортання для реальних умов"
        ],
        correct: 2,
        expA: "Надійність критична, але регульовані галузі потребують валідації всіх аспектів якості та відповідності.",
        expB: "Поетапна валідація корисна, але регулятори хочуть бачити докази роботи в критичних ситуаціях з самого початку.",
        expC: "Відмінно! Регульовані галузі потребують всеосяжного тестування всіх характеристик під регуляторним наглядом.",
        expD: "Тестування ШІ повинно починатись до розгортання - безпека пацієнтів та відповідність потребують проактивної валідації.",
        points: 3,
        chapter: "Характеристики якості для систем на основі ШІ",
        difficulty: "K4"
      },
      {
        id: 41,
        text: "Яке з наступних тверджень про навчання з учителем є ПРАВИЛЬНИМ? Виберіть ОДИН варіант.",
        options: [
          "Системи, що вивчають оптимальні патерни з немаркованих колекцій даних",
          "Системи, що використовують марковані тренувальні дані для передбачення результатів нових екземплярів",
          "Системи, що виявляють зв'язки через взаємодію із середовищем та механізми винагород",
          "Системи, що ідентифікують приховані структурні патерни без керівництва або попередньо визначених цілей"
        ],
        correct: 1,
        expA: "Це описує підходи навчання без учителя, які працюють з немаркованими даними.",
        expB: "Абсолютно правильно! Навчання з учителем використовує марковані приклади для вивчення зв'язків вхід-вихід для передбачень.",
        expC: "Це описує навчання з підкріпленням з системами винагород на основі взаємодії.",
        expD: "Це описує навчання без учителя, що виявляє приховані патерни без міток.",
        points: 1,
        chapter: "Машинне навчання (ML) - Огляд",
        difficulty: "K2"
      },
      {
        id: 42,
        text: "Яке з наступних тверджень надає НАЙКРАЩИЙ приклад класифікації? Виберіть ОДИН варіант.",
        options: [
          "Визначення дискретної належності до категорії з вхідних патернів ознак",
          "Оцінка безперервних числових значень з трендів історичних даних",
          "Виявлення природних груп всередині немаркованих колекцій даних",
          "Ідентифікація частих патернів співіснування в наборах даних транзакцій"
        ],
        correct: 0,
        expA: "Чудово! Класифікація призначає елементи до попередньо визначених дискретних категорій, як спам/не спам.",
        expB: "Це описує регресію, яка передбачає безперервні числові значення.",
        expC: "Це описує кластеризацію, яка групує схожі елементи без попередньо визначених категорій.",
        expD: "Це описує асоціативне навчання, яке знаходить зв'язки співіснування.",
        points: 1,
        chapter: "Машинне навчання (ML) - Огляд",
        difficulty: "K1"
      },
      {
        id: 43,
        text: "Яке з наступних тверджень надає НАЙКРАЩИЙ приклад регресії? Виберіть ОДИН варіант.",
        options: [
          "Призначення точок даних до попередньо визначених дискретних категоричних міток",
          "Передбачення безперервних числових значень зі зв'язків вхідних ознак",
          "Ідентифікація природних кластерів всередині багатовимірних просторів даних",
          "Навчання оптимальних дій через механізми зворотного зв'язку середовища"
        ],
        correct: 1,
        expA: "Це описує класифікацію, яка призначає елементи до дискретних категорій.",
        expB: "Точно! Регресія передбачає безперервні числові значення, як температура або ціна.",
        expC: "Це описує кластеризацію, яка групує схожі точки даних разом.",
        expD: "Це описує навчання з підкріпленням з механізмами винагороди.",
        points: 1,
        chapter: "Машинне навчання (ML) - Огляд",
        difficulty: "K1"
      },
      {
        id: 44,
        text: "Яке з наступних тверджень про інженерію ознак є ПРАВИЛЬНИМ? Виберіть ОДИН варіант.",
        options: [
          "Вона відбувається після розгортання моделі в продукційному середовищі",
          "Вона перетворює необроблені дані на структуровані входи для моделі",
          "Вона оцінює метрики точності та продуктивності розробленої моделі",
          "Вона вибирає остаточні параметри алгоритму для оптимальної продуктивності"
        ],
        correct: 1,
        expA: "Інженерія ознак відбувається під час підготовки даних, до розгортання.",
        expB: "Правильно! Інженерія ознак створює значущі входи з необроблених даних.",
        expC: "Це описує оцінку моделі, а не інженерію ознак.",
        expD: "Це описує налаштування гіперпараметрів, а не інженерію ознак.",
        points: 1,
        chapter: "Машинне навчання (ML) - Огляд",
        difficulty: "K2"
      },
      {
        id: 45,
        text: "Що з наступного НАЙІМОВІРНІШЕ вказує на недонавчання? Виберіть ОДИН варіант.",
        options: [
          "Висока точність тренування, низька точність тестування на валідаційних даних",
          "Низька точність тренування, низька точність тестування на обох наборах",
          "Висока точність тренування, висока точність тестування на різних наборах",
          "Змінна точність тренування, стабільна точність тестування протягом епох"
        ],
        correct: 1,
        expA: "Це вказує на перенавчання - модель запам'ятала тренувальні дані.",
        expB: "Правильно! Недонавчання показує погану продуктивність на обох наборах даних.",
        expC: "Це вказує на добре збалансоване навчання з оптимальною узагальненістю.",
        expD: "Це може вказувати на проблеми стабільності, але не специфічно недонавчання.",
        points: 1,
        chapter: "Машинне навчання (ML) - Огляд",
        difficulty: "K2"
      },
      {
        id: 46,
        text: "Яке з наступних найкраще описує перехресну валідацію? Виберіть ОДИН варіант.",
        options: [
          "Тестування моделі лише на окремому наборі тестових даних",
          "Розділення даних на кілька частин для ітеративного тренування та тестування",
          "Використання тих самих даних як для тренування, так і для тестування",
          "Тренування декількох моделей одночасно на різних наборах алгоритмів"
        ],
        correct: 1,
        expA: "Це описує простий розділ тренування/тестування, не перехресну валідацію.",
        expB: "Точно! Перехресна валідація розділяє дані на фолди для надійнішої оцінки.",
        expC: "Це призведе до перенавчання та нереалістичних результатів продуктивності.",
        expD: "Це описує ансамблеві методи, а не перехресну валідацію.",
        points: 1,
        chapter: "Машинне навчання (ML) - Огляд",
        difficulty: "K2"
      },
      {
        id: 47,
        text: "Що з наступного є основною перевагою ансамблевих методів? Виберіть ОДИН варіант.",
        options: [
          "Вони завжди працюють швидше за індивідуальні моделі навчання",
          "Вони покращують продуктивність шляхом комбінування кількох моделей разом",
          "Вони потребують менше тренувальних даних для досягнення високої точності",
          "Вони автоматично вибирають найкращі ознаки без втручання людини"
        ],
        correct: 1,
        expA: "Ансамблі зазвичай повільніші через обчислення кількох моделей одночасно.",
        expB: "Правильно! Ансамблі комбінують кілька моделей для покращеної загальної продуктивності.",
        expC: "Ансамблі зазвичай потребують стільки ж або більше даних.",
        expD: "Вибір ознак - це окремий процес, не автоматична функція ансамблів.",
        points: 1,
        chapter: "Машинне навчання (ML) - Огляд",
        difficulty: "K2"
      },
      {
        id: 48,
        text: "Яке з наступних найкраще описує regularization в машинному навчанні? Виберіть ОДИН варіант.",
        options: [
          "Процес збільшення складності моделі для кращої продуктивності тренування",
          "Метод зменшення перенавчання шляхом додавання штрафів за складність",
          "Техніка збільшення швидкості тренування через паралельні обчислення",
          "Підхід до автоматичного вибору найкращих ознак з великих наборів"
        ],
        correct: 1,
        expA: "Регуляризація зменшує складність, а не збільшує її для контролю перенавчання.",
        expB: "Точно! Регуляризація додає штрафи для запобігання перенавчанню та покращення узагальнення.",
        expC: "Це описує оптимізацію обчислень, а не regularization techniques.",
        expD: "Це описує вибір ознак, який є окремою методикою від regularization.",
        points: 1,
        chapter: "Машинне навчання (ML) - Огляд",
        difficulty: "K2"
      },
      {
        id: 49,
        text: "Що з наступного найкраще характеризує gradient descent? Виберіть ОДИН варіант.",
        options: [
          "Алгоритм для автоматичного вибору найкращих ознак з великого набору",
          "Метод розділення даних на тренувальні та тестові набори",
          "Техніка комбінування кількох моделей для покращеної загальної продуктивності",
          "Ітеративний алгоритм оптимізації для мінімізації функції втрат моделі"
        ],
        correct: 3,
        expA: "Це описує методи вибору ознак, а не gradient descent optimization.",
        expB: "Це описує розділення даних, що є окремим процесом підготовки.",
        expC: "Це описує ансамблеві методи, не алгоритми оптимізації gradient descent.",
        expD: "Правильно! Gradient descent ітеративно мінімізує функцію втрат для оптимізації параметрів.",
        points: 1,
        chapter: "Машинне навчання (ML) - Огляд",
        difficulty: "K2"
      },
      {
        id: 50,
        text: "Компанія електронної комерції хоче передбачати поведінку клієнтів для персоналізованих рекомендацій. Який підхід є НАЙБІЛЬШ відповідним? Виберіть ОДИН варіант.",
        options: [
          "Навчання з учителем з історичними даними про транзакції клієнтів",
          "Навчання без учителя для виявлення груп поведінки без міток",
          "Навчання з підкріпленням для адаптації до зворотного зв'язку користувачів",
          "Статистичний аналіз без алгоритмів машинного навчання взагалі"
        ],
        correct: 0,
        expA: "Відмінно! Історичні дані транзакцій з відомими результатами ідеальні для навчання з учителем.",
        expB: "Кластеризація корисна, але навчання з учителем краще для конкретних передбачень рекомендацій.",
        expC: "Навчання з підкріпленням може бути корисним, але вимагає складніших механізмів винагород.",
        expD: "Машинне навчання забезпечує кращі рекомендації, ніж базовий статистичний аналіз.",
        points: 2,
        chapter: "Машинне навчання (ML) - Огляд",
        difficulty: "K3"
      },
      {
        id: 51,
        text: "Медична компанія розробляє систему діагностики захворювань з рентгенівських знімків. Яка техніка машинного навчання найбільш підходяща? Виберіть ОДИН варіант.",
        options: [
          "Навчання без учителя для групування схожих патернів зображень автоматично",
          "Навчання з учителем з експертно маркованими діагнозами зображень",
          "Навчання з підкріпленням для навчання через взаємодію з пацієнтами",
          "Статистичні методи без глибинних алгоритмів навчання взагалі"
        ],
        correct: 1,
        expA: "Діагностика потребує специфічних міток захворювань, не просто групування патернів.",
        expB: "Правильно! Медична діагностика вимагає навчання з учителем з експертними мітками.",
        expC: "Навчання з підкріпленням непрактичне для медичної діагностики з етичних міркувань.",
        expD: "Глибинне навчання показує кращі результати для аналізу медичних зображень.",
        points: 2,
        chapter: "Машинне навчання (ML) - Огляд",
        difficulty: "K3"
      },
      {
        id: 52,
        text: "Технологічний стартап має обмежені дані, але потребує високоточну модель розпізнавання зображень. Яка стратегія є найбільш практичною? Виберіть ОДИН варіант.",
        options: [
          "Зібрати мільйони додаткових зображень перед початком розробки моделі",
          "Використовувати методи аугментації даних для штучного збільшення набору",
          "Покладатися виключно на навчання без учителя для навчання",
          "Розробляти власні алгоритми з нуля замість існуючих"
        ],
        correct: 1,
        expA: "Збір мільйонів зображень часозатратний і може бути непрактичним для стартапу.",
        expB: "Точно! Аугментація даних ефективно збільшує тренувальні дані з обмеженими ресурсами.",
        expC: "Навчання без учителя не забезпечить точних результатів для розпізнавання.",
        expD: "Розробка власних алгоритмів вимагає значних ресурсів і часу.",
        points: 2,
        chapter: "Машинне навчання (ML) - Огляд",
        difficulty: "K3"
      },
      {
        id: 53,
        text: "Фінансова інституція розробляє систему виявлення шахрайства, яка повинна мінімізувати помилкові спрацьовування. Яка метрика найбільш важлива? Виберіть ОДИН варіант.",
        options: [
          "Загальна точність класифікації всіх транзакцій в системі",
          "Швидкість обробки транзакцій в реальному часі",
          "Precision (точність) для класу шахрайських транзакцій",
          "Збалансованість розподілу класів у тренувальних даних"
        ],
        correct: 2,
        expA: "Загальна точність може бути оманливою в незбалансованих наборах даних шахрайства.",
        expB: "Швидкість важлива, але не стосується мінімізації помилкових спрацьовувань.",
        expC: "Правильно! Висока precision зменшує помилкові позитивні результати (помилкові спрацьовування).",
        expD: "Збалансованість даних корисна, але precision безпосередньо адресує помилкові спрацьовування.",
        points: 2,
        chapter: "Машинне навчання (ML) - Огляд",
        difficulty: "K3"
      },
      {
        id: 54,
        text: "Виробнича компанія впроваджує предиктивне обслуговування для зменшення простою обладнання. Яка стратегія найбільш ефективна? Виберіть ОДИН варіант.",
        options: [
          "Використовувати тільки історичні дані про поломки без сенсорної інформації",
          "Покладатися на планове обслуговування без машинного навчання",
          "Комбінувати дані сенсорів в реальному часі з алгоритмами машинного навчання",
          "Застосовувати тільки експертні правила без даних про продуктивність"
        ],
        correct: 2,
        expA: "Тільки історичні дані без поточної інформації обмежують точність передбачень.",
        expB: "Планове обслуговування менш ефективне ніж предиктивне з машинним навчанням.",
        expC: "Точно! Комбінація сенсорних даних реального часу з ML забезпечує найкращі результати.",
        expD: "Експертні правила без даних можуть пропустити складні патерни поломок.",
        points: 2,
        chapter: "Машинне навчання (ML) - Огляд",
        difficulty: "K3"
      },
      {
        id: 55,
        text: "Освітня платформа хоче персоналізувати навчальний досвід для студентів різних рівнів. Який підхід машинного навчання найбільш підходящий? Виберіть ОДИН варіант.",
        options: [
          "Використовувати однакову модель для всіх студентів незалежно від рівня",
          "Застосовувати тільки контентну фільтрацію без поведінкових даних",
          "Комбінувати колаборативну фільтрацію з аналізом навчальних патернів студентів",
          "Покладатися тільки на демографічні дані без навчальної поведінки"
        ],
        correct: 2,
        expA: "Одна модель для всіх не може забезпечити ефективну персоналізацію.",
        expB: "Контентна фільтрація сама по собі обмежена без поведінкових даних.",
        expC: "Відмінно! Комбінування підходів враховує як уподобання, так і навчальні патерни.",
        expD: "Демографічні дані недостатні для ефективної персоналізації навчання.",
        points: 2,
        chapter: "Машинне навчання (ML) - Огляд",
        difficulty: "K3"
      },
      {
        id: 56,
        text: "Медичний заклад повинен впровадити систему ШІ для діагностики з високими вимогами до інтерпретованості. Яка стратегія є НАЙКРАЩОЮ? Виберіть ОДИН варіант.",
        options: [
          "Розгорнути найточнішу ансамблеву модель незалежно від складності пояснення",
          "Використовувати інтерпретовані моделі з всебічною документацією процесів",
          "Зосередитися тільки на швидкості тренування без врахування пояснюваності",
          "Застосовувати навчання без учителя для автоматичного виявлення патернів"
        ],
        correct: 1,
        expA: "Складні ансамблі можуть не відповідати вимогам медичної аудитованості.",
        expB: "Точно! Медичні застосування вимагають інтерпретованих моделей для регуляторного схвалення.",
        expC: "Швидкість тренування менш важлива ніж інтерпретованість у медичній діагностиці.",
        expD: "Медична діагностика вимагає навчання з учителем з експертно маркованими даними.",
        points: 3,
        chapter: "Машинне навчання (ML) - Огляд",
        difficulty: "K4"
      },
      {
        id: 57,
        text: "Стартап з обмеженими обчислювальними ресурсами повинен впровадити ML для розпізнавання зображень. Яка стратегія найбільш практична? Виберіть ОДИН варіант.",
        options: [
          "Тренувати великі нейронні мережі з нуля для максимальної точності",
          "Використовувати transfer learning з попередньо тренованими моделями",
          "Збирати більші набори даних для тренування власних алгоритмів",
          "Розробляти власні алгоритми з дослідницьких статей самостійно"
        ],
        correct: 1,
        expA: "Тренування великих мереж з нуля вимагає значних обчислювальних ресурсів.",
        expB: "Чудово! Transfer learning використовує існуючі моделі для зменшення вимог до ресурсів.",
        expC: "Більші набори даних вимагають більше обчислювальних ресурсів, а не менше.",
        expD: "Власні алгоритми вимагають значного часу розробки та експертизи.",
        points: 3,
        chapter: "Машинне навчання (ML) - Огляд",
        difficulty: "K4"
      },
      {
        id: 58,
        text: "Платформа електронної комерції потребує персоналізованих рекомендацій, що адаптуються до мінливих уподобань користувачів. Який підхід найбільш підходящий? Виберіть ОДИН варіант.",
        options: [
          "Статична система на основі правил без можливості адаптації",
          "Пакетне навчання з щомісячними оновленнями моделей",
          "Онлайн навчання з безперервною адаптацією до нової поведінки",
          "Тільки ручна інженерія ознак без автоматичної адаптації"
        ],
        correct: 2,
        expA: "Статичні правила не можуть адаптуватися до мінливих уподобань користувачів.",
        expB: "Щомісячні оновлення можуть бути занадто повільними для швидко мінливих уподобань.",
        expC: "Точно! Онлайн навчання безперервно адаптується до нових патернів поведінки користувачів.",
        expD: "Ручна інженерія сама по собі не може обробляти динамічні зміни уподобань.",
        points: 3,
        chapter: "Машинне навчання (ML) - Огляд",
        difficulty: "K4"
      },
      {
        id: 59,
        text: "Фінансова інституція повинна впровадити ML для оцінки ризиків, забезпечуючи регуляторну відповідність та аудитованість моделі. Який підхід НАЙКРАЩИЙ? Виберіть ОДИН варіант.",
        options: [
          "Розгорнути найточніший ансамбль незалежно від складності пояснення",
          "Використовувати інтерпретовані моделі з всебічною документацією процесів рішень",
          "Зосередитися тільки на автоматизованому виборі ознак без контролю",
          "Надавати пріоритет швидкості тренування над усіма іншими факторами"
        ],
        correct: 1,
        expA: "Складні ансамблі можуть не відповідати вимогам фінансової аудитованості.",
        expB: "Чудово! Фінансові регулювання вимагають інтерпретованих та добре задокументованих моделей.",
        expC: "Автоматизовані ознаки самі по собі не можуть забезпечити регуляторну відповідність.",
        expD: "Швидкість тренування менш важлива ніж відповідність та аудитованість.",
        points: 3,
        chapter: "Машинне навчання (ML) - Огляд",
        difficulty: "K4"
      },
      {
        id: 60,
        text: "Виробнича компанія хоче впровадити предиктивне обслуговування з варіативною якістю даних по різних машинах та локаціях. Яка стратегія найбільш ефективна? Виберіть ОДИН варіант.",
        options: [
          "Використовувати ідентичні моделі для всіх машин без врахування відмінностей",
          "Зосередитися тільки на машинах з ідеальними даними для розробки",
          "Впровадити робастні моделі з обробкою якості даних та адаптацією",
          "Ігнорувати проблеми якості даних повністю в процесі моделювання"
        ],
        correct: 2,
        expA: "Ідентичні моделі можуть не обробляти варіативні умови різних машин.",
        expB: "Зосередження тільки на ідеальних даних обмежує практичну користь системи.",
        expC: "Правильно! Робастні моделі з обробкою якості даних забезпечують надійні передбачення в варіативних умовах.",
        expD: "Ігнорування проблем якості даних призведе до ненадійних передбачень.",
        points: 3,
        chapter: "Машинне навчання (ML) - Огляд",
        difficulty: "K4"
      },
      {
        id: 61,
        text: "Що з наведеного є НАЙКРАЩИМ прикладом підходу до розмітки даних для навчання ML-моделі?",
        options: [
          "Використання краудсорсингу для розмітки великих наборів даних",
          "Автоматичне генерування міток на основі наявних метаданих", 
          "Залучення предметних експертів для складних випадків розмітки",
          "Застосування активного навчання для вибору зразків для розмітки"
        ],
        correct: 0,
        expA: "Правильно! Краудсорсинг дозволяє ефективно обробляти великі обсяги даних з контролем якості через множинних анотаторів.",
        expB: "Автоматичне генерування міток може бути корисним, але часто не забезпечує необхідної точності для навчання якісних моделей.",
        expC: "Експерти дуже цінні для складних випадків, але це не масштабується для великих наборів даних і може бути занадто дорогим.",
        expD: "Активне навчання допомагає оптимізувати вибір зразків, але не вирішує основну проблему того, як саме розмітити дані.",
        points: 1,
        chapter: "ML - Дані",
        difficulty: "K1"
      },
      {
        id: 62,
        text: "Який тип набору даних найбільше підходить для навчання моделі класифікації зображень?",
        options: [
          "Набір неструктурованих текстових документів з категоріями",
          "Набір часових рядів з мітками подій",
          "Набір зображень з відповідними категоріальними мітками", 
          "Набір числових даних з безперервними цільовими значеннями"
        ],
        correct: 2,
        expA: "Текстові документи підходять для обробки природної мови, а не для класифікації зображень.",
        expB: "Часові ряди використовуються для прогнозування в часі, що не стосується класифікації зображень.",
        expC: "Саме так! Для навчання класифікатора зображень потрібен набір зображень з правильними категоріальними мітками для кожного класу.",
        expD: "Безперервні цільові значення підходять для задач регресії, а не класифікації.",
        points: 1,
        chapter: "ML - Дані",
        difficulty: "K1"
      },
      {
        id: 63,
        text: "Яка з наступних проблем є найпоширенішою при роботі з несбалансованими наборами даних?",
        options: [
          "Недостатня кількість ознак для навчання моделі",
          "Висока обчислювальна складність під час навчання",
          "Переобладнанність моделі на домінуючих класах",
          "Модель погано працює на меншинних класах"
        ],
        correct: 3,
        expA: "Кількість ознак не пов'язана з проблемою несбалансованості класів.",
        expB: "Несбалансованість класів не впливає безпосередньо на обчислювальну складність.",
        expC: "Переобладнанність може статися, але не є основною проблемою несбалансованих даних.",
        expD: "Точно! Моделі схильні погано класифікувати меншинні класи, оскільки вони недостатньо представлені в навчальних даних.",
        points: 1,
        chapter: "ML - Дані",
        difficulty: "K2"
      },
      {
        id: 64,
        text: "Що з наведеного найкраще описує метод валідації набору даних?",
        options: [
          "Перевірка відповідності формату та діапазонів значень",
          "Оцінка точності міток через експертну перевірку",
          "Аналіз статистичного розподілу ознак у наборі",
          "Виявлення дублікатів та викидів у даних"
        ],
        correct: 1,
        expA: "Перевірка формату важлива, але не охоплює якість змісту даних.",
        expB: "Правильно! Валідація набору даних в першу чергу стосується перевірки якості та точності міток експертами.",
        expC: "Статистичний аналіз корисний, але це скоріше частина дослідницького аналізу даних.",
        expD: "Виявлення дублікатів важливе, але це більше стосується очищення даних, ніж валідації.",
        points: 1,
        chapter: "ML - Дані",
        difficulty: "K2"
      },
      {
        id: 65,
        text: "Яка основна мета застосування методів аугментації даних?",
        options: [
          "Збільшення розміру навчального набору для покращення узагальнення",
          "Зменшення розмірності даних для прискорення навчання",
          "Видалення шумів та артефактів з вихідних даних", 
          "Перетворення даних у стандартизований формат"
        ],
        correct: 0,
        expA: "Саме так! Аугментація створює додаткові тренувальні приклади, що допомагає моделі краще узагальнювати на нових даних.",
        expB: "Аугментація збільшує, а не зменшує кількість даних, і не стосується зменшення розмірності.",
        expC: "Видалення шумів - це завдання препроцесингу, а не аугментації даних.",
        expD: "Стандартизація формату - це етап підготовки даних, не пов'язаний з аугментацією.",
        points: 1,
        chapter: "ML - Дані",
        difficulty: "K2"
      },
      {
        id: 66,
        text: "Що найкраще характеризує поняття \"дрейф даних\" в контексті ML?",
        options: [
          "Поступова зміна розподілу вхідних даних з часом",
          "Випадкові помилки у процесі збору даних",
          "Систематичні упередження в навчальному наборі",
          "Втрата даних через технічні збої системи"
        ],
        correct: 0,
        expA: "Правильно! Дрейф даних означає, що статистичні властивості даних змінюються з часом, що може погіршити продуктивність моделі.",
        expB: "Випадкові помилки - це шум у даних, а не дрейф.",
        expC: "Упередження - це систематична помилка, але не дрейф даних.",
        expD: "Втрата даних - це технічна проблема, не пов'язана з концепцією дрейфу.",
        points: 1,
        chapter: "ML - Дані",
        difficulty: "K2"
      },
      {
        id: 67,
        text: "Яке з наступних тверджень найточніше описує обмеження стратифікованої вибірки?",
        options: [
          "Не підходить для наборів даних з безперервними цільовими змінними",
          "Може не зберігати складні взаємозв'язки між ознаками",
          "Вимагає попереднього знання розподілу всіх ознак",
          "Не ефективна для великих наборів даних"
        ],
        correct: 1,
        expA: "Стратифікована вибірка призначена для категоріальних цілей, але це не є обмеженням.",
        expB: "Точно! Стратифікація зберігає пропорції класів, але може не врахувати складні кореляції між ознаками.",
        expC: "Стратифікація потребує знання тільки цільової змінної, а не всіх ознак.",
        expD: "Стратифікована вибірка добре масштабується для великих даних.",
        points: 1,
        chapter: "ML - Дані",
        difficulty: "K2"
      },
      {
        id: 68,
        text: "Що з наведеного є найкращим підходом до роботи з пропущеними значеннями в категоріальних ознаках?",
        options: [
          "Видалення всіх рядків з пропущеними значеннями",
          "Заповнення середнім значенням категорії",
          "Створення окремої категорії \"Невідомо\" для пропущених значень",
          "Використання лінійної інтерполяції для відновлення значень"
        ],
        correct: 2,
        expA: "Видалення рядків може призвести до втрати важливої інформації та зменшення розміру даних.",
        expB: "Поняття \"середнє\" не застосовується до категоріальних даних.",
        expC: "Правильно! Створення окремої категорії дозволяє зберегти інформацію про те, що значення було відсутнє.",
        expD: "Лінійна інтерполяція не має сенсу для категоріальних даних.",
        points: 1,
        chapter: "ML - Дані",
        difficulty: "K2"
      },
      {
        id: 69,
        text: "У якому сценарії найдоцільніше використовувати метод bootstrap sampling?",
        options: [
          "Коли потрібно зменшити розмір великого набору даних",
          "Коли необхідно створити кілька навчальних наборів з одного вихідного",
          "Коли потрібно видалити викиди з набору даних", 
          "Коли необхідно оцінити невизначеність прогнозів моделі"
        ],
        correct: 3,
        expA: "Bootstrap зазвичай не використовується для зменшення розміру даних.",
        expB: "Хоча bootstrap може створити кілька наборів, це не його основна мета.",
        expC: "Видалення викидів не є типовим застосуванням bootstrap.",
        expD: "Саме так! Bootstrap sampling дозволяє оцінити варіативність та невизначеність моделі через створення множинних вибірок.",
        points: 1,
        chapter: "ML - Дані",
        difficulty: "K2"
      },
      {
        id: 70,
        text: "Яка стратегія найкраще підходить для анонімізації персональних даних у ML-проектах?",
        options: [
          "Повне видалення всіх ідентифікаторів з набору даних",
          "Застосування k-anonymity з дискретизацією чутливих атрибутів",
          "Заміна реальних значень випадковими з того ж розподілу",
          "Використання хешування для всіх текстових полів"
        ],
        correct: 1,
        expA: "Видалення ідентифікаторів важливе, але недостатнє для повної анонімізації.",
        expB: "Правильно! K-anonymity забезпечує, що кожен запис неможливо відрізнити від принаймні k-1 інших записів.",
        expC: "Випадкова заміна може зруйнувати важливі закономірності в даних.",
        expD: "Хешування допомагає, але не забезпечує повної анонімізації чутливих атрибутів.",
        points: 1,
        chapter: "ML - Дані",
        difficulty: "K2"
      },
      {
        id: 71,
        text: "Команда розробляє рекомендаційну систему для e-commerce платформи. Які характеристики даних найважливіші для забезпечення якості рекомендацій?",
        options: [
          "Актуальність взаємодій користувачів та повнота профілів товарів",
          "Великий обсяг історичних даних та високошвидкісне оновлення",
          "Точна геолокація користувачів та детальна демографічна інформація",
          "Стандартизовані формати даних та відсутність дублікатів"
        ],
        correct: 0,
        expA: "Точно! Свіжі дані про поведінку та повні описи товарів критично важливі для релевантних рекомендацій.",
        expB: "Обсяг важливий, але актуальність та якість даних важливіші за кількість.",
        expC: "Геолокація корисна, але не настільки критична як поведінкові дані та характеристики товарів.",
        expD: "Технічна якість важлива, але не вирішує проблему релевантності рекомендацій.",
        points: 2,
        chapter: "ML - Дані", 
        difficulty: "K3"
      },
      {
        id: 72,
        text: "При підготовці даних для моделі прогнозування відтоку клієнтів, яка стратегія обробки часових ознак буде найефективнішою?",
        options: [
          "Видалення всіх часових міток для спрощення моделі",
          "Створення похідних ознак: тривалість, сезонність, тренди активності",
          "Перетворення всіх дат у числові значення timestamp",
          "Згрупування всіх подій по місяцях без деталізації"
        ],
        correct: 1,
        expA: "Видалення часових даних позбавить модель важливих патернів поведінки клієнтів.",
        expB: "Правильно! Інженерія ознак з часових даних створює значущі предиктори відтоку: частота використання, зміни в активності.",
        expC: "Прості timestamp не розкривають поведінкові патерни, важливі для прогнозування відтоку.",
        expD: "Місячне групування може втратити важливі короткострокові сигнали відтоку.",
        points: 2,
        chapter: "ML - Дані",
        difficulty: "K3"
      },
      {
        id: 73,
        text: "Аналізуючи набір даних для медичної діагностики, ви виявили значну несбалансованість класів. Яка комбінація методів буде найефективнішою?",
        options: [
          "Випадкова недовибірка мажоритарного класу та збільшення ваги меншинних класів",
          "SMOTE для генерації синтетичних зразків та стратифікована крос-валідація",
          "Видалення найскладніших зразків та використання ансамблевих методів",
          "Дублювання меншинних класів та застосування регуляризації"
        ],
        correct: 1,
        expA: "Недовибірка може призвести до втрати важливої інформації в медичних даних.",
        expB: "Відмінно! SMOTE створює якісні синтетичні зразки, а стратифікована валідація забезпечує надійну оцінку.",
        expC: "Видалення складних випадків може погіршити здатність моделі до діагностики важких випадків.",
        expD: "Просте дублювання створює переобладнанність, не вирішуючи основну проблему несбалансованості.",
        points: 2,
        chapter: "ML - Дані",
        difficulty: "K3"
      },
      {
        id: 74,
        text: "Команда створює модель для виявлення шахрайства в фінансових транзакціях. Яка стратегія відбору ознак буде найрезультативнішою?",
        options: [
          "Комбінація експертних знань предметної області та автоматичного відбору ознак",
          "Використання тільки статистичних методів відбору ознак",
          "Вибір ознак на основі кореляційного аналізу з цільовою змінною", 
          "Застосування методів зменшення розмірності без відбору ознак"
        ],
        correct: 0,
        expA: "Ідеально! Експертні знання про фінансове шахрайство плюс автоматичні методи дають найкращі результати.",
        expB: "Тільки статистичні методи можуть пропустити важливі домен-специфічні ознаки шахрайства.",
        expC: "Кореляційний аналіз може пропустити складні нелінійні патерни, характерні для шахрайства.",
        expD: "Зменшення розмірності може приховати важливі сигнали шахрайської активності.",
        points: 2,
        chapter: "ML - Дані",
        difficulty: "K3"
      },
      {
        id: 75,
        text: "При роботі з багатомовним набором текстових даних для класифікації настроїв, яка стратегія підготовки даних забезпечить найкращу продуктивність?",
        options: [
          "Переклад всіх текстів на одну мову та стандартна обробка",
          "Створення окремих моделей для кожної мови з специфічною обробкою",
          "Використання багатомовних ембедингів з уніфікованою обробкою",
          "Видалення мовно-специфічних ознак та фокус на універсальних патернах"
        ],
        correct: 3,
        expA: "Переклад може втратити культурні нюанси та емоційну забарвленість тексту.",
        expB: "Окремі моделі працюють, але потребують більше ресурсів та можуть втратити переваги багатомовного навчання.",
        expC: "Багатомовні ембединги корисні, але уніфікована обробка може не врахувати мовні особливості.",
        expD: "Правильно! Фокус на універсальних емоційних патернах при збереженні мовної специфіки дає найкращі результати.",
        points: 2,
        chapter: "ML - Дані",
        difficulty: "K3"
      },
      {
        id: 76,
        text: "Розробляючи систему контролю якості для виробничої лінії, як найкраще структурувати дані для ефективного навчання моделі аномалій?",
        options: [
          "Зосередження на збиранні великої кількості аномальних прикладів",
          "Створення збалансованого набору нормальних та аномальних зразків",
          "Акцент на якісних нормальних даних з детальним описом процесу",
          "Рівномірний розподіл між всіма типами можливих дефектів"
        ],
        correct: 2,
        expA: "Аномальні приклади важливі, але їх природна рідкість робить цей підхід непрактичним.",
        expB: "Штучна збалансованість може не відобразити реальний розподіл аномалій у виробництві.",
        expC: "Саме так! Якісні нормальні дані з контекстом процесу дозволяють моделі краще розуміти, що є відхиленням.",
        expD: "Рівномірний розподіл дефектів не відповідає реальним виробничим умовам.",
        points: 2,
        chapter: "ML - Дані",
        difficulty: "K3"
      },
      {
        id: 77,
        text: "Медична установа розробляє AI систему для діагностики, але виявляє систематичні упередження в історичних даних пацієнтів. Яка комплексна стратегія найкраще вирішить цю проблему?",
        options: [
          "Збалансування демографічних груп, аудит упереджень та етична валідація експертами",
          "Збільшення розміру набору даних для статистичного нівелювання упереджень",
          "Використання алгоритмів fair ML без модифікації вихідних даних",
          "Зосередження на технічній точності моделі незалежно від упереджень"
        ],
        correct: 0,
        expA: "Відмінно! Комплексний підхід: збалансовані дані + технічний аудит + етична експертиза забезпечує справедливість.",
        expB: "Більше даних не усуває систематичні упередження, може навіть їх посилити.",
        expC: "Fair ML алгоритми допомагають, але не замінюють якісну підготовку даних.",
        expD: "Ігнорування упереджень у медицині може призвести до дискримінації та погіршення лікування.",
        points: 3,
        chapter: "ML - Дані",
        difficulty: "K4"
      },
      {
        id: 78,
        text: "Компанія збирає дані з різних джерел для створення мультимодальної AI системи. Яка стратегія забезпечення якості найефективніша для такої складності?",
        options: [
          "Стандартизація всіх типів даних до єдиного формату представлення",
          "Багаторівневий консенсус з динамічним скорингом та зворотним зв'язком",
          "Створення окремих пайплайнів валідації для кожної модальності",
          "Використання експертних панелей для перевірки якості кожного джерела"
        ],
        correct: 1,
        expA: "Стандартизація може втратити унікальні характеристики різних модальностей.",
        expB: "Правильно! Багаторівневий консенсус з динамічним скорингом вирішує як вимірювання якості, так і покращення анотаторів.",
        expC: "ML фільтри якості допомагають ідентифікувати проблеми, але не вирішують корінні причини розбіжностей анотаторів.",
        expD: "Експертні панелі забезпечують нагляд, але можуть не масштабуватися ефективно або покращувати індивідуальну продуктивність анотаторів.",
        points: 3,
        chapter: "ML - Дані",
        difficulty: "K4"
      },
      {
        id: 79,
        text: "Створюючи автономну систему, що інтегрує дані сенсорів, камер та ліара, яка архітектура забезпечить найкращу адаптивність до змінних умов?",
        options: [
          "Адаптивна мультимодальна архітектура з контекстно-залежним злиттям",
          "Централізована система зі статичними вагами для кожної модальності",
          "Ієрархічна обробка з фіксованим пріоритетом джерел даних",
          "Розподілена система з незалежною обробкою кожної модальності"
        ],
        correct: 0,
        expA: "Відмінно! Адаптивна архітектура може динамічно змінювати стратегії злиття залежно від умов: погода, освітлення, технічні несправності.",
        expB: "Статичні ваги не можуть адаптуватися до змінних умов як погода або несправності сенсорів.",
        expC: "Фіксовані пріоритети не враховують динамічні зміни в надійності різних джерел даних.",
        expD: "Незалежна обробка втрачає переваги синергії між різними типами сенсорних даних.",
        points: 3,
        chapter: "ML - Дані",
        difficulty: "K4"
      },
      {
        id: 80,
        text: "При розробці платформи для анотації даних з тисячами учасників, яка система забезпечить найвищу якість при мінімальних витратах?",
        options: [
          "Система стимулювання з бонусами за швидкість анотації",
          "Експертні панелі для перевірки кожної анотації",  
          "Багаторівневий консенсус з алгоритмами динамічного скорингу та системою зворотного зв'язку",
          "ML фільтри для автоматичного виявлення неякісних анотацій"
        ],
        correct: 2,
        expA: "Стимулювання швидкості може погіршити якість анотацій та не вирішує проблеми методології консенсусу.",
        expB: "Експертні панелі забезпечують нагляд, але можуть не масштабуватися ефективно або покращувати індивідуальну продуктивність анотаторів.",
        expC: "Ідеально! Багаторівневий консенсус з динамічним скорингом та зворотним зв'язком вирішує як вимірювання якості, так і системне покращення анотаторів.",
        expD: "ML фільтри якості допомагають виявляти проблеми, але не вирішують корінні причини розбіжностей анотаторів.",
        points: 3,
        chapter: "ML - Дані", 
        difficulty: "K4"
      },
      {
        id: 81,
        text: "Яка з наведених метрик вимірює частку фактичних позитивних випадків, що були правильно ідентифіковані?",
        options: [
          "Точність (Precision)",
          "Повнота (Recall)", 
          "Загальна точність (Accuracy)",
          "F1-метрика (F1-score)"
        ],
        correct: 1,
        expA: "Точність вимірює, скільки з прогнозованих позитивних випадків були насправді правильними, а не скільки фактичних позитивних було знайдено.",
        expB: "Саме так! Повнота вимірює частку фактичних позитивних випадків, які були правильно ідентифіковані моделлю.",
        expC: "Загальна точність вимірює загальну правильність по всіх класах, а не конкретно ідентифікацію позитивних випадків.",
        expD: "F1-метрика поєднує точність і повноту, але не вимірює конкретно рівень ідентифікації фактичних позитивних випадків.",
        points: 1,
        chapter: "Метрики функціональної продуктивності ML", 
        difficulty: "K1"
      },
      {
        id: 82,
        text: "Яке з наведених тверджень ПРАВИЛЬНЕ щодо матриці плутанини?",
        options: [
          "Вона показує тільки метрики загальної точності",
          "Вона відображає прогнозовані класифікації проти фактичних",
          "Вона вимірює значення точності та повноти", 
          "Вона автоматично розраховує F1-метрику"
        ],
        correct: 1,
        expA: "Матриці плутанини показують результати класифікації, а не тільки розрахунки загальної точності.",
        expB: "Правильно! Матриця плутанини відображає, як прогнозовані класифікації співвідносяться з фактичними класифікаціями.",
        expC: "Хоча точність і повноту можна розрахувати з неї, сама матриця показує кількості класифікацій.",
        expD: "F1-метрики розраховуються з даних матриці плутанини, але не відображаються автоматично.",
        points: 1,
        chapter: "Метрики функціональної продуктивності ML",
        difficulty: "K1"
      },
      {
        id: 83,
        text: "Яка з наведених метрик НАЙБІЛЬШЕ підходить для регресійних моделей?",
        options: [
          "Точність (Precision)",
          "Повнота (Recall)", 
          "Середньоквадратична помилка (MSE)",
          "F1-метрика (F1-score)"
        ],
        correct: 2,
        expA: "Точність є метрикою класифікації, що використовується для категоріальних прогнозів, а не регресії.",
        expB: "Повнота також є метрикою класифікації, не застосовною до задач регресії.",
        expC: "Правильно! Середньоквадратична помилка (MSE) вимірює, наскільки добре регресійні моделі підходять до фактичних точок даних.", 
        expD: "F1-метрика поєднує точність і повноту для класифікації, а не для задач регресії.",
        points: 1,
        chapter: "Метрики функціональної продуктивності ML",
        difficulty: "K2"
      },
      {
        id: 84,
        text: "Яке з наведених є обмеженням метрик функціональної продуктивності ML?",
        options: [
          "Вони вимірюють тільки функціональність моделі",
          "Вони вимірюють всі характеристики якості", 
          "Вони працюють з немаркованими даними",
          "Вони замінюють системне тестування"
        ],
        correct: 0,
        expA: "Абсолютно правильно! Ці метрики вимірюють тільки функціональність, а не інші характеристики якості як продуктивність або пояснюваність.",
        expB: "Насправді, метрики функціональної продуктивності ML обмежені і не вимірюють усі характеристики якості як пояснюваність.",
        expC: "Більшість метрик функціональної продуктивності ML потребують маркованих даних для оцінки навчання з учителем.",
        expD: "Ці метрики доповнюють, але не замінюють комплексні підходи до системного тестування.",
        points: 1,
        chapter: "Метрики функціональної продуктивності ML", 
        difficulty: "K2"
      },
      {
        id: 85,
        text: "Яке з наведених тверджень про ROC-криві ПРАВИЛЬНЕ?",
        options: [
          "Вони відображають точність проти повноти",
          "Вони відображають істинно позитивний рівень проти хибно позитивного рівня",
          "Вони показують тільки продуктивність кластеризації",
          "Вони вимірюють точність регресії"
        ],
        correct: 1,
        expA: "ROC-криві не відображають точність проти повноти - це була б крива точність-повнота.",
        expB: "Правильно! ROC-криві відображають істинно позитивний рівень (повноту) проти хибно позитивного рівня для бінарної класифікації.",
        expC: "ROC-криві призначені для бінарної класифікації, а не для оцінки продуктивності кластеризації.", 
        expD: "ROC-криві призначені для задач класифікації, а не для вимірювання точності регресії.",
        points: 1,
        chapter: "Метрики функціональної продуктивності ML",
        difficulty: "K2"
      },
      {
        id: 86,
        text: "Яка з наведених метрик має діапазон від -1 до +1 для оцінки кластеризації?",
        options: [
          "Загальна точність",
          "Точність",
          "Коефіцієнт силуету", 
          "Середньоквадратична помилка"
        ],
        correct: 2,
        expA: "Загальна точність зазвичай має діапазон від 0 до 1 (або від 0% до 100%), а не від -1 до +1.",
        expB: "Точність також має діапазон від 0 до 1, вимірюючи точність позитивних прогнозів.",
        expC: "Правильно! Коефіцієнт силуету має діапазон від -1 до +1, вимірюючи якість розділення кластерів.",
        expD: "MSE завжди позитивна і не має верхньої межі, використовується для оцінки регресії.",
        points: 1,
        chapter: "Метрики функціональної продуктивності ML",
        difficulty: "K2"
      },
      {
        id: 87,
        text: "Що є НАЙВАЖЛИВІШИМ при роботі з несбалансованими наборами даних?",
        options: [
          "Моніторинг загальної точності по всіх класах",
          "Фокус на точності та повноті меншинного класу",
          "Балансування компромісу точність-повнота рівномірно", 
          "Зважування метрик за пропорціями розподілу класів"
        ],
        correct: 1,
        expA: "Загальна точність може бути оманливою з несбалансованими наборами даних, оскільки переважає мажоритарний клас.",
        expB: "Правильно! З несбалансованими даними точність і повнота меншинного класу надають критичні уявлення про рідкісні, але важливі випадки.",
        expC: "Рівномірний баланс може бути неприйнятним, коли один клас набагато критичніший за інші.",
        expD: "Зважені за класами метрики допомагають, але все ще можуть пропустити критичні проблеми продуктивності меншинного класу.",
        points: 1,
        chapter: "Метрики функціональної продуктивності ML",
        difficulty: "K2"
      },
      {
        id: 88,
        text: "Медична діагностична AI система повинна мінімізувати пропущені виявлення раку. Який підхід НАЙБІЛЬШ доречний?",
        options: [
          "Оптимізувати для високої чутливості з прийнятними порогами специфічності",
          "Збалансувати витрати хибно позитивних з вимогами діагностичної точності", 
          "Застосувати підхід, орієнтований на точність, з регуляторною відповідністю",
          "Застосувати метрики, скориговані на ризик, на основі класифікацій тяжкості захворювання"
        ],
        correct: 0,
        expA: "Відмінно! Висока чутливість (повнота) забезпечує мінімум пропущених випадків раку, що критично важливо для безпеки пацієнтів навіть з деякими хибно позитивними результатами.",
        expB: "Хоча баланс витрат важливий, мінімізація пропущених випадків раку має пріоритет у медичній діагностиці.",
        expC: "Фокус на точності може збільшити пропущені випадки раку, що неприйнятно в медичній діагностиці.",
        expD: "Коригування ризику цінне, але не вирішує безпосередньо вимогу мінімізації пропущених випадків.",
        points: 1,
        chapter: "Метрики функціональної продуктивності ML",
        difficulty: "K2"
      },
      {
        id: 89,
        text: "Який сценарій НАЙКРАЩЕ демонструє, коли R-квадрат була б переважною метрикою?",
        options: [
          "Бінарна класифікація зі збалансованими класами",
          "Багатокласова класифікація з багатьма категоріями",
          "Регресійний аналіз, що вимірює пояснену варіативність",
          "Валідація кластеризації з невідомими групами"
        ],
        correct: 2,
        expA: "R-квадрат не використовується для задач класифікації - точність і повнота були б більш доречними.",
        expB: "Багатокласова класифікація використовує метрики як загальна точність або F1-метрика, а не R-квадрат.",
        expC: "Правильно! R-квадрат ідеально підходить для регресійного аналізу, показуючи, скільки варіативності пояснює модель.",
        expD: "Кластеризація використовує метрики як коефіцієнт силуету, а не R-квадрат для валідації.",
        points: 2,
        chapter: "Метрики функціональної продуктивності ML",
        difficulty: "K3"
      },
      {
        id: 90,
        text: "Система виявлення зображень показує високу точність на тренувальних даних, але погану продуктивність на валідаційних. Який підхід НАЙКРАЩИЙ?",
        options: [
          "Адаптивне навчання домену з техніками регуляризації та крос-валідацією",
          "Збільшення складності моделі для кращого охоплення патернів",
          "Зменшення розміру тренувального набору для простішого навчання",
          "Застосування ансамблевих методів без регуляризації"
        ],
        correct: 0,
        expA: "Відмінно! Адаптивне навчання домену з регуляризацією вирішує переобладнанність і покращує узагальнення на нових даних.",
        expB: "Збільшення складності може погіршити переобладнанність, а не вирішити проблему узагальнення.",
        expC: "Менше тренувальних даних може погіршити здатність моделі вивчати важливі патерни.",
        expD: "Ансамблеві методи додають складність, але можуть не вирішити фундаментальну проблему чутливості до освітлення.",
        points: 2,
        chapter: "Метрики функціональної продуктивності ML",
        difficulty: "K3"
      },
      {
        id: 91,
        text: "Команда розробляє модель класифікації для медичної діагностики з різними типами захворювань. Який підхід до оцінки метрик НАЙЕФЕКТИВНІШИЙ?",
        options: [
          "Комплексна система оцінки справедливості з клінічною валідацією безпеки",
          "Окрема оцінка продуктивності для кожної демографічної групи з незалежними порогами",
          "Зважені метрики точності, що пріоритезують популяції високого ризику над іншими",
          "Тестування регуляторної відповідності зі стандартизованими клінічними бенчмарками продуктивності"
        ],
        correct: 0,
        expA: "Правильно! Комплексна оцінка справедливості з клінічною валідацією безпеки забезпечує як продуктивність, так і справедливість між усіма групами пацієнтів при збереженні стандартів безпеки.",
        expB: "Окремі оцінки допомагають, але можуть пропустити системні упередження і не забезпечують загальної справедливості.",
        expC: "Зважені метрики допомагають пріоритезувати, але можуть компрометувати якість догляду для непріоритезованих груп.",
        expD: "Регуляторна відповідність важлива, але може не вирішувати питання справедливості та демографічної рівності комплексно.",
        points: 2,
        chapter: "Метрики функціональної продуктивності ML",
        difficulty: "K3"
      },
      {
        id: 92,
        text: "Регресійна модель показує R-квадрат 0,85 та MSE 4,2. Яка інтерпретація НАЙТОЧНІША?",
        options: [
          "Модель пояснює 85% варіативності з розумною помилкою прогнозування",
          "Модель має 85% точність в задачах класифікації",
          "Модель потребує додаткового навчання для покращення продуктивності",
          "Ознаки недостатньо інформативні для прогнозування"
        ],
        correct: 0,
        expA: "Правильно! R-квадрат 0,85 означає, що пояснено 85% варіативності, а MSE 4,2 вказує на розумну помилку прогнозування.",
        expB: "R-квадрат не те ж саме, що точність - він вимірює, наскільки добре модель пояснює варіативність в регресії.",
        expC: "Ці метрики насправді вказують на те, що модель працює добре, а не що потрібно більше навчання.",
        expD: "Сильний R-квадрат вказує на те, що ознаки насправді досить інформативні для прогнозування.",
        points: 2,
        chapter: "Метрики функціональної продуктивності ML",
        difficulty: "K3"
      },
      {
        id: 93,
        text: "Спам-фільтр електронної пошти має високу точність, але низьку повноту. Яке наслідок НАЙЙМОВІРНІШИЙ?",
        options: [
          "Занадто багато законних листів позначено як спам",
          "Фільтр повільно обробляє електронні листи",
          "Модель використовує занадто багато пам'яті",
          "Занадто багато спам-листів потрапляє до вхідної пошти"
        ],
        correct: 3,
        expA: "Висока точність означає мало хибно позитивних результатів, тому законні листи не позначаються неправильно як спам.",
        expB: "Швидкість обробки не пов'язана з метриками точності та повноти.",
        expC: "Використання пам'яті не пов'язане з цими метриками функціональної продуктивності.",
        expD: "Правильно! Низька повнота означає, що багато фактичних спам-листів не виявляються і потрапляють до вхідної пошти (хибно негативні).",
        points: 2,
        chapter: "Метрики функціональної продуктивності ML",
        difficulty: "K3"
      },
      {
        id: 94,
        text: "Яке з наведених тверджень про розрахунок F1-метрики ПРАВИЛЬНЕ?",
        options: [
          "Використовується простий середній точності та повноти",
          "Використовується гармонічний середній точності та повноти",
          "Використовуються тільки значення точності",
          "Використовуються тільки значення повноти"
        ],
        correct: 1,
        expA: "F1-метрика не використовує простий середній - це дало б однакову вагу незалежно від значень.",
        expB: "Правильно! F1-метрика використовує гармонічний середній, який надає більшу вагу нижчим значенням між точністю та повнотою.",
        expC: "F1-метрика поєднує як точність, так і повноту, а не тільки точність окремо.",
        expD: "F1-метрика поєднує як точність, так і повноту, а не тільки повноту окремо.",
        points: 2,
        chapter: "Метрики функціональної продуктивності ML",
        difficulty: "K3"
      },
      {
        id: 95,
        text: "Бінарний класифікатор показує AUC = 0,92. Яке твердження НАЙКРАЩЕ описує продуктивність моделі?",
        options: [
          "Модель має погану здатність розрізнення",
          "Модель вгадує випадково",
          "Модель переобладнана",
          "Модель має відмінну здатність розрізнення"
        ],
        correct: 3,
        expA: "AUC 0,92 дуже високий, що вказує на відмінне розрізнення, а не погану продуктивність.",
        expB: "Випадкове вгадування дало б AUC близько 0,5, а не 0,92.",
        expC: "Високий AUC вказує на хорошу продуктивність, але нам потрібна додаткова інформація для визначення переобладнання.",
        expD: "Абсолютно правильно! AUC 0,92 вказує на відмінну здатність розрізняти між позитивними та негативними класами.",
        points: 2,
        chapter: "Метрики функціональної продуктивності ML",
        difficulty: "K3"
      },
      {
        id: 96,
        text: "Фінансова система виявлення шахрайства вимагає мінімізації хибно негативних результатів при управлінні операційними витратами. Яка стратегія НАЙЕФЕКТИВНІША?",
        options: [
          "Впровадити високо-повнотну систему з багаторівневими робочими процесами розслідування",
          "Розгорнути оптимізовану за точністю систему з автоматичною фільтрацією хибно позитивних",
          "Створити збалансований підхід точності з скоригованими на ризик порогами рішень", 
          "Встановити навчання, чутливе до витрат, з динамічним зважуванням типів шахрайства"
        ],
        correct: 0,
        expA: "Правильно! Високо-повнотна система забезпечує мінімум пропущеного шахрайства, а багаторівневі робочі процеси ефективно управляють витратами розслідування.",
        expB: "Оптимізація точності може пропустити випадки шахрайства, що коштовно у фінансових застосуваннях.",
        expC: "Збалансована точність може не пріоритезувати критичну вимогу мінімізації хибно негативних результатів.",
        expD: "Навчання, чутливе до витрат, допомагає, але може не вирішувати безпосередньо вимогу мінімізації хибно негативних результатів.",
        points: 3,
        chapter: "Метрики функціональної продуктивності ML",
        difficulty: "K4"
      },
      {
        id: 97,
        text: "Який підхід НАЙКРАЩИЙ для справедливого порівняння різних ML алгоритмів?",
        options: [
          "Використовувати різні набори даних для кожного алгоритму",
          "Порівнювати тільки метрики точності",
          "Використовувати бенчмарк-набори зі стандартизованими метриками", 
          "Тестувати тільки на продакшн даних"
        ],
        correct: 2,
        expA: "Використання різних наборів даних зробило б порівняння несправедливим і результати незіставними між алгоритмами.",
        expB: "Тільки точність може не охопити повну картину продуктивності для різних алгоритмів.",
        expC: "Відмінний вибір! Бенчмарк-набори забезпечують стандартизовані набори даних та метрики для справедливої, порівнюваної оцінки алгоритмів.",
        expD: "Тільки продакшн дані можуть бути упередженими і не забезпечують контрольованої оцінки, необхідної для справедливого порівняння.",
        points: 3,
        chapter: "Метрики функціональної продуктивності ML",
        difficulty: "K4"
      },
      {
        id: 98,
        text: "Рекомендаційна система показує високу точність у тестуванні, але погану задоволеність користувачів у продакшні. Яке обмеження метрик функціональної продуктивності ML це НАЙКРАЩЕ ілюструє?",
        options: [
          "Метрики потребують маркованих даних",
          "Метрики не вимірюють нефункціональні характеристики",
          "Метрики обчислювально затратні",
          "Метрики працюють тільки з великими наборами даних"
        ],
        correct: 1,
        expA: "Хоча це обмеження, воно не пояснює розрив між тестовою точністю та задоволеністю користувачів.",
        expB: "Саме так! Розрив показує, що функціональні метрики не охоплюють нефункціональні характеристики як користувацький досвід, релевантність або зручність системи, що впливають на задоволеність у реальному світі.",
        expC: "Обчислювальні витрати не є проблемою, що спричиняє проблеми задоволеності користувачів.",
        expD: "Розмір набору даних не є проблемою - питання в тому, що функціональні метрики пропускають аспекти користувацького досвіду.",
        points: 3,
        chapter: "Метрики функціональної продуктивності ML",
        difficulty: "K4"
      },
      {
        id: 99,
        text: "Медична AI система вимагає балансу діагностичної точності з безпекою пацієнтів між різними демографічними групами. Яка система оцінки НАЙКОМПЛЕКСНІША?",
        options: [
          "Впровадити багатовимірну оцінку справедливості з клінічною валідацією безпеки для демографічних груп пацієнтів",
          "Розгорнути окрему оцінку продуктивності для кожної демографічної групи з незалежними порогами",
          "Створити зважені метрики точності, що пріоритезують популяції високого ризику над іншими",
          "Встановити тестування регуляторної відповідності зі стандартизованими клінічними бенчмарками продуктивності"
        ],
        correct: 0,
        expA: "Правильно! Багатовимірна справедливість з клінічною валідацією безпеки забезпечує як продуктивність, так і справедливість між усіма групами пацієнтів при збереженні стандартів безпеки.",
        expB: "Окремі оцінки допомагають, але можуть пропустити системні упередження і не забезпечують загальної справедливості.",
        expC: "Зважені метрики допомагають пріоритезувати, але можуть скомпрометувати якість догляду для непріоритезованих груп.",
        expD: "Регуляторна відповідність важлива, але може не вирішувати питання справедливості та демографічної рівності комплексно.",
        points: 3,
        chapter: "Метрики функціональної продуктивності ML",
        difficulty: "K4"
      },
      {
        id: 100,
        text: "Система автономного водіння вимагає метрики, що балансують множинні критично важливі для безпеки аспекти продуктивності в різних умовах. Який підхід забезпечує НАЙСТІЙКІШУ систему оцінки?",
        options: [
          "Впровадити адаптивну багатокритеріальну оцінку продуктивності з контекстно-залежною валідацією безпеки",
          "Розгорнути єдину комплексну метрику, що поєднує всі аспекти продуктивності з однаковим зважуванням",
          "Створити сценарно-специфічні протоколи оцінки з незалежною валідацією порогів безпеки",
          "Встановити безперервний моніторинг продуктивності з реальночасним коригуванням критеріїв оцінки"
        ],
        correct: 0,
        expA: "Відмінно! Адаптивна багатокритеріальна оцінка з контекстно-залежною валідацією справляється зі складністю різних умов при збереженні фокусу на безпеці.",
        expB: "Єдині метрики можуть пропустити критичні аспекти продуктивності і не адаптуються до різних критично важливих для безпеки сценаріїв.",
        expC: "Сценарно-специфічні протоколи допомагають, але можуть пропустити взаємодії між різними умовами та аспектами безпеки.",
        expD: "Безперервний моніторинг цінний для продакшну, але не встановлює комплексну систему оцінки перед розгортанням.",
        points: 3,
        chapter: "Метрики функціональної продуктивності ML",
        difficulty: "K4"
      },
      {
        id: 101,
        text: "Яка з наступних НАЙКРАЩЕ описує переваги глибоких нейронних мереж порівняно з традиційними методами? Виберіть ОДИН варіант.",
        options: [
          "Автоматичне вивчення складних ознак з мінімальним проектуванням вручну",
          "Повна інтерпретованість усіх рівнів абстракції в мережі",
          "Гарантована збіжність до глобального оптимуму під час навчання",
          "Простота налаштування гіперпараметрів для всіх типів даних"
        ],
        correct: 0,
        expA: "Саме так! Глибокі нейронні мережі можуть автоматично виявляти складні закономірності без потреби в ручному проектуванні ознак.",
        expB: "Глибокі мережі часто описують як 'чорні скриньки' через складність інтерпретації внутрішніх представлень.",
        expC: "Навчання глибоких мереж зазвичай призводить до локальних оптимумів, а не до глобальних.",
        expD: "Налаштування гіперпараметрів глибоких мереж може бути доволі складним і потребує експертних знань.",
        points: 1,
        chapter: "МН - Нейронні мережі та тестування",
        difficulty: "K1"
      },
      {
        id: 102,
        text: "Що з наступного НАЙКРАЩЕ описує основну функцію функції активації в нейронній мережі? Виберіть ОДИН варіант.",
        options: [
          "Регулювання швидкості навчання під час зворотного поширення помилки",
          "Управління розміром пакетів даних для навчання мережі",
          "Введення нелінійності для дозволу складного відображення входів на виходи",
          "Збереження градієнтів від зникнення в глибоких архітектурах"
        ],
        correct: 2,
        expA: "Швидкість навчання контролюється оптимізатором, а не функцією активації.",
        expB: "Розмір пакетів визначається під час підготовки даних, а не функцією активації.",
        expC: "Правильно! Функції активації дають змогу мережам вивчати складні нелінійні закономірності.",
        expD: "Деякі функції активації допомагають із зникаючими градієнтами, але це не їхня основна функція.",
        points: 1,
        chapter: "МН - Нейронні мережі та тестування",
        difficulty: "K1"
      },
      {
        id: 103,
        text: "Яка з наступних метрик НАЙКРАЩЕ для оцінки активації нейронів у прихованих шарах? Виберіть ОДИН варіант.",
        options: [
          "Аналіз розподілу активації з візуалізацією гістограм",
          "Середня абсолютна похибка між прогнозованими та фактичними значеннями",
          "F1-міра для оцінки балансу точності та повноти",
          "Площа під ROC-кривою для бінарної класифікації"
        ],
        correct: 0,
        expA: "Відмінно! Розподіл активації показує, як нейрони реагують на різні входи та чи функціонують вони належним чином.",
        expB: "MAE оцінює передбачення на виході, а не активацію прихованих нейронів.",
        expC: "F1-міра оцінює якість передбачень моделі, а не внутрішню активацію нейронів.",
        expD: "AUC-ROC оцінює продуктивність класифікації, а не активацію окремих нейронів.",
        points: 2,
        chapter: "МН - Нейронні мережі та тестування",
        difficulty: "K2"
      },
      {
        id: 104,
        text: "Яка з наступних стратегій НАЙЕФЕКТИВНІША для тестування стійкості нейронних мереж до шуму? Виберіть ОДИН варіант.",
        options: [
          "Використання лише валідаційного набору із високоякісними даними",
          "Застосування методів регуляризації під час навчання моделі",
          "Створення спектра зашумлених версій тестових даних",
          "Зменшення складності архітектури для спрощення моделі"
        ],
        correct: 3,
        expA: "Високоякісні дані не демонструють стійкість до реальних зашумлених умов.",
        expB: "Регуляризація допомагає під час навчання, але не тестує стійкість до шуму.",
        expC: "Спектр шуму показує межі стійкості, але не найефективніший для систематичного тестування.",
        expD: "Саме так! Систематичне тестування із контрольованим шумом різного рівня оцінює межі стійкості.",
        points: 2,
        chapter: "МН - Нейронні мережі та тестування",
        difficulty: "K2"
      },
      {
        id: 105,
        text: "Що з наступного НАЙВАЖЛИВІШЕ під час тестування згорткових нейронних мереж на обертання зображень? Виберіть ОДИН варіант.",
        options: [
          "Перевірка збереження точності розпізнавання незалежно від орієнтації",
          "Вимірювання зміни швидкості обробки для повернутих зображень",
          "Аналіз впливу обертання на розмір файлу зображення",
          "Оцінка зменшення пам'яті моделі при обробці повернутих даних"
        ],
        correct: 0,
        expA: "Правильно! Інваріантність до обертання - це критична властивість для надійного розпізнавання зображень.",
        expB: "Швидкість обробки важлива, але точність розпізнавання має пріоритет для функціонального тестування.",
        expC: "Розмір файлу зображення не пов'язаний із функціональним тестуванням CNN.",
        expD: "Використання пам'яті моделлю зазвичай не змінюється від орієнтації вхідних зображень.",
        points: 2,
        chapter: "МН - Нейронні мережі та тестування",
        difficulty: "K2"
      },
      {
        id: 106,
        text: "Яка з наступних стратегій НАЙЕФЕКТИВНІША для валідації архітектури глибокої мережі? Виберіть ОДИН варіант.",
        options: [
          "Тестування лише на наборах даних, що використовувались для навчання",
          "Порівняння із простими базовими моделями на різних наборах даних",
          "Фокусування виключно на метриках швидкості навчання та збіжності",
          "Використання лише синтетичних даних для контрольованого тестування"
        ],
        correct: 2,
        expA: "Тестування лише на навчальних даних призведе до переоцінки через перенавчання.",
        expB: "Саме так! Порівняння із базовими моделями на різних даних демонструє реальну цінність архітектури.",
        expC: "Метрики навчання важливі, але не показують реальну ефективність на нових даних.",
        expD: "Лише синтетичні дані можуть не відображати складність реальних сценаріїв використання.",
        points: 2,
        chapter: "МН - Нейронні мережі та тестування",
        difficulty: "K2"
      },
      {
        id: 107,
        text: "Що з наступного НАЙКРИТИЧНІШЕ для тестування рекурентних нейронних мереж? Виберіть ОДИН варіант.",
        options: [
          "Валідація здатності обробляти послідовності різної довжини",
          "Перевірка симетричності вагових матриць у всіх шарах",
          "Забезпечення однакової кількості нейронів у кожному часовому кроці",
          "Гарантування використання лише фіксованих розмірів вхідних векторів"
        ],
        correct: 2,
        expA: "Правильно! RNN розроблені для послідовностей, тому здатність обробляти різні довжини є критичною.",
        expB: "Симетричність вагів не є вимогою для RNN архітектур.",
        expC: "RNN можуть мати різну кількість нейронів у різних шарах.",
        expD: "RNN можуть обробляти різні розміри вхідних векторів залежно від застосування.",
        points: 2,
        chapter: "МН - Нейронні мережі та тестування",
        difficulty: "K2"
      },
      {
        id: 108,
        text: "Яка з наступних архітектур НАЙКРАЩА для тестування обробки зображень високої роздільної здатності? Виберіть ОДИН варіант.",
        options: [
          "U-Net із пропусковими з'єднаннями для збереження просторових деталей",
          "ResNet із залишковими з'єднаннями для глибокого навчання ознак",
          "LSTM мережі для послідовної обробки пікселів зображення",
          "Автокодувальник із вузьким місцем для стиснення зображень"
        ],
        correct: 3,
        expA: "Правильно! U-Net спеціально розроблена для завдань, що потребують збереження просторових деталей.",
        expB: "ResNet чудова для класифікації, але може втрачати просторові деталі у високій роздільній здатності.",
        expC: "LSTM не підходять для просторової обробки зображень високої роздільної здатності.",
        expD: "Автокодувальники зазвичай зменшують роздільну здатність у вузькому місці.",
        points: 2,
        chapter: "МН - Нейронні мережі та тестування",
        difficulty: "K2"
      },
      {
        id: 109,
        text: "Що з наступного НАЙЕФЕКТИВНІШЕ для тестування трансферного навчання в нейронних мережах? Виберіть ОДИН варіант.",
        options: [
          "Використання лише невеликих наборів даних для швидкого тестування",
          "Порівняння навчання з нуля із предобученими моделями на цільових завданнях",
          "Фокусування виключно на архітектурах, що показали найкращі результати",
          "Тестування лише на завданнях, подібних до вихідного домену"
        ],
        correct: 2,
        expA: "Невеликі набори даних можуть не показати справжню ефективність трансферного навчання.",
        expB: "Саме так! Порівняння показує, наскільки ефективно предобучена модель прискорює навчання нового завдання.",
        expC: "Тестування різних архітектур дає краще розуміння загальності трансферного навчання.",
        expD: "Тестування на різних доменах показує справжню цінність трансферного навчання.",
        points: 2,
        chapter: "МН - Нейронні мережі та тестування",
        difficulty: "K2"
      },
      {
        id: 110,
        text: "Яка з наступних стратегій НАЙКОМПЛЕКСНІША для тестування покриття нейронних мереж? Виберіть ОДИН варіант.",
        options: [
          "Комбінація покриття нейронів, межових умов та активаційних патернів",
          "Використання лише метрик покриття нейронів для спрощення процесу",
          "Фокусування виключно на покритті ребер між шарами мережі",
          "Застосування традиційних метрик покриття коду до архітектури мережі"
        ],
        correct: 0,
        expA: "Відмінно! Комплексний підхід забезпечує всебічне тестування різних аспектів нейронної мережі.",
        expB: "Лише покриття нейронів не враховує складні взаємодії та межові випадки.",
        expC: "Покриття ребер важливе, але недостатнє для повного розуміння поведінки мережі.",
        expD: "Традиційні метрики покриття не підходять для складної архітектури нейронних мереж.",
        points: 2,
        chapter: "МН - Нейронні мережі та тестування",
        difficulty: "K2"
      },
      {
        id: 111,
        text: "Яка з наступних стратегій НАЙЕФЕКТИВНІША для тестування стійкості CNN до геометричних трансформацій? Виберіть ОДИН варіант.",
        options: [
          "Систематичне тестування із прогресивними рівнями трансформації та метриками деградації",
          "Випадкове застосування трансформацій без вимірювання впливу на точність",
          "Використання лише одного типу трансформації за раз для ізольованого аналізу",
          "Тестування трансформацій лише на валідаційному наборі без тренувальних даних"
        ],
        correct: 0,
        expA: "Правильно! Систематичний підхід із прогресивними рівнями дає змогу визначити межі стійкості та точки відмови.",
        expB: "Випадкове тестування без вимірювання не дає корисної інформації про межі стійкості.",
        expC: "Ізольоване тестування пропускає важливі взаємодії між різними типами трансформацій.",
        expD: "Тестування без тренувальних даних може пропустити проблеми, пов'язані з узагальненням.",
        points: 3,
        chapter: "МН - Нейронні мережі та тестування",
        difficulty: "K3"
      },
      {
        id: 112,
        text: "Що з наступного НАЙКРИТИЧНІШЕ під час оцінки впливу регуляризації на нейронні мережі? Виберіть ОДИН варіант.",
        options: [
          "Вимірювання лише фінальної точності на тестовому наборі даних",
          "Аналіз лише швидкості збіжності під час процесу навчання моделі",
          "Моніторинг balансу між ефективністю навчання та узагальненням на валідації",
          "Фокусування виключно на зменшенні складності архітектури мережі"
        ],
        correct: 3,
        expA: "Фінальна точність важлива, але не показує ефект регуляризації на переоцінку.",
        expB: "Швидкість збіжності корисна, але не основна мета регуляризації.",
        expC: "Саме так! Регуляризація має балансувати здатність до навчання із запобіганням переоцінці.",
        expD: "Регуляризація не обов'язково зменшує складність архітектури, а контролює переоцінку.",
        points: 3,
        chapter: "МН - Нейронні мережі та тестування",
        difficulty: "K3"
      },
      {
        id: 113,
        text: "Яка з наступних стратегій НАЙКРАЩА для валідації механізмів уваги в трансформерах? Виберіть ОДИН варіант.",
        options: [
          "Перевірка лише фінальних оцінок уваги для кожного токена",
          "Аналіз патернів уваги в різних шарах та головах для інтерпретації",
          "Фокусування виключно на швидкості обчислення механізмів уваги",
          "Використання лише усереднених вагів уваги по всім головам"
        ],
        correct: 2,
        expA: "Фінальні оцінки не показують, як увага розвивається через шари.",
        expB: "Правильно! Аналіз патернів уваги допомагає зрозуміти, на що модель фокусується на різних рівнях.",
        expC: "Швидкість важлива для продуктивності, але не для валідації якості механізму уваги.",
        expD: "Усереднення по головах може приховати важливі специфічні патерни уваги.",
        points: 3,
        chapter: "МН - Нейронні мережі та тестування",
        difficulty: "K3"
      },
      {
        id: 114,
        text: "Яка з наступних стратегій НАЙКОМПЛЕКСНІША для тестування CNN у медичній візуалізації? Виберіть ОДИН варіант.",
        options: [
          "Багатомодальна валідація із різними типами зображень та клінічною верифікацією",
          "Використання лише синтетичних медичних зображень для контрольованого тестування",
          "Фокусування виключно на метриках точності без клінічного контексту",
          "Тестування лише на одному типі медичних зображень для спеціалізації"
        ],
        correct: 0,
        expA: "Відмінно! Медичні застосування потребують ретельної валідації із клінічними експертами та різними модальностями.",
        expB: "Синтетичні зображення не можуть повністю відтворити складність реальних медичних даних.",
        expC: "Медичні застосування потребують клінічної релевантності понад технічні метрики.",
        expD: "Один тип зображень може не покривати всі сценарії використання в медицині.",
        points: 3,
        chapter: "МН - Нейронні мережі та тестування",
        difficulty: "K3"
      },
      {
        id: 115,
        text: "Що з наступного НАЙКРИТИЧНІШЕ для оцінки генеративно-змагальних мереж (GAN)? Виберіть ОДИН варіант.",
        options: [
          "Вимірювання лише швидкості генерації нових зразків даних",
          "Балансування якості генерації із різноманітністю створених зразків",
          "Фокусування виключно на стабільності навчання дискримінатора",
          "Оцінка лише здатності генератора обманювати дискримінатор"
        ],
        correct: 1,
        expA: "Швидкість генерації важлива для продуктивності, але не головний критерій якості GAN.",
        expB: "Правильно! GAN повинні генерувати високоякісні та різноманітні зразки, уникаючи колапсу режиму.",
        expC: "Стабільність дискримінатора важлива, але потрібен баланс між генератором і дискримінатором.",
        expD: "Обман дискримінатора недостатній - потрібна якість та різноманітність для реального застосування.",
        points: 3,
        chapter: "МН - Нейронні мережі та тестування",
        difficulty: "K3"
      },
      {
        id: 116,
        text: "Яка з наступних стратегій НАЙЕФЕКТИВНІША для тестування ансамблів нейронних мереж? Виберіть ОДИН варіант.",
        options: [
          "Систематична оцінка індивідуальних моделей та стратегій комбінування із метриками консенсусу",
          "Тестування лише фінальних передбачень ансамблю без аналізу компонентів",
          "Використання ідентичних архітектур для всіх членів ансамблю",
          "Фокусування виключно на швидкості обробки ансамблевих передбачень"
        ],
        correct: 0,
        expA: "Відмінно! Ансамблі потребують розуміння як індивідуальні моделі вносять вклад у фінальні передбачення.",
        expB: "Тестування лише фінальних результатів не допомагає діагностувати проблеми з окремими компонентами.",
        expC: "Різноманітність архітектур зазвичай покращує ефективність ансамблю.",
        expD: "Швидкість важлива, але ефективність та надійність мають пріоритет для ансамблів.",
        points: 3,
        chapter: "МН - Нейронні мережі та тестування",
        difficulty: "K3"
      },
      {
        id: 117,
        text: "Яка з наступних стратегій НАЙКОМПЛЕКСНІША для тестування інтеграції нейронних мереж у критичні системи? Виберіть ОДИН варіант.",
        options: [
          "Багатошарове тестування із симуляцією відмов, моніторингом у режимі реального часу та відновленням",
          "Використання лише ізольованого тестування нейронної мережі без системного контексту",
          "Фокусування виключно на функціональному тестуванні без врахування системної інтеграції",
          "Тестування лише в ідеальних умовах без симуляції складних сценаріїв"
        ],
        correct: 0,
        expA: "Правильно! Критичні системи потребують всебічного тестування відмовостійкості та відновлення.",
        expB: "Ізольоване тестування пропускає важливі інтеграційні проблеми в критичних системах.",
        expC: "Системна інтеграція критично важлива для безпеки в критичних застосуваннях.",
        expD: "Критичні системи повинні працювати надійно навіть у складних та несприятливих умовах.",
        points: 3,
        chapter: "МН - Нейронні мережі та тестування",
        difficulty: "K4"
      },
      {
        id: 118,
        text: "Яка з наступних стратегій НАЙКРАЩА для ризик-орієнтованого тестування великих мовних моделей? Виберіть ОДИН варіант.",
        options: [
          "Пріоритизація тестових випадків на основі впливу на бізнес та ймовірності відмови",
          "Використання лише автоматизованих тестів без ручного огляду результатів",
          "Фокусування виключно на технічних метриках без бізнес-контексту",
          "Тестування лише найпоширеніших сценаріїв використання без граничних випадків"
        ],
        correct: 0,
        expA: "Відмінно! Ризик-орієнтоване тестування фокусується на найкритичніших сценаріях для бізнесу.",
        expB: "LLM потребують людського огляду для виявлення тонких проблем якості та етики.",
        expC: "Бізнес-контекст критично важливий для визначення прийнятності результатів LLM.",
        expD: "Граничні випадки особливо важливі для LLM через їхню складну поведінку.",
        points: 3,
        chapter: "МН - Нейронні мережі та тестування",
        difficulty: "K4"
      },
      {
        id: 119,
        text: "Яка з наступних стратегій НАЙКОМПЛЕКСНІША для тестування змагального захисту в нейронних мережах? Виберіть ОДИН варіант.",
        options: [
          "Багатоетапне тестування із прогресивними атаками, адаптивними захистами та оцінкою стійкості",
          "Використання лише базових змагальних прикладів без адаптивних атак",
          "Фокусування виключно на захисних механізмах без тестування атак",
          "Тестування лише одного типу змагальної атаки за раз"
        ],
        correct: 0,
        expA: "Правильно! Змагальна стійкість потребує складного тестування проти адаптивних атак.",
        expB: "Базові атаки можуть не виявити справжні вразливості проти адаптивних противників.",
        expC: "Ефективність захисту можна оцінити лише через тестування проти атак.",
        expD: "Реальні змагальні атаки часто комбінують множинні техніки.",
        points: 3,
        chapter: "МН - Нейронні мережі та тестування",
        difficulty: "K4"
      },
      {
        id: 120,
        text: "Яка з наступних стратегій НАЙЕФЕКТИВНІША для вирішення виклику пояснюваності ШІ в регульованих галузях? Виберіть ОДИН варіант.",
        options: [
          "Інтерпретовані архітектури із вбудованою пояснюваністю для систематичного вирішення регуляторних вимог",
          "Пост-хок пояснення допомагають, але можуть не відповідати регуляторним вимогам щодо прозорості моделі",
          "Спрощені моделі можуть задовольнити пояснюваність, але втратити продуктивність для бізнес-цілей",
          "Документація цінна, але не вирішує фундаментальний виклик пояснюваності самої моделі"
        ],
        correct: 0,
        expA: "Відмінно! Інтерпретовані архітектури із вбудованою пояснюваністю систематично вирішують регуляторні вимоги зі збереженням продуктивності.",
        expB: "Пост-хок пояснення допомагають, але можуть не відповідати регуляторним вимогам щодо природної прозорості моделі.",
        expC: "Спрощені моделі можуть задовольнити пояснюваність, але можуть пожертвувати продуктивністю, необхідною для бізнес-цілей.",
        expD: "Документація цінна, але не вирішує фундаментальний виклик пояснюваності самої моделі.",
        points: 3,
        chapter: "МН - Нейронні мережі та тестування",
        difficulty: "K4"
      },
      {
        id: 121,
        text: "Що з наступного НАЙІМОВІРНІШЕ створює виклики для специфікацій систем ШІ? Виберіть ОДИН варіант.",
        options: [
          "Адаптивна поведінка системи, що потребує гнучких специфікацій",
          "Невизначеність моделей машинного навчання в вимогах",
          "Недетермінований вихід системи, що створює прогалини в специфікаціях",
          "Динамічні межі рішень ШІ, що впливають на специфікації"
        ],
        correct: 2,
        expA: "Адаптивна поведінка складна, але керована за допомогою хороших практик специфікації.",
        expB: "Невизначеність моделі важлива, але не впливає безпосередньо на створення специфікацій.",
        expC: "Саме так! Недетерміновані виходи роблять надзвичайно складним точне визначення очікуваної поведінки.",
        expD: "Динамічні межі викликають занепокоєння, але представляють підмножину ширшого виклику специфікації.",
        points: 1,
        chapter: "Огляд тестування систем на основі ШІ",
        difficulty: "K2"
      },
      {
        id: 122,
        text: "Що з наступного описує тестування вхідних даних для систем ШІ? Виберіть ОДИН варіант.",
        options: [
          "Валідація бази даних для цілісності структурованих даних",
          "Оцінка характеристик тестових даних для тестування ШІ",
          "Валідація параметрів входу веб-сервісу",
          "Тестування входу інтерфейсу користувача мобільного додатку"
        ],
        correct: 1,
        expA: "Валідація бази даних фокусується на структурованих даних, а не на оцінці тестових даних для ШІ.",
        expB: "Правильно! Тестування вхідних даних оцінює, чи підходять тестові дані для тестування систем ШІ.",
        expC: "Валідація веб-сервісу стосується тестування API, а не характеристик тестових даних ШІ.",
        expD: "Тестування входу UI фокусується на інтерфейсах користувача, а не на оцінці тестових даних ШІ.",
        points: 1,
        chapter: "Огляд тестування систем на основі ШІ",
        difficulty: "K1"
      },
      {
        id: 123,
        text: "Яке з наступних тверджень про тестування моделей МН є ПРАВИЛЬНИМ? Виберіть ОДИН варіант.",
        options: [
          "Воно оцінює метрики продуктивності моделі",
          "Воно замінює всі інші рівні тестування",
          "Воно фокусується лише на тренувальних даних",
          "Воно усуває потребу в валідації"
        ],
        correct: 0,
        expA: "Правильно! Тестування моделей МН оцінює метрики продуктивності, такі як точність, прецизійність та повнота.",
        expB: "Тестування моделі - це один рівень серед кількох, а не заміна всім іншим.",
        expC: "Тестування моделі використовує тестові дані, а не лише тренувальні дані для оцінки.",
        expD: "Валідація залишається важливою поряд із діяльністю з тестування моделі.",
        points: 2,
        chapter: "Огляд тестування систем на основі ШІ",
        difficulty: "K3"
      },
      {
        id: 124,
        text: "Який рівень тестування НАЙБІЛЬШЕ фокусується на взаємодії компонентів? Виберіть ОДИН варіант.",
        options: [
          "Підходи до модульного тестування компонентів ШІ",
          "Інтеграційне тестування компонентів",
          "Протоколи системного приймального тестування",
          "Фреймворки тестування продуктивності моделі"
        ],
        correct: 1,
        expA: "Модульне тестування фокусується на індивідуальних компонентах ШІ, а не на їхній взаємодії.",
        expB: "Саме так! Інтеграційне тестування компонентів перевіряє, як компоненти ШІ працюють разом ефективно.",
        expC: "Приймальне тестування фокусується на бізнес-вимогах, а не конкретно на взаємодії компонентів.",
        expD: "Тестування продуктивності оцінює метрики, а не поведінку взаємодії компонентів.",
        points: 1,
        chapter: "Огляд тестування систем на основі ШІ",
        difficulty: "K2"
      },
      {
        id: 125,
        text: "Яке з наступних тверджень про системне тестування є ПРАВИЛЬНИМ? Виберіть ОДИН варіант.",
        options: [
          "Воно тестує індивідуальні моделі в ізоляції",
          "Воно перевіряє повні системи в продукційно-подібних середовищах",
          "Воно фокусується лише на якості тренувальних даних",
          "Воно замінює потребу в приймальному тестуванні"
        ],
        correct: 1,
        expA: "Системне тестування розглядає повну систему, а не індивідуальні моделі в ізоляції.",
        expB: "Правильно! Системне тестування оцінює всю систему ШІ в продукційно-подібних умовах.",
        expC: "Системне тестування охоплює набагато більше, ніж просто якість тренувальних даних.",
        expD: "Системне тестування та приймальне тестування служать різним цілям і обидва необхідні.",
        points: 1,
        chapter: "Огляд тестування систем на основі ШІ",
        difficulty: "K2"
      },
      {
        id: 126,
        text: "Який з наступних факторів може ускладнювати тестування систем на основі ШІ? Виберіть ОДИН варіант.",
        options: [
          "Складності інтеграції застарілих систем",
          "Мережева затримка в розподіленому тестуванні",
          "Вимоги до великого обсягу та різноманітності",
          "Виклики тестування сумісності обладнання"
        ],
        correct: 2,
        expA: "Інтеграція застарілих систем складна, але не специфічна для складностей тестування систем ШІ.",
        expB: "Мережева затримка впливає на тестування, але не є основним фактором складності для ШІ.",
        expC: "Правильно! Великі обсяги та різноманітність даних створюють значну складність у тестуванні систем ШІ.",
        expD: "Сумісність обладнання викликає занепокоєння, але не є основною складністю тестування ШІ.",
        points: 1,
        chapter: "Огляд тестування систем на основі ШІ",
        difficulty: "K1"
      },
      {
        id: 127,
        text: "Що з наступного описує упередження автоматизації? Виберіть ОДИН варіант.",
        options: [
          "Технічні помилки в автоматизованих тестових сценаріях",
          "Недостатнє покриття в автоматизованих наборах тестів",
          "Надмірна довіра до результатів автоматизованих систем",
          "Високі витрати на підтримку автоматизованого тестування"
        ],
        correct: 2,
        expA: "Технічні помилки - це дефекти реалізації, а не упередження автоматизації.",
        expB: "Недостатнє покриття - це проблема планування тестів, а не упередження автоматизації.",
        expC: "Правильно! Упередження автоматизації виникає, коли люди надмірно довіряють автоматизованим системам.",
        expD: "Витрати на підтримку - це економічна проблема, а не когнітивне упередження.",
        points: 1,
        chapter: "Огляд тестування систем на основі ШІ",
        difficulty: "K2"
      },
      {
        id: 128,
        text: "Що з наступного НАЙКРАЩЕ описує документацію моделі МН? Виберіть ОДИН варіант.",
        options: [
          "Лише технічні специфікації архітектури моделі",
          "Комплексна документація включно з даними, алгоритмами та метриками",
          "Виключно результати тестування та валідації",
          "Тільки вихідний код та параметри конфігурації"
        ],
        correct: 1,
        expA: "Лише технічні специфікації недостатні для повного розуміння моделі МН.",
        expB: "Правильно! Документація моделі МН повинна охоплювати дані, алгоритми, метрики та контекст використання.",
        expC: "Результати тестування важливі, але не є повною документацією моделі.",
        expD: "Код та конфігурація корисні, але потребують більш широкого контексту для розуміння.",
        points: 1,
        chapter: "Огляд тестування систем на основі ШІ",
        difficulty: "K2"
      },
      {
        id: 129,
        text: "Що з наступного НАЙКРИТИЧНІШЕ для тестування дрейфу концепцій? Виберіть ОДИН варіант.",
        options: [
          "Одноразове базове тестування з високоякісними даними",
          "Безперервний моніторинг продуктивності моделі з часом",
          "Фокусування виключно на архітектурі моделі",
          "Тестування лише на статичних наборах даних"
        ],
        correct: 1,
        expA: "Одноразове тестування не може виявити зміни, що відбуваються з часом.",
        expB: "Відмінно! Дрейф концепцій вимагає безперервного моніторингу для виявлення деградації продуктивності.",
        expC: "Архітектура важлива, але дрейф концепцій стосується змін у даних та середовищі.",
        expD: "Статичні набори даних не відображають еволюційних змін, що призводять до дрейфу концепцій.",
        points: 2,
        chapter: "Огляд тестування систем на основі ШІ",
        difficulty: "K3"
      },
      {
        id: 130,
        text: "Яка з наступних стратегій НАЙЕФЕКТИВНІША для тестування великих даних у системах ШІ? Виберіть ОДИН варіант.",
        options: [
          "Зменшення всіх наборів даних до керованих розмірів",
          "Використання лише синтетичних даних для контрольованого тестування",
          "Фокусування виключно на швидкості обробки даних",
          "Поєднання вибіркового тестування з валідацією репрезентативності"
        ],
        correct: 3,
        expA: "Зменшення розмірів може пропустити проблеми, що виникають лише з великими даними.",
        expB: "Лише синтетичні дані можуть не відображати складність реальних даних.",
        expC: "Швидкість важлива, але якість та правильність мають пріоритет.",
        expD: "Правильно! Поєднання вибіркового підходу з валідацією репрезентативності забезпечує баланс між здійсненністю та точністю.",
        points: 3,
        chapter: "Огляд тестування систем на основі ШІ",
        difficulty: "K3"
      },
      {
        id: 131,
        text: "Яка з наступних стратегій НАЙКРАЩА для валідації конвеєрів даних у системах ШІ? Виберіть ОДИН варіант.",
        options: [
          "Наскрізне тестування з валідацією якості даних на кожному етапі",
          "Тестування лише фінального виходу конвеєра",
          "Фокусування виключно на швидкості обробки конвеєра",
          "Валідація лише вхідних даних без проміжних етапів"
        ],
        correct: 0,
        expA: "Відмінно! Наскрізне тестування з валідацією на кожному етапі забезпечує цілісність даних через весь конвеєр.",
        expB: "Тестування лише фінального виходу може пропустити проблеми трансформації даних на проміжних етапах.",
        expC: "Швидкість важлива, але якість та правильність даних мають пріоритет.",
        expD: "Валідація лише входів пропускає проблеми, що можуть виникнути під час обробки.",
        points: 3,
        chapter: "Огляд тестування систем на основі ШІ",
        difficulty: "K3"
      },
      {
        id: 132,
        text: "Що з наступного НАЙКРИТИЧНІШЕ під час вибору метрик для функціонального тестування МН? Виберіть ОДИН варіант.",
        options: [
          "Використання лише найпопularніших галузевих метрик",
          "Фокусування виключно на метриках, що легко обчислити",
          "Узгодження метрик з бізнес-цілями та контекстом домену",
          "Вибір метрик, що показують найкращі результати"
        ],
        correct: 2,
        expA: "Популярні метрики можуть не підходити для конкретного контексту застосування.",
        expB: "Легкі для обчислення метрики можуть не бути найбільш релевантними для оцінки успіху.",
        expC: "Правильно! Метрики повинні відображати реальні бізнес-цілі та специфіку домену застосування.",
        expD: "Вибір метрик на основі результатів може призвести до введення в оману та неправильних висновків.",
        points: 2,
        chapter: "Огляд тестування систем на основі ШІ",
        difficulty: "K2"
      },
      {
        id: 133,
        text: "Яка з наступних стратегій НАЙЕФЕКТИВНІША для тестування систем ШІ в умовах обмеженого часу? Виберіть ОДИН варіант.",
        options: [
          "Тестування всіх компонентів рівномірно незалежно від ризику",
          "Ризик-орієнтована пріоритизація з фокусом на критичних функціях",
          "Виключне фокусування на автоматизованих тестах",
          "Тестування лише нових функцій без регресії"
        ],
        correct: 1,
        expA: "Рівномірне тестування може витрачати час на менш критичні області.",
        expB: "Відмінно! Ризик-орієнтований підхід максимізує покриття найкритичніших функцій за обмежений час.",
        expC: "Лише автоматизовані тести можуть пропустити важливі сценарії, що потребують ручного огляду.",
        expD: "Ігнорування регресійного тестування може призвести до введення нових дефектів.",
        points: 2,
        chapter: "Огляд тестування систем на основі ШІ",
        difficulty: "K3"
      },
      {
        id: 134,
        text: "Що з наступного НАЙВАЖЛИВІШЕ для забезпечення якості тренувальних даних? Виберіть ОДИН варіант.",
        options: [
          "Комплексна валідація якості, репрезентативності та відсутності упередження",
          "Використання лише найбільших доступних наборів даних",
          "Фокусування виключно на точності мітування даних",
          "Забезпечення максимальної швидкості завантаження даних"
        ],
        correct: 0,
        expA: "Правильно! Якість тренувальних даних вимагає комплексного підходу до валідації всіх аспектів.",
        expB: "Розмір важливий, але якість та репрезентативність мають пріоритет над обсягом.",
        expC: "Точність мітування критична, але недостатня без репрезентативності та відсутності упереджень.",
        expD: "Швидкість завантаження - це технічна оптимізація, а не питання якості даних.",
        points: 2,
        chapter: "Огляд тестування систем на основі ШІ",
        difficulty: "K2"
      },
      {
        id: 135,
        text: "Медичний заклад впроваджує систему ШІ для діагностичної візуалізації з суворими вимогами до безпеки пацієнтів, регуляторної відповідності та точності діагностики. Обмежений бюджет вимагає пріоритизації тестування. Який підхід НАЙКРАЩЕ збалансує ці вимоги? Виберіть ОДИН варіант.",
        options: [
          "Фокусування виключно на метриках точності для максимізації діагностичної ефективності",
          "Рівномірний розподіл ресурсів тестування між усіма вимогами",
          "Пріоритизація безпеки пацієнтів та регуляторної відповідності як невідкладних вимог з оптимізацією точності",
          "Відкладання впровадження до досягнення ідеального балансу"
        ],
        correct: 2,
        expA: "Фокус лише на точності ігнорує критичні аспекти безпеки в медичних застосуваннях.",
        expB: "Рівномірний розподіл може недооцінювати критичну важливість безпеки пацієнтів.",
        expC: "Відмінно! K4 стратегічний аналіз: безпека пацієнтів та відповідність не підлягають обговоренню в медицині.",
        expD: "Ідеальний баланс нереалістичний і затримує критично важливі медичні можливості.",
        points: 3,
        chapter: "Огляд тестування систем на основі ШІ",
        difficulty: "K4"
      },
      {
        id: 136,
        text: "Глобальна компанія розробляє систему ШІ для обслуговування клієнтів, яка повинна працювати в різних регіонах з різними мовами, культурами та регуляторними вимогами. Яка стратегія тестування забезпечує оптимальне покриття? Виберіть ОДИН варіант.",
        options: [
          "Тестування лише в основній мові розробки з припущенням універсальної застосовності",
          "Фокусування виключно на технічних метриках продуктивності, ігноруючи культурні варіації",
          "Створення окремих ізольованих систем для кожного регіону без спільних компонентів",
          "Багаторівневе тестування, що поєднує валідацію спільної функціональності з регіон-специфічним адаптаційним тестуванням"
        ],
        correct: 3,
        expA: "Тестування однією мовою пропускає критичні вимоги локалізації та культурної адаптації.",
        expB: "Лише технічні метрики пропускають питання культурної відповідності та регуляторної відповідності.",
        expC: "Повна ізоляція запобігає корисному спільному навчанню та непотрібно збільшує складність підтримки.",
        expD: "Відмінно! K4 аналіз: поєднання тестування спільної функціональності з регіон-специфічною валідацією забезпечує всебічне покриття з оптимізацією ресурсів.",
        points: 3,
        chapter: "Огляд тестування систем на основі ШІ",
        difficulty: "K4"
      },
      {
        id: 137,
        text: "Фінансова установа впроваджує систему ШІ для кредитного скорингу, яка повинна збалансувати регуляторну відповідність, справедливість між демографічними групами, конкурентну продуктивність та операційну ефективність. Зацікавлені сторони мають конфліктні пріоритети та обмежений час впровадження. Який стратегічний підхід НАЙКРАЩЕ керує цими конкуруючими вимогами? Виберіть ОДИН варіант.",
        options: [
          "Пріоритизація регуляторної відповідності та справедливості як невідкладних вимог з оптимізацією продуктивності в межах обмежень",
          "Фокусування виключно на конкурентній продуктивності для максимізації бізнес-переваги",
          "Відкладання впровадження до ідеального вирішення всіх занепокоєнь зацікавлених сторін",
          "Впровадження мінімальних вимог відповідності для прискорення розгортання"
        ],
        correct: 0,
        expA: "Відмінно! K4 стратегічний аналіз: регуляторна відповідність та справедливість обов'язкові в фінансових послугах, з оптимізацією продуктивності в цих межах як оптимальний підхід.",
        expB: "Фокус лише на продуктивності ризикує регуляторними порушеннями та дискримінаційними результатами в регульованих фінансових послугах.",
        expC: "Ідеальне вирішення всіх занепокоєнь нереалістичне і непотрібно затримує критичну бізнес-функціональність.",
        expD: "Мінімальна відповідність створює значні правові та репутаційні ризики в сильно регульованих фінансових послугах.",
        points: 3,
        chapter: "Огляд тестування систем на основі ШІ",
        difficulty: "K4"
      },
      {
        id: 138,
        text: "Система ШІ автономного транспортного засобу повинна інтегрувати множинні підсистеми (зір, навігація, прийняття рішень), забезпечуючи безпеку в різноманітних умовах водіння та регуляторних середовищах. Обмежений час тестування вимагає пріоритизації. Який підхід забезпечує НАЙКОМПЛЕКСНІШЕ покриття ризиків? Виберіть ОДИН варіант.",
        options: [
          "Комплексне інтеграційне тестування всіх взаємодій підсистем з пріоритизацією сценаріїв, критичних для безпеки",
          "Послідовне індивідуальне тестування підсистем без валідації інтеграції",
          "Фокусування виключно на нормальних умовах водіння для забезпечення базової функціональності",
          "Обмеження тестування лише контрольованими лабораторними середовищами"
        ],
        correct: 0,
        expA: "Ідеально! K4 стратегічне мислення: комплексне інтеграційне тестування з пріоритизацією безпеки адресує найризикованіші сценарії спочатку, забезпечуючи координацію підсистем.",
        expB: "Індивідуальне тестування пропускає критичні інтеграційні відмови, що можуть спричинити проблеми безпеки в реальних умовах.",
        expC: "Лише нормальні умови пропускають граничні випадки та аварійні сценарії, де безпека найбільш критична.",
        expD: "Лише лабораторне тестування не валідує реальну продуктивність та безпеку в фактичних умовах експлуатації.",
        points: 3,
        chapter: "Огляд тестування систем на основі ШІ",
        difficulty: "K4"
      },
      {
        id: 139,
        text: "Фінансова установа впроваджує систему ШІ для кредитного скорингу, яка повинна збалансувати регуляторну відповідність, справедливість між демографічними групами, конкурентну продуктивність та операційну ефективність. Зацікавлені сторони мають конфліктні пріоритети та обмежений час впровадження. Який стратегічний підхід НАЙКРАЩЕ керує цими конкуруючими вимогами? Виберіть ОДИН варіант.",
        options: [
          "Пріоритизація регуляторної відповідності та справедливості як невідкладних вимог з оптимізацією продуктивності в межах обмежень",
          "Фокусування виключно на конкурентній продуктивності для максимізації бізнес-переваги",
          "Відкладання впровадження до ідеального вирішення всіх занепокоєнь зацікавлених сторін",
          "Впровадження мінімальних вимог відповідності для прискорення розгортання"
        ],
        correct: 0,
        expA: "Відмінно! K4 стратегічний аналіз: регуляторна відповідність та справедливість обов'язкові в фінансових послугах, з оптимізацією продуктивності в цих межах як оптимальний підхід.",
        expB: "Фокус лише на продуктивності ризикує регуляторними порушеннями та дискримінаційними результатами в регульованих фінансових послугах.",
        expC: "Ідеальне вирішення всіх занепокоєнь нереалістичне і непотрібно затримує критичну бізнес-функціональність.",
        expD: "Мінімальна відповідність створює значні правові та репутаційні ризики в сильно регульованих фінансових послугах.",
        points: 3,
        chapter: "Огляд тестування систем на основі ШІ",
        difficulty: "K4"
      },
      {
        id: 140,
        text: "Яке твердження про приймальне тестування для систем ШІ є ПРАВИЛЬНИМ? Виберіть ОДИН варіант.",
        options: [
          "Воно фокусується лише на технічних метриках продуктивності",
          "Воно валідує бізнес-вимоги та задоволеність користувачів",
          "Воно замінює потребу в системному тестуванні",
          "Воно тестує лише якість тренувальних даних"
        ],
        correct: 1,
        expA: "Приймальне тестування виходить за межі технічних метрик, включаючи оцінку бізнес-цінності.",
        expB: "Саме так! Приймальне тестування забезпечує, що система ШІ відповідає бізнес-потребам та очікуванням користувачів.",
        expC: "Приймальне тестування доповнює системне тестування, а не замінює його.",
        expD: "Якість тренувальних даних тестується набагато раніше в процесі, а не під час приймального тестування.",
        points: 2,
        chapter: "Огляд тестування систем на основі ШІ",
        difficulty: "K3"
      },
      {
        id: 141,
        text: "Що з наведеного НАЙІМОВІРНІШЕ ускладнює тестування систем самонавчання? Оберіть ОДИН варіант.",
        options: [
          "Статичні параметри моделі машинного навчання",
          "Еволюційна поведінка системи від безперервного навчання", 
          "Обмежена різноманітність та обсяг навчальних даних",
          "Стандартні архітектурні обмеження нейронних мереж"
        ],
        correct: 1,
        expA: "Статичні параметри насправді зробили б тестування легшим і більш передбачуваним.",
        expB: "Саме так! Системи самонавчання постійно модифікують свою поведінку на основі нових даних, що робить традиційні підходи до тестування недостатніми.",
        expC: "Хоча обмеження даних мають значення, основний виклик - це зміна поведінки, а не лише обмеження даних.",
        expD: "Архітектурні обмеження - це проектні рішення, а не основний виклик тестування для систем самонавчання.",
        points: 1,
        chapter: "Тестування специфічних характеристик якості ІІ",
        difficulty: "K2"
      },
      {
        id: 142,
        text: "Яке з наведених тверджень про алгоритмічне упередження є ПРАВИЛЬНИМ? Оберіть ОДИН варіант.",
        options: [
          "Спричиняє систематичну несправедливість у рішеннях",
          "Створює випадкові помилки алгоритму",
          "Впливає на швидкість обробки",
          "Впливає на розподіл пам'яті"
        ],
        correct: 0,
        expA: "Ідеально! Алгоритмічне упередження означає систематичну дискримінацію або несправедливість у рішеннях ІІ, часто відображаючи патерни історичних даних.",
        expB: "Випадкові помилки - це баги, а не упередження. Упередження є систематичною і передбачуваною несправедливістю.",
        expC: "Варіації швидкості - це проблеми продуктивності, а не упередження в прийнятті рішень.",
        expD: "Проблеми пам'яті - це технічні проблеми, а не питання, пов'язані з упередженням.",
        points: 1,
        chapter: "Тестування специфічних характеристик якості ІІ", 
        difficulty: "K1"
      },
      {
        id: 143,
        text: "Який з наведених підходів НАЙКРАЩЕ вирішує тестування автономних систем ІІ? Оберіть ОДИН варіант.",
        options: [
          "Попередньо визначені тестові сценарії",
          "Контроль ручного керування",
          "Симуляція з граничними випадками",
          "Зменшене покриття тестування"
        ],
        correct: 2,
        expA: "Автономні системи потребують адаптивного тестування, а не лише попередньо визначених сценаріїв.",
        expB: "Ручний контроль під час роботи - це моніторинг, а не тестування.",
        expC: "Правильно! Середовища симуляції дозволяють безпечно тестувати граничні випадки та несподівані сценарії для автономних систем.",
        expD: "Автономні системи фактично потребують більш комплексного тестування, а не зменшеного покриття.",
        points: 2,
        chapter: "Тестування специфічних характеристик якості ІІ",
        difficulty: "K3"
      },
      {
        id: 144,
        text: "Що з наведеного НАЙКРАЩЕ описує упередження вибірки в навчальних даних МН? Оберіть ОДИН варіант.",
        options: [
          "Систематична методологія збору даних, що створює спотворені вибірки",
          "Недостатній розмір навчального набору для узагальнення моделі",
          "Нерепрезентативний розподіл даних, що впливає на продуктивність моделі",
          "Непослідовності попередньої обробки даних, що створюють артефакти моделі"
        ],
        correct: 2,
        expA: "Проблеми методології можуть сприяти упередженню, але упередження вибірки конкретно стосується нерепрезентативного розподілу.",
        expB: "Розмір набору даних стосується дисперсії, а не упередження - можна мати репрезентативні малі набори та упереджені великі.",
        expC: "Саме так! Упередження вибірки виникає, коли навчальні дані не представляють реальну популяцію, яку система зустрічатиме в продакшені.",
        expD: "Непослідовності попередньої обробки створюють технічні артефакти, а не проблеми репрезентативності, що визначають упередження вибірки.",
        points: 1,
        chapter: "Тестування специфічних характеристик якості ІІ",
        difficulty: "K2"
      },
      {
        id: 145,
        text: "Що з наведеного НАЙІМОВІРНІШЕ ускладнює тестування ймовірнісних систем ІІ? Оберіть ОДИН варіант.",
        options: [
          "Детермінованські патерни виводу",
          "Змінні виводи для ідентичних входів",
          "Послідовні метрики продуктивності",
          "Передбачувані швидкості помилок"
        ],
        correct: 1,
        expA: "Детермінованські патерни фактично зробили б тестування легшим, а не складнішим.",
        expB: "Абсолютно! Коли ідентичні входи дають різні виводи, важко визначити очікувані результати та перевірити правильність.",
        expC: "Послідовні метрики допомагають тестуванню - вони не створюють викликів.",
        expD: "Передбачувані швидкості помилок роблять тестування більш керованим, а не складним.",
        points: 2,
        chapter: "Тестування специфічних характеристик якості ІІ",
        difficulty: "K3"
      },
      {
        id: 146,
        text: "Яке з наведених тверджень про пояснюваність у тестуванні ІІ є ПРАВИЛЬНИМ? Оберіть ОДИН варіант.",
        options: [
          "Документує продуктивність системи",
          "Пояснює обґрунтування рішень ІІ",
          "Покращує читабельність коду",
          "Роз'яснює користувацькі інтерфейси"
        ],
        correct: 1,
        expA: "Документація продуктивності важлива, але не пояснює обґрунтування рішень.",
        expB: "Ідеально! Пояснюваність означає можливість зрозуміти та інтерпретувати, чому система ІІ прийняла певні рішення.",
        expC: "Читабельність коду стосується вихідного коду, а не пояснень рішень ІІ.",
        expD: "Ясність інтерфейсу допомагає користувачам, але не пояснює процес міркування ІІ.",
        points: 1,
        chapter: "Тестування специфічних характеристик якості ІІ",
        difficulty: "K1"
      },
      {
        id: 147,
        text: "Який з наведених інструментів НАЙЧАСТІШЕ використовується для тестування пояснюваності моделі? Оберіть ОДИН варіант.",
        options: [
          "Фреймворк аналізу важливості ознак SHAP",
          "Метод інтерпретації LIME для локальних пояснень",
          "Метод аналізу атрибуції інтегрованих градієнтів",
          "Підхід тестування важливості ознак перестановки"
        ],
        correct: 1,
        expA: "SHAP забезпечує глобальну важливість ознак, але LIME частіше використовується для локального тестування пояснюваності.",
        expB: "Правильно! LIME (Local Interpretable Model-agnostic Explanations) - найчастіше використовуваний метод для розуміння індивідуальних передбачень ІІ під час тестування.",
        expC: "Інтегровані градієнти корисні для нейронних мереж, але менш поширені, ніж LIME для загального тестування пояснюваності.",
        expD: "Важливість перестановки корисна для аналізу ознак, але LIME більш стандартний саме для тестування пояснюваності.",
        points: 1,
        chapter: "Тестування специфічних характеристик якості ІІ",
        difficulty: "K2"
      },
      {
        id: 148,
        text: "Яка з наведених характеристик НАЙІМОВІРНІШЕ створює виклики тестування в складних системах ІІ? Оберіть ОДИН варіант.",
        options: [
          "Проста лінійна обробка",
          "Множинні взаємодіючі компоненти", 
          "Однопоточне виконання",
          "Статичні налаштування конфігурації"
        ],
        correct: 1,
        expA: "Проста лінійна обробка фактично зробила б тестування легшим.",
        expB: "Саме так! Множинні взаємодіючі компоненти створюють складні залежності та емерджентну поведінку, яку важко передбачити та протестувати.",
        expC: "Однопоточне виконання простіше тестувати, ніж складні системи ІІ.",
        expD: "Статичні налаштування зробили б системи більш передбачуваними, а не складнішими для тестування.",
        points: 2,
        chapter: "Тестування специфічних характеристик якості ІІ",
        difficulty: "K3"
      },
      {
        id: 149,
        text: "Що з наведеного НАЙКРАЩЕ характеризує неприйнятне упередження в системах ІІ? Оберіть ОДИН варіант.",
        options: [
          "Дискримінація на основі захищених демографічних атрибутів",
          "Статистичні варіації в точності моделі між групами",
          "Систематичні помилки в алгоритмах машинного навчання",
          "Непослідовність в методах збору навчальних даних"
        ],
        correct: 0,
        expA: "Правильно! Неприйнятне упередження означає дискримінацію на основі захищених характеристик, таких як раса, стать або вік, що є етично і юридично неприйнятним.",
        expB: "Статистичні варіації можуть бути прийнятними, якщо вони не дискримінують захищені групи.",
        expC: "Систематичні помилки - це технічні проблеми, що не обов'язково конституюють неприйнятне упередження.",
        expD: "Непослідовність збору даних - це проблема якості даних, а не специфічно неприйнятне упередження.",
        points: 1,
        chapter: "Тестування специфічних характеристик якості ІІ",
        difficulty: "K2"
      },
      {
        id: 150,
        text: "Яка стратегія НАЙКРАЩИМ ЧИНОМ вирішує тестування самоадаптивних систем ІІ? Оберіть ОДИН варіант.",
        options: [
          "Періодичне тестування з фіксованими тестовими наборами",
          "Безперервний моніторинг з адаптивними тестовими стратегіями",
          "Одноразове комплексне тестування після розгортання",
          "Статичне тестування продуктивності з базовими показниками"
        ],
        correct: 1,
        expA: "Фіксовані тестові набори стають застарілими, коли самоадаптивні системи змінюють свою поведінку.",
        expB: "Точно! Самоадаптивні системи потребують безперервного моніторингу та тестових стратегій, що еволюціонують разом з навчанням системи.",
        expC: "Одноразове тестування неадекватне для систем, що постійно змінюються та адаптуються.",
        expD: "Статичне тестування не може відстежувати динамічні зміни в самоадаптивних системах.",
        points: 2,
        chapter: "Тестування специфічних характеристик якості ІІ",
        difficulty: "K3"
      },
      {
        id: 151,
        text: "Що з наведеного є ОСНОВНИМ викликом при створенні тестових оракулів для систем ІІ? Оберіть ОДИН варіант.",
        options: [
          "Обмежена обчислювальна потужність для складних розрахунків",
          "Визначення очікуваних результатів для недетермінованих систем",
          "Інтеграція з існуючими фреймворками автоматизації тестування",
          "Документування складних сценаріїв тестування для команд"
        ],
        correct: 1,
        expA: "Обчислювальна потужність - це ресурсна проблема, а не основний виклик тестового оракула.",
        expB: "Правильно! Коли системи ІІ виводять різні результати для однакових входів, визначення 'правильного' очікуваного результату стає основним викликом.",
        expC: "Інтеграція - це технічна проблема реалізації, а не фундаментальний виклик тестового оракула.",
        expD: "Документування важливе для команди, але не є основним викликом створення тестових оракулів.",
        points: 1,
        chapter: "Тестування специфічних характеристик якості ІІ",
        difficulty: "K2"
      },
      {
        id: 152,
        text: "Яка техніка НАЙЕФЕКТИВНІШЕ перевіряє прозорість систем ІІ? Оберіть ОДИН варіант.",
        options: [
          "Аудит архітектури системи та документації коду",
          "Аналіз журналів виконання та трасування рішень",
          "Тестування інтерфейсів та взаємодії користувачів",
          "Перевірка метрик продуктивності та швидкості відгуку"
        ],
        correct: 0,
        expA: "Точно! Прозорість означає зрозумілість процесів системи, що найкраще перевіряється через аудит архітектури та документації.",
        expB: "Журнали виконання показують, що сталося, але не обов'язково роблять процеси зрозумілими.",
        expC: "Тестування інтерфейсів перевіряє зручність використання, а не внутрішню прозорість системи.",
        expD: "Метрики продуктивності вимірюють ефективність, а не прозорість процесів прийняття рішень.",
        points: 1,
        chapter: "Тестування специфічних характеристик якості ІІ",
        difficulty: "K2"
      },
      {
        id: 153,
        text: "Компанія розгортає систему ІІ для обробки персональних даних клієнтів. Які критерії приймання НАЙВАЖЛИВІШІ? Оберіть ОДИН варіант.",
        options: [
          "Високе покриття тестів та автоматизовані регресійні тести",
          "Комплаєнс із захистом даних та тестування справедливості",
          "Оптимізація продуктивності та масштабування системи",
          "Інтеграційне тестування та сумісність з наявними системами"
        ],
        correct: 1,
        expA: "Покриття тестів важливе, але комплаєнс із захистом даних критичний для персональних даних.",
        expB: "Правильно! При роботі з персональними даними дотримання регулацій захисту даних (GDPR, CCPA) та відсутність дискримінації є першочерговими.",
        expC: "Продуктивність важлива, але відповідність регуляторним вимогам критичніша для персональних даних.",
        expD: "Інтеграція необхідна, але правові та етичні вимоги мають пріоритет при обробці персональних даних.",
        points: 3,
        chapter: "Тестування специфічних характеристик якості ІІ",
        difficulty: "K4"
      },
      {
        id: 154,
        text: "Що з наведеного НАЙКРАЩЕ описує різницю між інтерпретованістю та пояснюваністю? Оберіть ОДИН варіант.",
        options: [
          "Інтерпретованість потребує зовнішніх інструментів",
          "Інтерпретованість застосовується лише до нейронних мереж",
          "Інтерпретованість вимірює продуктивність системи",
          "Інтерпретованість стосується загального розуміння моделі"
        ],
        correct: 3,
        expA: "Інтерпретованість не обов'язково потребує зовнішніх інструментів - це стосується внутрішньої ясності моделі.",
        expB: "Інтерпретованість застосовується до всіх моделей ІІ, а не лише до нейронних мереж.",
        expC: "Інтерпретованість стосується розуміння рішень, а не вимірювання продуктивності.",
        expD: "Правильно! Інтерпретованість стосується того, наскільки добре зацікавлені сторони розуміють технологію ІІ загалом, тоді як пояснюваність фокусується на розумінні конкретних рішень.",
        points: 2,
        chapter: "Тестування специфічних характеристик якості ІІ",
        difficulty: "K3"
      },
      {
        id: 155,
        text: "Яка з наведених характеристик НАЙІМОВІРНІШЕ ускладнює тестування автономних систем? Оберіть ОДИН варіант.",
        options: [
          "Попередньо визначені патерни відгуку",
          "Механізми ручного керування",
          "Статичні операційні параметри",
          "Незалежні можливості прийняття рішень"
        ],
        correct: 3,
        expA: "Попередньо визначені патерни фактично зробили б тестування більш передбачуваним.",
        expB: "Ручне керування забезпечує контроль тестування, а не виклики.",
        expC: "Статичні параметри зробили б тестування легшим, а не складнішим.",
        expD: "Саме так! Незалежне прийняття рішень означає, що система може робити несподівані вибори, які важко передбачити та комплексно протестувати.",
        points: 2,
        chapter: "Тестування специфічних характеристик якості ІІ",
        difficulty: "K3"
      },
      {
        id: 156,
        text: "Організація впроваджує автономну систему в продакшн середовищі. Яка стратегія тестування НАЙБІЛЬШ доречна? Оберіть ОДИН варіант.",
        options: [
          "Комплексне інтеграційне тестування з наявними продакшн системами",
          "Ізольоване тестування, зосереджене лише на новій автономній функціональності",
          "Тестування користувацького інтерфейсу для можливостей контролю оператора",
          "Мінімальне інтеграційне тестування для зменшення ризиків розгортання"
        ],
        correct: 0,
        expA: "Ідеально! Автономні системи в продакшн середовищах повинні бути ретельно протестовані на інтеграцію з наявними системами для забезпечення безпечної та ефективної роботи.",
        expB: "Ізольоване тестування не виявить, як автономна система взаємодіятиме з іншими продакшн системами.",
        expC: "Тестування інтерфейсу важливе, але інтеграційне тестування критично для автономних систем у продакшені.",
        expD: "Мінімальне інтеграційне тестування неадекватне та ризиковане для автономних систем у продакшн середовищах.",
        points: 3,
        chapter: "Тестування специфічних характеристик якості ІІ",
        difficulty: "K4"
      },
      {
        id: 157,
        text: "При тестуванні системи ІІ на упередження вибірки, що НАЙВАЖЛИВІШЕ перевірити? Оберіть ОДИН варіант.",
        options: [
          "Розмір навчального набору даних",
          "Репрезентативність даних для всіх груп користувачів",
          "Швидкість обробки для різних типів даних",
          "Специфікації формату зберігання даних"
        ],
        correct: 1,
        expA: "Розмір має значення для якості моделі, але упередження вибірки конкретно стосується репрезентативності серед груп.",
        expB: "Саме так! Упередження вибірки виникає, коли навчальні дані не представляють всі групи користувачів рівномірно, що призводить до несправедливого ставлення.",
        expC: "Швидкість обробки - це технічний аспект продуктивності, не пов'язаний з якістю репрезентативності даних.",
        expD: "Формат зберігання - це технічна деталь реалізації, не пов'язана з виявленням упередження вибірки.",
        points: 1,
        chapter: "Тестування специфічних характеристик якості ІІ",
        difficulty: "K2"
      },
      {
        id: 158,
        text: "Банк тестує систему ІІ для кредитних рішень. Який аспект потребує НАЙБІЛЬШОЇ уваги? Оберіть ОДИН варіант.",
        options: [
          "Тестування справедливості серед усіх демографічних груп",
          "Оптимізація швидкості обробки",
          "Мінімізація складності інтеграції",
          "Оптимізація обчислювальних ресурсів"
        ],
        correct: 0,
        expA: "Правильно! У фінансовому прийнятті рішень справедливість та відсутність дискримінації є критичними вимогами для правового дотримання та етичної відповідальності.",
        expB: "Швидкість важлива для користувацького досвіду, але вторинна порівняно зі справедливістю в регульованих фінансових рішеннях.",
        expC: "Складність інтеграції - це технічна проблема, але не вирішує первинні етичні та правові вимоги.",
        expD: "Оптимізація ресурсів - це операційна ефективність, а не основна проблема справедливості кредитних рішень.",
        points: 3,
        chapter: "Тестування специфічних характеристик якості ІІ",
        difficulty: "K4"
      },
      {
        id: 159,
        text: "Який з наведених підходів НАЙКРАЩЕ вирішує виклики тестування самоадаптивних систем ІІ? Оберіть ОДИН варіант.",
        options: [
          "Виконання фіксованих тестових випадків",
          "Безперервний моніторинг з адаптивними тестовими стратегіями",
          "Завершення одноетапного тестування",
          "Статичне тестування продуктивності з еталонами"
        ],
        correct: 1,
        expA: "Фіксовані тестові випадки стають застарілими, коли самоадаптивні системи змінюють свою поведінку.",
        expB: "Саме так! Самоадаптивні системи потребують безперервного моніторингу та тестових стратегій, що еволюціонують разом з навчанням системи.",
        expC: "Одноетапне тестування неадекватне для систем, що постійно навчаються та адаптуються.",
        expD: "Статичні еталони не можуть відстежувати динамічні зміни в самоадаптивних системах.",
        points: 3,
        chapter: "Тестування специфічних характеристик якості ІІ",
        difficulty: "K4"
      },
      {
        id: 160,
        text: "Який підхід НАЙКРАЩЕ вирішує тестування ймовірнісних систем з невизначеними результатами? Оберіть ОДИН варіант.",
        options: [
          "Ігнорування варіабельності та фокусування на детермінованих компонентах",
          "Встановлення бінарних критеріїв проходження/неуспіху для всіх результатів",
          "Використання статистичної валідації замість точного збігу результатів",
          "Документування проблем без реалізації специфічних тестових підходів"
        ],
        correct: 2,
        expA: "Ігнорування варіабельності не вирішує основні виклики тестування ймовірнісних систем.",
        expB: "Хоча це правда, це описує проблему, але не надає підходу до вирішення.",
        expC: "Саме так! Ймовірнісні системи потребують статистичних методів валідації, а не точного збігу результатів для перевірки оракулів.",
        expD: "Це пояснює, чому бінарні критерії недостатні, але не визначає оптимальний підхід.",
        points: 3,
        chapter: "Тестування специфічних характеристик якості ІІ",
        difficulty: "K4"
      },
      {
        id: 161,
        text: "Яке з наведених тверджень про ворожі приклади є ПРАВИЛЬНИМ? Оберіть ОДИН варіант.",
        options: [
          "Вони представляють доброякісні варіації вводу",
          "Це спотворені вводи для спричинення неправильних передбачень",
          "Вони покращують тестування стійкості моделі",
          "Вони валідують нормальну поведінку системи"
        ],
        correct: 1,
        expA: "Ворожі приклади є зловмисними, а не доброякісними - вони спеціально створені для обману моделей.",
        expB: "Саме так! Ворожі приклади - це навмисно спотворені входи, розроблені для спричинення неправильних передбачень у системах ІІ.",
        expC: "Хоча вони можуть використовуватися в тестуванні стійкості, ворожі приклади є атаками, а не покращеннями тестування.",
        expD: "Ворожі приклади тестують аномальні сценарії атак, а не нормальну валідацію системи.",
        points: 1,
        chapter: "Методи та техніки тестування систем на основі ІІ",
        difficulty: "K1"
      },
      {
        id: 162,
        text: "Яке з наведених тверджень про отруєння даних є ПРАВИЛЬНИМ? Оберіть ОДИН варіант.",
        options: [
          "Впливає лише на фази валідації моделі",
          "Покращує надійність навчальних даних",
          "Може скомпрометувати цілісність моделі під час навчання",
          "Покращує ефективність попередньої обробки даних"
        ],
        correct: 2,
        expA: "Отруєння даних в першу чергу впливає на фазу навчання, хоча ефекти зберігаються при розгортанні.",
        expB: "Отруєння даних навмисно корумпує надійність даних - воно не покращує її.",
        expC: "Ідеально! Отруєння даних включає ін'єкцію зловмисних даних для компрометації цілісності моделі під час навчання.",
        expD: "Отруєння даних стосується атак безпеки, а не покращення ефективності попередньої обробки.",
        points: 1,
        chapter: "Методи та техніки тестування систем на основі ІІ",
        difficulty: "K1"
      },
      {
        id: 163,
        text: "Яке з наведених тверджень про парне тестування є ПРАВИЛЬНИМ? Оберіть ОДИН варіант.",
        options: [
          "Тестує всі можливі комбінації вводу",
          "Фокусується на тестуванні пар параметрів",
          "Працює лише з нейронними мережами",
          "Повністю замінює функціональне тестування"
        ],
        correct: 1,
        expA: "Парне тестування зменшує комбінації, тестуючи пари параметрів, а не всі можливі комбінації.",
        expB: "Правильно! Парне тестування забезпечує тестування кожної пари вхідних параметрів разом принаймні один раз.",
        expC: "Парне тестування - це загальна техніка, що застосовується до будь-яких систем з параметрами.",
        expD: "Парне тестування доповнює функціональне тестування, а не замінює його повністю.",
        points: 1,
        chapter: "Методи та техніки тестування систем на основі ІІ",
        difficulty: "K2"
      },
      {
        id: 164,
        text: "Який підхід НАЙЕФЕКТИВНІШЕ тестує адаптивність моделей машинного навчання? Оберіть ОДИН варіант.",
        options: [
          "Моніторинг дрифту даних з оновленням базової лінії",
          "Статичне тестування з фіксованими наборами даних",
          "Періодична переоцінка з історичними метриками",
          "Ручне налаштування порогів на основі експертних оцінок"
        ],
        correct: 0,
        expA: "Точно! Моніторинг дрифту даних та оновлення базової лінії забезпечують адаптацію до змін.",
        expB: "Статичне тестування не може виявити проблеми адаптації в мінливих середовищах.",
        expC: "Періодична оцінка може пропустити критичні зміни між циклами оцінки.",
        expD: "Ручне налаштування не масштабується і може бути суб'єктивним для складних адаптацій.",
        points: 1,
        chapter: "Методи та техніки тестування систем на основі ІІ",
        difficulty: "K2"
      },
      {
        id: 165,
        text: "Що з наведеного НАЙКРАЩЕ описує метод тестування \"назад-до-назад\"? Оберіть ОДИН варіант.",
        options: [
          "Порівняння виводу різних версій системи ІІ",
          "Зворотне відстеження помилок до навчальних даних",
          "Тестування системи у зворотному хронологічному порядку",
          "Валідація архітектури моделі від виводу до вводу"
        ],
        correct: 0,
        expA: "Правильно! Тестування \"назад-до-назад\" порівнює виводи різних реалізацій для виявлення розбіжностей.",
        expB: "Відстеження помилок - це діагностика, а не метод тестування \"назад-до-назад\".",
        expC: "Хронологічний порядок не має відношення до методу тестування \"назад-до-назад\".",
        expD: "Валідація архітектури - це структурний аналіз, а не тестування \"назад-до-назад\".",
        points: 1,
        chapter: "Методи та техніки тестування систем на основі ІІ",
        difficulty: "K2"
      },
      {
        id: 166,
        text: "Яка техніка НАЙЕФЕКТИВНІШЕ виявляє деградацію моделі в продакшен середовищі? Оберіть ОДИН варіант.",
        options: [
          "Безперервний моніторинг метрик продуктивності з попередженнями",
          "Щомісячна переоцінка моделі з тестовими наборами",
          "Порівняння з конкуруючими моделями галузі",
          "Аналіз відгуків користувачів на точність системи"
        ],
        correct: 0,
        expA: "Саме так! Безперервний моніторинг забезпечує швидке виявлення деградації та автоматичні попередження.",
        expB: "Щомісячна оцінка може пропустити швидку деградацію між циклами перевірки.",
        expC: "Галузеві порівняння не виявляють деградацію конкретної моделі в реальному часі.",
        expD: "Відгуки користувачів корисні, але можуть бути суб'єктивними та запізнілими індикаторами.",
        points: 1,
        chapter: "Методи та техніки тестування систем на основі ІІ",
        difficulty: "K2"
      },
      {
        id: 167,
        text: "Що з наведеного є ОСНОВНИМ викликом при тестуванні систем ансамблів? Оберіть ОДИН варіант.",
        options: [
          "Валідація узгодженості між множинними моделями-учасниками",
          "Тестування індивідуальної продуктивності кожного компонента",
          "Оптимізація обчислювальних ресурсів для ансамблю",
          "Документування архітектури складного ансамблевого підходу"
        ],
        correct: 0,
        expA: "Правильно! Ансамблі потребують валідації того, як множинні моделі взаємодіють та досягають узгодженості.",
        expB: "Індивідуальне тестування важливе, але основний виклик - у взаємодії між моделями.",
        expC: "Оптимізація ресурсів - це проблема реалізації, а не основний виклик тестування.",
        expD: "Документування важливе для підтримки, але не є основним викликом тестування.",
        points: 1,
        chapter: "Методи та техніки тестування систем на основі ІІ",
        difficulty: "K2"
      },
      {
        id: 168,
        text: "Яка стратегія НАЙКРАЩЕ підходить для тестування робастності в системах обробки природної мови? Оберіть ОДИН варіант.",
        options: [
          "Генерація ворожих текстових прикладів з семантичним збереженням",
          "Тестування лише з очищеними та стандартизованими вводами",
          "Фокусування на граматичній правильності вхідних даних",
          "Використання лише формальних мовних конструкцій для валідації"
        ],
        correct: 0,
        expA: "Точно! Ворожі приклади з семантичним збереженням тестують робастність до реальних атак.",
        expB: "Очищені входи не тестують робастність до зловмисних або несподіваних входів.",
        expC: "Граматична правильність не покриває всі аспекти робастності НЛП систем.",
        expD: "Формальні конструкції не відображають різноманітність реальних текстових входів.",
        points: 1,
        chapter: "Методи та техніки тестування систем на основі ІІ",
        difficulty: "K2"
      },
      {
        id: 169,
        text: "Який метод НАЙКРАЩЕ валідує пояснення, надані інтерпретованими моделями ІІ? Оберіть ОДИН варіант.",
        options: [
          "Автоматизована перевірка відповідності пояснень вихідним даним",
          "Експертна оцінка узгодженості пояснень з доменними знаннями",
          "Статистичний аналіз частоти використання різних ознак",
          "Порівняння пояснень з документацією системи та алгоритмів"
        ],
        correct: 1,
        expA: "Автоматизована перевірка може пропустити нюанси, які розуміють лише доменні експерти.",
        expB: "Правильно! Експерти домену можуть найкраще оцінити, чи є пояснення ІІ логічними та узгодженими.",
        expC: "Статистичний аналіз показує використання ознак, але не валідує якість пояснень.",
        expD: "Документація описує механізми, але не валідує якість конкретних пояснень.",
        points: 1,
        chapter: "Методи та техніки тестування систем на основі ІІ",
        difficulty: "K2"
      },
      {
        id: 170,
        text: "Яка стратегія НАЙЕФЕКТИВНІШЕ тестує системи комп'ютерного зору на стійкість до змін освітлення? Оберіть ОДИН варіант.",
        options: [
          "Синтетична генерація зображень з контрольованими змінами освітлення",
          "Збір додаткових зображень у різних природних умовах",
          "Застосування фільтрів постобробки для симуляції варіацій",
          "Використання існуючих наборів даних з різних географічних регіонів"
        ],
        correct: 0,
        expA: "Саме так! Синтетична генерація дозволяє контрольовані та систематичні тести варіацій освітлення.",
        expB: "Природні умови можуть бути непослідовними та важкими для контролю в тестуванні.",
        expC: "Фільтри постобробки можуть не точно відображати реальні варіації освітлення.",
        expD: "Існуючі набори даних можуть не покривати всі необхідні сценарії освітлення.",
        points: 2,
        chapter: "Методи та техніки тестування систем на основі ІІ",
        difficulty: "K3"
      },
      {
        id: 171,
        text: "Яка техніка НАЙКРАЩЕ підходить для валідації чесності в рекомендаційних системах? Оберіть ОДИН варіант.",
        options: [
          "Демографічний аналіз паритету з статистичним тестуванням",
          "А/Б тестування різних алгоритмічних підходів",
          "Аналіз журналів користувацької поведінки та взаємодії",
          "Порівняння з еталонними рекомендаційними системами галузі"
        ],
        correct: 0,
        expA: "Правильно! Демографічний аналіз паритету може виявити упередження та забезпечити справедливе ставлення.",
        expB: "А/Б тестування корисне для продуктивності, але не спеціально для валідації чесності.",
        expC: "Журнали поведінки показують використання, але не вимірюють справедливість безпосередньо.",
        expD: "Галузеві порівняння не забезпечують внутрішню валідацію справедливості системи.",
        points: 2,
        chapter: "Методи та техніки тестування систем на основі ІІ",
        difficulty: "K3"
      },
      {
        id: 172,
        text: "Яка стратегія НАЙКРАЩЕ вирішує тестування систем ІІ з обмеженими помічениими даними? Оберіть ОДИН варіант.",
        options: [
          "Синтетична генерація даних з валідацією доменних експертів",
          "Зменшення складності моделі для відповідності розміру даних",
          "Використання лише простих базових моделей для порівняння",
          "Відкладення тестування до збору додаткових помічених даних"
        ],
        correct: 0,
        expA: "Точно! Синтетичні дані з експертною валідацією можуть розширити тестове покриття безпечно.",
        expB: "Зменшення складності може жертвувати необхідною функціональністю для простоти тестування.",
        expC: "Базові моделі можуть не тестувати реальну складність системи, що розгортається.",
        expD: "Відкладення тестування збільшує ризики та затримує виявлення критичних проблем.",
        points: 2,
        chapter: "Методи та техніки тестування систем на основі ІІ",
        difficulty: "K3"
      },
      {
        id: 173,
        text: "Який підхід НАЙЕФЕКТИВНІШЕ тестує адаптивність систем, що навчаються в режимі онлайн? Оберіть ОДИН варіант.",
        options: [
          "Симуляція поступових змін даних з контрольними точками валідації",
          "Періодичне тестування з статичними еталонними наборами даних",
          "Порівняння з офлайн навченими моделями на тих же даних",
          "Моніторинг лише фінальних метрик продуктивності системи"
        ],
        correct: 0,
        expA: "Правильно! Симуляція поступових змін з контрольними точками відображає реальні умови онлайн навчання.",
        expB: "Статичні набори не тестують адаптивність до змінних умов онлайн навчання.",
        expC: "Офлайн порівняння не захоплюють унікальні виклики адаптації в реальному часі.",
        expD: "Лише фінальні метрики можуть пропустити проблеми адаптації під час процесу навчання.",
        points: 2,
        chapter: "Методи та техніки тестування систем на основі ІІ",
        difficulty: "K3"
      },
      {
        id: 174,
        text: "Яка техніка НАЙКРАЩЕ валідує робастність моделей до розподільчого дрифту? Оберіть ОДИН варіант.",
        options: [
          "Поступова зміна розподілу тестових даних з моніторингом деградації",
          "Випадкова вибірка з різних часових періодів для тестування",
          "Використання синтетично згенерованих даних з різними властивостями",
          "Застосування різних методів попередньої обробки до тестових даних"
        ],
        correct: 0,
        expA: "Саме так! Поступові зміни розподілу з моніторингом дозволяють контрольоване тестування робастності до дрифту.",
        expB: "Випадкова вибірка може не систематично покривати типи дрифту, які потрібно тестувати.",
        expC: "Синтетичні дані можуть не точно відображати реальні патерни розподільчого дрифту.",
        expD: "Методи попередньої обробки тестують технічні варіації, а не справжній розподільчий дрифт.",
        points: 2,
        chapter: "Методи та техніки тестування систем на основі ІІ",
        difficulty: "K3"
      },
      {
        id: 175,
        text: "Який метод НАЙЕФЕКТИВНІШЕ валідує пояснення в критичних системах ІІ? Оберіть ОДИН варіант.",
        options: [
          "Автоматизований аналіз відповідності з доменною онтологією",
          "Мультиекспертна валідація з протоколами узгодженості",
          "Порівняння з попередньо визначеними шаблонами пояснень",
          "Статистична кореляція між поясненнями та результатами"
        ],
        correct: 1,
        expA: "Автоматизований аналіз може пропустити нюанси, критичні в чутливих доменах.",
        expB: "Точно! Мультиекспертна валідація забезпечує ретельну перевірку пояснень у критичних системах.",
        expC: "Шаблони можуть бути занадто жорсткими для охоплення всіх валідних типів пояснень.",
        expD: "Статистична кореляція не валідує якість або правильність пояснень.",
        points: 2,
        chapter: "Методи та техніки тестування систем на основі ІІ",
        difficulty: "K3"
      },
      {
        id: 176,
        text: "Фінансова установа розгортає систему ІІ для виявлення шахрайства. Яка стратегія тестування НАЙКРАЩА? Оберіть ОДИН варіант.",
        options: [
          "Фокусування лише на точності виявлення відомих патернів шахрайства",
          "Комплексне тестування з ворожими прикладами та аналізом справедливості",
          "Використання лише історичних даних для валідації продуктивності",
          "Пріоритетність швидкості обробки над детальною валідацією"
        ],
        correct: 1,
        expA: "Відомі патерни недостатні - шахрайники постійно розробляють нові методи атак.",
        expB: "Правильно! Фінансові системи потребують комплексного тестування проти атак та забезпечення справедливості.",
        expC: "Історичні дані можуть не передбачати майбутні патерни шахрайства або нові атаки.",
        expD: "У фінансах точність та безпека критичніші за швидкість для запобігання втратам.",
        points: 3,
        chapter: "Методи та техніки тестування систем на основі ІІ",
        difficulty: "K4"
      },
      {
        id: 177,
        text: "Автономний автомобіль потребує тестування системи прийняття рішень. Який підхід НАЙСИСТЕМАТИЧНІШИЙ? Оберіть ОДИН варіант.",
        options: [
          "Використання лише контрольованих тестових треків з відомими сценаріями",
          "Симуляція з систематичним покриттям граничних випадків та етичних дилем",
          "Випадкове тестування у різноманітних дорожних умовах",
          "Фокусування на технічній продуктивності сенсорів та алгоритмів"
        ],
        correct: 1,
        expA: "Контрольовані треки не можуть покрити всі непередбачувані реальні сценарії.",
        expB: "Саме так! Систематична симуляція забезпечує покриття критичних граничних випадків та етичних рішень.",
        expC: "Випадкове тестування може пропустити критичні сценарії, що потребують специфічної валідації.",
        expD: "Технічна продуктивність важлива, але прийняття рішень потребує етичної та логічної валідації.",
        points: 3,
        chapter: "Методи та техніки тестування систем на основі ІІ",
        difficulty: "K4"
      },
      {
        id: 178,
        text: "Медична діагностична система ІІ потребує валідації в лікарні. Що НАЙВАЖЛИВІШЕ? Оберіть ОДИН варіант.",
        options: [
          "Швидкість обробки зображень та інтеграція з існуючими системами",
          "Клінічна валідація з лікарями та відповідність медичним стандартам",
          "Оптимізація витрат та зменшення складності розгортання",
          "Стандартні практики програмного забезпечення та документування коду"
        ],
        correct: 1,
        expA: "Швидкість та інтеграція важливі, але безпека пацієнтів потребує клінічної валідації.",
        expB: "Правильно! Медичні системи потребують клінічної валідації та відповідності регуляторним стандартам.",
        expC: "Оптимізація витрат вторинна порівняно з безпекою пацієнтів та клінічною ефективністю.",
        expD: "Стандартні практики програмного забезпечення не покривають специфічні медичні регуляторні вимоги.",
        points: 3,
        chapter: "Методи та техніки тестування систем на основі ІІ",
        difficulty: "K4"
      },
      {
        id: 179,
        text: "Система рекомендацій електронної комерції потребує тестування сезонних варіацій. Яка стратегія НАЙЕФЕКТИВНІША? Оберіть ОДИН варіант.",
        options: [
          "Використання лише аналізу патернів історичних даних",
          "Застосування адаптивного тестування з темпоральними метаморфічними відносинами",
          "Фокусування на статичному тестуванні точності рекомендацій",
          "Реалізація базових підходів А/Б тестування"
        ],
        correct: 1,
        expA: "Аналіз лише історичних даних не тестує можливості адаптації до нових сезонних патернів.",
        expB: "Ідеально! Адаптивне тестування з темпоральними метаморфічними відносинами перевіряє послідовну поведінку через сезонні зміни.",
        expC: "Статичне тестування не адресує динамічну природу сезонних змін рекомендацій.",
        expD: "Базове А/Б тестування не вирішує систематично виклики темпоральних варіацій.",
        points: 3,
        chapter: "Методи та техніки тестування систем на основі ІІ",
        difficulty: "K4"
      },
      {
        id: 180,
        text: "Мультимодальна система ІІ, що поєднує зір та мову, потребує вибору техніки тестування. Який підхід НАЙСИСТЕМАТИЧНІШИЙ? Оберіть ОДИН варіант.",
        options: [
          "Тестування кожної модальності незалежно з окремими техніками",
          "Застосування кросмодального метаморфічного тестування з валідацією інтеграції",
          "Фокусування на оптимізації продуктивності індивідуальних компонентів",
          "Використання стандартних методів тестування мультисистемної інтеграції"
        ],
        correct: 1,
        expA: "Незалежне тестування пропускає критичні взаємодії між компонентами зору та мови.",
        expB: "Відмінно! Кросмодальне метаморфічне тестування валідує узгодженість між модальностями, а інтеграційне тестування забезпечує правильну поведінку системи.",
        expC: "Оптимізація компонентів не адресує складності мультимодальної взаємодії.",
        expD: "Стандартні методи інтеграції не адресують унікальні виклики мультимодальних взаємодій ІІ.",
        points: 3,
        chapter: "Методи та техніки тестування систем на основі ІІ",
        difficulty: "K4"
      },
      {
        id: 181,
        text: "Що з наведеного є НАЙБІЛЬШ важливим при розрізненні тестових середовищ для ШІ? Оберіть ОДИН варіант.",
        options: [
          "Вимоги до ШІ-специфічних процесорів",
          "Адаптація до невизначених змін середовища", // ✓ ПРАВИЛЬНО
          "Потреби розгортання моделей машинного навчання",
          "Апаратне прискорення нейронних мереж"
        ],
        correct: 1,
        expA: "ШІ-процесори важливі, але не є основним фактором відмінності від звичайних тестових середовищ.",
        expB: "Точно! Самонавчальні системи повинні адаптуватися до змінних середовищ, не повністю визначених під час первинного розгортання (силабус Розділ 10.1).",
        expC: "Розгортання моделі є фактором, але не найкритичнішою відмінністю від звичайних систем.",
        expD: "Апаратне прискорення підтримує ШІ, але не унікально диференціює вимоги тестового середовища.",
        points: 1,
        chapter: "Тестові середовища для систем на основі ШІ",
        difficulty: "K1"
      },
      {
        id: 182,
        text: "Що з наведеного НАЙКРАЩЕ описує характеристики великих даних? Оберіть ОДИН варіант.",
        options: [
          "Структуроване зберігання реляційних даних",
          "Обробка потокових даних у реальному часі",
          "Розподілене багатоформатне оброблення даних",
          "Характеристики високого обсягу, швидкості та різноманітності" // ✓ ПРАВИЛЬНО
        ],
        correct: 3,
        expA: "Структуроване зберігання - це лише один підхід до обробки даних, а не визначальна характеристика великих даних.",
        expB: "Обробка в реальному часі є одним аспектом, але не охоплює повне визначення великих даних.",
        expC: "Розподілена обробка важлива, але не є всеосяжним описом великих даних.",
        expD: "Відмінно! Великі дані визначаються трьома V: обсяг (volume), швидкість (velocity) та різноманітність (variety).",
        points: 1,
        chapter: "Тестові середовища для систем на основі ШІ",
        difficulty: "K1"
      },
    
      // ================= ПИТАННЯ K2 (СТРАТЕГІЯ: ДОМЕН ШІ/МН З ТОНКИМИ ВІДМІННОСТЯМИ) =================
      {
        id: 183,
        text: "Яке з наведених тверджень про тестування автономних систем є ПРАВИЛЬНИМ? Оберіть ОДИН варіант.",
        options: [
          "Межове тестування з попередньо визначеними сценаріями",
          "Стрес-тестування для визначення порогів передачі керування", // ✓ ПРАВИЛЬНО
          "Тестування продуктивності за нормальних умов",
          "Інтеграційне тестування з людськими операторами"
        ],
        correct: 1,
        expA: "Попередньо визначені сценарії не охоплюють непередбачувану природу автономного прийняття рішень.",
        expB: "Правильно! Тестування автономії вимагає доведення систем до меж, щоб визначити, коли вони повинні передавати керування людям.",
        expC: "Нормальні умови не тестують критичні граничні випадки, де рішення про автономію мають найбільше значення.",
        expD: "Інтеграція важлива, але не тестує межі автономного прийняття рішень.",
        points: 1,
        chapter: "Тестові середовища для систем на основі ШІ",
        difficulty: "K2"
      },
      {
        id: 184,
        text: "Що з наведеного описує виклик пояснюваності при тестуванні ШІ? Оберіть ОДИН варіант.",
        options: [
          "Складні архітектури моделей знижують інтерпретованість",
          "Процеси прийняття рішень не мають прозорих шляхів міркування", // ✓ ПРАВИЛЬНО
          "Алгоритми \"чорної скриньки\" приховують внутрішню логіку",
          "Багаторівневі мережі приховують зв'язки між ознаками"
        ],
        correct: 1,
        expA: "Складність архітектури є фактором, але не основним викликом тестування пояснюваності.",
        expB: "Точно! Процеси прийняття рішень ШІ потребують включення інструментів пояснюваності для розуміння шляхів міркування (силабус Розділ 10.1).",
        expC: "Природа \"чорної скриньки\" є проблемою, але пояснюваність фокусується на прозорості рішень.",
        expD: "Зв'язки ознак важливі, але основна проблема - прозоре обґрунтування рішень.",
        points: 1,
        chapter: "Тестові середовища для систем на основі ШІ",
        difficulty: "K2"
      },
      {
        id: 185,
        text: "Що з наведеного є ОСНОВНОЮ перевагою віртуальних тестових середовищ? Оберіть ОДИН варіант.",
        options: [
          "Прискорене виконання циклу тестування",
          "Покращена відтворюваність сценаріїв",
          "Безпечне тестування небезпечних умов", // ✓ ПРАВИЛЬНО
          "Покращене управління тестовими даними"
        ],
        correct: 2,
        expA: "Прискорення корисне, але не є основною перевагою для тестування систем ШІ.",
        expB: "Відтворюваність цінна, але не найкритичніша перевага для сценаріїв тестування ШІ.",
        expC: "Відмінно! Віртуальні середовища дозволяють безпечне тестування небезпечних сценаріїв, неможливих у реальності.",
        expD: "Управління даними покращується, але безпечне тестування є основною перевагою віртуального середовища.",
        points: 1,
        chapter: "Тестові середовища для систем на основі ШІ",
        difficulty: "K2"
      },
      {
        id: 186,
        text: "Який з наведених сценаріїв НАЙКРАЩЕ підходить для віртуальних середовищ? Оберіть ОДИН варіант.",
        options: [
          "Симуляція реагування на ядерну катастрофу", // ✓ ПРАВИЛЬНО
          "Стандартне тестування API інтеграції",
          "Валідація транзакцій бази даних",
          "Робочі процеси автентифікації користувачів"
        ],
        correct: 0,
        expA: "Точно! Екстремальні та небезпечні сценарії як ядерні катастрофи ідеально підходять для віртуальних тестових середовищ.",
        expB: "API тестування не потребує складності та переваг безпеки віртуальних середовищ.",
        expC: "Валідація бази даних - стандартне тестування, яке не потребує можливостей віртуального середовища.",
        expD: "Робочі процеси автентифікації - рутинні тести, що не потребують складності віртуального середовища.",
        points: 1,
        chapter: "Тестові середовища для систем на основі ШІ",
        difficulty: "K2"
      },
      {
        id: 187,
        text: "Що з наведеного НАЙКРАЩЕ описує тестування мульти-агентних систем? Оберіть ОДИН варіант.",
        options: [
          "Скоординована детерміністична поведінка агентів",
          "Послідовна валідація одиночних агентів",
          "Недетерміністичні шаблони взаємодії", // ✓ ПРАВИЛЬНО
          "Спрощені протоколи комунікації"
        ],
        correct: 2,
        expA: "Детерміністична поведінка не відображає складні взаємодії в мульти-агентних системах.",
        expB: "Послідовне тестування упускає критичні аспекти одночасної взаємодії.",
        expC: "Правильно! Мульти-агентні системи потребують тестових середовищ, що включають недетерміністичні взаємодії.",
        expD: "Спрощені протоколи не охоплюють складність реальної мульти-агентної координації.",
        points: 1,
        chapter: "Тестові середовища для систем на основі ШІ",
        difficulty: "K2"
      },
      {
        id: 188,
        text: "Який фактор є НАЙБІЛЬШ важливим при плануванні апаратного забезпечення для тестового середовища ШІ? Оберіть ОДИН варіант.",
        options: [
          "Стандартні специфікації серверів",
          "Вимоги до ШІ-специфічних процесорів", // ✓ ПРАВИЛЬНО
          "Обмеження пропускної здатності мережі",
          "Оптимізація ємності зберігання"
        ],
        correct: 1,
        expA: "Стандартні специфікації можуть не підтримувати спеціалізовані вимоги обробки ШІ.",
        expB: "Правильно! ШІ-специфічні процесори як GPU та TPU слід враховувати при плануванні тестового середовища.",
        expC: "Пропускна здатність важлива, але не така критична як обчислювальна потужність для навантажень ШІ.",
        expD: "Зберігання необхідне, але ШІ-специфічна обчислювальна потужність є найкритичнішим фактором апаратного забезпечення.",
        points: 1,
        chapter: "Тестові середовища для систем на основі ШІ",
        difficulty: "K2"
      },
    
      // ================= ПИТАННЯ K3 (СТРАТЕГІЯ: ПРОФЕСІЙНІ РЕКОМЕНДАЦІЇ) =================
      {
        id: 189,
        text: "Який підхід є НАЙБІЛЬШ ефективним для тестування систем автономних транспортних засобів? Оберіть ОДИН варіант.",
        options: [
          "Симуляція реальних дорожніх умов з несподіваними подіями", // ✓ ПРАВИЛЬНО
          "Тестування лише на контрольованих тестових треках",
          "Фокус на окремих компонентах датчиків",
          "Валідація алгоритмів без апаратного забезпечення"
        ],
        correct: 0,
        expA: "Відмінно! Автономні транспортні засоби повинні бути протестовані в умовах, що імітують реальну непередбачуваність дорожнього руху.",
        expB: "Контрольовані треки не забезпечують повного спектру реальних дорожніх викликів.",
        expC: "Тестування окремих компонентів упускає критичну інтеграцію системи в цілому.",
        expD: "Валідація без апаратного забезпечення не перевіряє реальну поведінку системи.",
        points: 3,
        chapter: "Тестові середовища для систем на основі ШІ",
        difficulty: "K3"
      },
      {
        id: 190,
        text: "Яка стратегія є НАЙКРАЩОЮ для валідації самонавчальних систем? Оберіть ОДИН варіант.",
        options: [
          "Статичне тестування з фіксованими даними",
          "Динамічне тестування з адаптивними сценаріями", // ✓ ПРАВИЛЬНО
          "Лише початкова валідація після розгортання",
          "Тестування лише на історичних даних"
        ],
        correct: 1,
        expA: "Статичні дані не відображають адаптивну природу самонавчальних систем.",
        expB: "Правильно! Самонавчальні системи потребують динамічних тестових сценаріїв, що адаптуються разом із системою.",
        expC: "Початкова валідація недостатня для систем, що продовжують навчатися після розгортання.",
        expD: "Історичні дані не тестують здатність системи адаптуватися до нових ситуацій.",
        points: 3,
        chapter: "Тестові середовища для систем на основі ШІ",
        difficulty: "K3"
      },
      {
        id: 191,
        text: "Який підхід є НАЙБІЛЬШ підходящим для тестування пояснюваності в медичних системах ШІ? Оберіть ОДИН варіант.",
        options: [
          "Тестування швидкості прийняття рішень",
          "Валідація точності діагностики",
          "Фокус на зручності інтерфейсу",
          "Перевірка зрозумілості обґрунтування рішень" // ✓ ПРАВИЛЬНО
        ],
        correct: 3,
        expA: "Швидкість важлива, але не основна проблема пояснюваності в медичних системах.",
        expB: "Точність критична, але пояснюваність стосується розуміння процесу прийняття рішень.",
        expC: "Зручність інтерфейсу не адресує основні вимоги медичної пояснюваності.",
        expD: "Точно! Медичні системи ШІ повинні надавати зрозумілі пояснення своїх діагностичних рішень.",
        points: 3,
        chapter: "Тестові середовища для систем на основі ШІ",
        difficulty: "K3"
      },
      {
        id: 192,
        text: "Яка стратегія є ОПТИМАЛЬНОЮ для тестування мульти-агентних систем у фінансовій торгівлі? Оберіть ОДИН варіант.",
        options: [
          "Ізольоване тестування кожного агента окремо",
          "Тестування лише за стабільних ринкових умов",
          "Фокус на швидкості виконання транзакцій",
          "Симуляція складних ринкових взаємодій" // ✓ ПРАВИЛЬНО
        ],
        correct: 3,
        expA: "Ізольоване тестування упускає критичні взаємодії між агентами у торгівельному середовищі.",
        expB: "Стабільні умови не тестують здатність системи адаптуватися до волатильності ринку.",
        expC: "Швидкість важлива, але не тестує складну координацію між агентами.",
        expD: "Відмінно! Фінансові мульти-агентні системи потребують тестування в умовах, що імітують складну ринкову динаміку.",
        points: 3,
        chapter: "Тестові середовища для систем на основі ШІ",
        difficulty: "K3"
      },
      {
        id: 193,
        text: "Який підхід є НАЙЕФЕКТИВНІШИМ для підготовки тестових даних великого обсягу? Оберіть ОДИН варіант.",
        options: [
          "Ручне створення репрезентативних зразків",
          "Використання лише виробничих даних",
          "Застосування синтетичної генерації даних", // ✓ ПРАВИЛЬНО
          "Копіювання існуючих тестових наборів"
        ],
        correct: 2,
        expA: "Ручне створення не масштабується для тестування великих даних.",
        expB: "Виробничі дані можуть містити конфіденційну інформацію та мати обмеження використання.",
        expC: "Правильно! Синтетична генерація даних дозволяє створювати великі, різноманітні набори даних для тестування.",
        expD: "Копіювання існуючих наборів не забезпечує необхідного різноманіття для тестування великих даних.",
        points: 3,
        chapter: "Тестові середовища для систем на основі ШІ",
        difficulty: "K3"
      },
      {
        id: 194,
        text: "Яка стратегія є НАЙКРАЩОЮ для тестування еволюції ШІ-системи протягом часу? Оберіть ОДИН варіант.",
        options: [
          "Континуальне моніторування з адаптивними порогами", // ✓ ПРАВИЛЬНО
          "Щомісячне ретестування з тими самими тестами",
          "Тестування лише після основних оновлень",
          "Статичне порівняння з базовими показниками"
        ],
        correct: 0,
        expA: "Відмінно! Еволюційні системи потребують постійного моніторування з порогами, що адаптуються до змін системи.",
        expB: "Фіксовані інтервали та тести можуть пропустити критичні зміни в поведінці системи.",
        expC: "Очікування основних оновлень може пропустити поступові, але значні зміни.",
        expD: "Статичні пороги не враховують природну еволюцію системи протягом часу.",
        points: 3,
        chapter: "Тестові середовища для систем на основі ШІ",
        difficulty: "K3"
      },
    
      // ================= ПИТАННЯ K4 (СТРАТЕГІЯ: СТРАТЕГІЧНИЙ АНАЛІЗ) =================
      {
        id: 195,
        text: "Організація планує розгорнути критично важливу для безпеки систему ШІ в аерокосмічній галузі. Яка стратегія тестового середовища є НАЙКРАЩОЮ? Оберіть ОДИН варіант.",
        options: [
          "Фокус лише на симуляції нормальних польотних умов",
          "Тестування екстремальних сценаріїв з детальною верифікацією", // ✓ ПРАВИЛЬНО
          "Використання лише реальних польотних тестів",
          "Обмеження тестування програмними валідаціями"
        ],
        correct: 1,
        expA: "Нормальні умови недостатні для критично важливих для безпеки аерокосмічних систем.",
        expB: "Правильно! Аерокосмічні системи потребують всебічного тестування екстремальних умов із суворою верифікацією безпеки.",
        expC: "Реальні польотні тести небезпечні та дорогі для початкової валідації критичних систем.",
        expD: "Лише програмна валідація недостатня для систем, критично важливих для безпеки.",
        points: 4,
        chapter: "Тестові середовища для систем на основі ШІ",
        difficulty: "K4"
      },
      {
        id: 196,
        text: "Фінансовій установі потрібно протестувати систему виявлення шахрайства на основі ШІ перед розгортанням. Яка комплексна стратегія є ОПТИМАЛЬНОЮ? Оберіть ОДИН варіант.",
        options: [
          "Тестування лише на історичних випадках шахрайства",
          "Багатоступеневе тестування з синтетичними та реальними даними", // ✓ ПРАВИЛЬНО
          "Фокус виключно на метриках точності",
          "Використання лише штучно створених шахрайських транзакцій"
        ],
        correct: 1,
        expA: "Лише історичні дані не підготують систему до нових типів шахрайства.",
        expB: "Відмінно! Виявлення шахрайства потребує багатоступеневого підходу з різноманітними даними для забезпечення надійності.",
        expC: "Точність важлива, але недостатня без врахування коефіцієнтів помилок та справедливості.",
        expD: "Лише синтетичні дані можуть не відображати складність реального шахрайства.",
        points: 4,
        chapter: "Тестові середовища для систем на основі ШІ",
        difficulty: "K4"
      },
      {
        id: 197,
        text: "Компанія розробляє автономну систему керування складом з декількома роботами. Яка стратегія тестування є НАЙБІЛЬШ всеосяжною? Оберіть ОДИН варіант.",
        options: [
          "Тестування кожного робота індивідуально",
          "Фокус лише на алгоритмах планування шляхів",
          "Комплексне тестування координації з моделюванням збоїв", // ✓ ПРАВИЛЬНО
          "Валідація лише програмного забезпечення без апаратного забезпечення"
        ],
        correct: 2,
        expA: "Індивідуальне тестування упускає критичну координацію між роботами у складському середовищі.",
        expB: "Планування шляхів - лише один аспект складної автономної системи складу.",
        expC: "Правильно! Автономні склади потребують тестування координації з моделюванням реальних збоїв та перешкод.",
        expD: "Програмна валідація без апаратного забезпечення не тестує реальні фізичні взаємодії.",
        points: 4,
        chapter: "Тестові середовища для систем на основі ШІ",
        difficulty: "K4"
      },
      {
        id: 198,
        text: "Велика технологічна компанія планує розгорнути платформу рекомендацій на основі ШІ для мільйонів користувачів. Яка стратегія тестування є НАЙСТРАТЕГІЧНІШОЮ? Оберіть ОДИН варіант.",
        options: [
          "Тестування лише на невеликій підмножині користувачів",
          "Фокус виключно на метриках точності рекомендацій",
          "Використання лише А/Б тестування у виробництві",
          "Поетапне тестування з моніторингом упередженості та справедливості" // ✓ ПРАВИЛЬНО
        ],
        correct: 3,
        expA: "Невелика підмножина може не представляти різноманітність мільйонів користувачів.",
        expB: "Точність важлива, але недостатня без врахування справедливості та етичних міркувань.",
        expC: "Лише виробниче А/Б тестування ризикує негативним впливом на користувачів.",
        expD: "Відмінно! Великомасштабні системи рекомендацій потребують поетапного підходу з етичними міркуваннями.",
        points: 4,
        chapter: "Тестові середовища для систем на основі ШІ",
        difficulty: "K4"
      },
      {
        id: 199,
        text: "Сільськогосподарська компанія розробляє систему ШІ для управління флотом автономних тракторів. Яка стратегія тестового середовища є НАЙКОМПЛЕКСНІШОЮ? Оберіть ОДИН варіант.",
        options: [
          "Різноманітні сценарії з варіаціями погоди та ґрунту", // ✓ ПРАВИЛЬНО
          "Тестування лише за ідеальних погодних умов",
          "Фокус на індивідуальному тестуванні тракторів",
          "Використання лише історичних сільськогосподарських даних"
        ],
        correct: 0,
        expA: "Відмінно! Сільськогосподарська ШІ потребує різноманітних сценаріїв для тестування адаптації до середовища та мульти-агентної координації.",
        expB: "Ідеальні умови не тестують здатність системи адаптуватися та координуватися за складних реальних умов.",
        expC: "Індивідуальне тестування упускає критичні аспекти координації, необхідні для мульти-агентних сільськогосподарських систем.",
        expD: "Історичні дані не тестують здатність системи адаптуватися до нових умов та координувати відповіді агентів.",
        points: 4,
        chapter: "Тестові середовища для систем на основі ШІ",
        difficulty: "K4"
      },
      {
        id: 200,
        text: "Медична установа впроваджує систему підтримки прийняття рішень на основі ШІ для діагностики. Яка стратегія валідації є НАЙВІДПОВІДНІШОЮ? Оберіть ОДИН варіант.",
        options: [
          "Багатоінституційна валідація з різноманітними популяціями пацієнтів", // ✓ ПРАВИЛЬНО
          "Тестування лише на даних однієї лікарні",
          "Фокус виключно на технічній точності",
          "Валідація лише на синтетичних медичних даних"
        ],
        correct: 0,
        expA: "Правильно! Медичні системи ШІ потребують валідації в різних клінічних середовищах для забезпечення узагальнення.",
        expB: "Дані однієї лікарні можуть не представляти різноманітність пацієнтів та клінічних практик.",
        expC: "Технічна точність необхідна, але недостатня без клінічної валідації та врахування упередженості.",
        expD: "Синтетичні дані можуть не охопити складність реальних медичних випадків та варіацій пацієнтів.",
        points: 4,
        chapter: "Тестові середовища для систем на основі ШІ",
        difficulty: "K4"
      },
      {
        id: 201,
        text: "Яке з наведених тверджень НАЙКРАЩЕ пояснює використання ШІ у візуальному тестуванні? Оберіть ОДИН варіант.",
        options: [
          "Комп'ютерний зір аналізує розташування UI компонентів",
          "ШІ автоматично порівнює елементи GUI", // ✓ ПРАВИЛЬНО
          "Машинне навчання валідує візуальну узгодженість",
          "Нейронні мережі виявляють аномалії макету"
        ],
        correct: 1,
        expA: "Аналіз розташування компонентів - один аспект, але не охоплює повний обсяг ШІ візуального тестування.",
        expB: "Точно! ШІ візуальне тестування використовує машинне навчання для автоматичного порівняння GUI елементів та виявлення візуальних відмінностей на різних екранах і пристроях.",
        expC: "Валідація візуальної узгодженості важлива, але не є всеосяжним поясненням ШІ візуального тестування.",
        expD: "Виявлення аномалій макету цінне, але представляє лише одне застосування ШІ у візуальному тестуванні.",
        points: 1,
        chapter: "Використання ШІ для тестування",
        difficulty: "K2"
      },
      {
        id: 202,
        text: "Що з наведеного НАЙБІЛЬШ імовірно використовується для тестування графічного інтерфейсу? Оберіть ОДИН варіант.",
        options: [
          "Оптимізація регресійних тестів",
          "Моделювання прогнозування дефектів",
          "Верифікація візуального макету", // ✓ ПРАВИЛЬНО
          "Моніторинг продуктивності"
        ],
        correct: 2,
        expA: "Оптимізація регресії управляє наборами тестів у різних застосуваннях ШІ-тестування, а не конкретно тестуванням GUI.",
        expB: "Прогнозування дефектів ідентифікує потенційні помилки за допомогою ШІ, але не тестує функціональність GUI інтерфейсу.",
        expC: "Відмінно! Верифікація візуального макету є ключовою технікою тестування GUI, що використовує комп'ютерний зір ШІ.",
        expD: "Моніторинг продуктивності відстежує метрики системи, а не функціональність тестування GUI.",
        points: 1,
        chapter: "Використання ШІ для тестування",
        difficulty: "K1"
      },
      {
        id: 203,
        text: "Яке з наведених тверджень про ШІ технології для тестування є ПРАВИЛЬНИМ? Оберіть ОДИН варіант.",
        options: [
          "Машинне навчання ефективно категоризує шаблони дефектів", // ✓ ПРАВИЛЬНО
          "ШІ доповнює ручне тестування автоматизованим аналізом",
          "Алгоритми класифікації ідентифікують рівні критичності дефектів",
          "Нейронні мережі прогнозують ймовірність появи дефектів"
        ],
        correct: 0,
        expA: "Правильно! Машинне навчання ефективно категоризує та класифікує різні типи дефектів на основі шаблонів та історичних даних.",
        expB: "Доповнення ШІ цінне, але не адресує конкретно можливість категоризації, що тестується.",
        expC: "Ідентифікація критичності - одне застосування, але не таке всеосяжне як категоризація шаблонів.",
        expD: "Прогнозування дефектів важливе, але категоризація шаблонів більш фундаментальна для ШІ тестування.",
        points: 1,
        chapter: "Використання ШІ для тестування",
        difficulty: "K2"
      },
      {
        id: 204,
        text: "Що з наведеного НАЙКРАЩЕ описує аналіз дефектів за допомогою ШІ? Оберіть ОДИН варіант.",
        options: [
          "Автоматизоване дослідження першопричин",
          "Розпізнавання шаблонів у даних дефектів", // ✓ ПРАВИЛЬНО
          "Інтелектуальна оцінка критичності дефектів",
          "Прогнозний аналіз трендів дефектів"
        ],
        correct: 1,
        expA: "Дослідження першопричин - одне застосування, але не охоплює фундаментальну можливість ШІ аналізу.",
        expB: "Точно! Розпізнавання шаблонів у даних дефектів є основною можливістю, що дозволяє аналіз за допомогою ШІ.",
        expC: "Оцінка критичності цінна, але розпізнавання шаблонів більш фундаментальне для ШІ аналізу.",
        expD: "Аналіз трендів важливий, але розпізнавання шаблонів формує основу для всього ШІ аналізу дефектів.",
        points: 1,
        chapter: "Використання ШІ для тестування",
        difficulty: "K2"
      },
      {
        id: 205,
        text: "Який фактор є НАЙКРИТИЧНІШИМ для ефективної генерації тест-кейсів ШІ? Оберіть ОДИН варіант.",
        options: [
          "Вдосконалені алгоритми машинного навчання",
          "Всеосяжні історичні дані тестування", // ✓ ПРАВИЛЬНО
          "Високопродуктивні обчислювальні ресурси",
          "Обширний внесок доменних експертів"
        ],
        correct: 1,
        expA: "Вдосконалені алгоритми цінні, але потребують якісних даних для ефективності.",
        expB: "Відмінно! Всеосяжні історичні дані тестування забезпечують фундамент для значущої ШІ генерації тестів.",
        expC: "Обчислювальні ресурси забезпечують обробку, але не визначають якість генерації.",
        expD: "Внесок експертів корисний, але всеосяжні дані більш фундаментальні для навчання ШІ.",
        points: 1,
        chapter: "Використання ШІ для тестування",
        difficulty: "K2"
      },
      {
        id: 206,
        text: "Який підхід є НАЙЕФЕКТИВНІШИМ для ШІ-вибору регресійних тестів? Оберіть ОДИН варіант.",
        options: [
          "Аналіз впливу з ризик-орієнтованою пріоритизацією", // ✓ ПРАВИЛЬНО
          "Випадкова вибірка з набору тестів",
          "Хронологічне упорядкування виконання тестів",
          "Рівномірний розподіл по категоріях тестів"
        ],
        correct: 0,
        expA: "Відмінно! Аналіз впливу з ризик-орієнтованою пріоритизацією забезпечує найефективніший ШІ відбір регресійних тестів.",
        expB: "Випадкова вибірка не використовує ШІ аналітичні можливості для інтелектуального відбору тестів.",
        expC: "Хронологічне упорядкування ігнорує важливість та релевантність тестів для поточних змін.",
        expD: "Рівномірний розподіл не враховує ризики та потенційний вплив різних тестових сценаріїв.",
        points: 1,
        chapter: "Використання ШІ для тестування",
        difficulty: "K2"
      },
      {
        id: 207,
        text: "Що є НАЙБІЛЬШ важливим для успішного ШІ візуального тестування? Оберіть ОДИН варіант.",
        options: [
          "Алгоритми розпізнавання зображень",
          "Встановлення базової лінії з налаштовуваними порогами", // ✓ ПРАВИЛЬНО
          "Розпізнавання об'єктів з машинним навчанням",
          "Оцінка подібності з адаптивними метриками"
        ],
        correct: 1,
        expA: "Алгоритми розпізнавання цінні, але встановлення базової лінії більш фундаментальне для успіху.",
        expB: "Відмінно! Встановлення базових ліній з налаштовуваними порогами забезпечує фундамент для ефективного ШІ візуального тестування.",
        expC: "Розпізнавання об'єктів цінне, але конфігурація базової лінії більш фундаментальна для успіху впровадження.",
        expD: "Оцінка подібності важлива, але правильне встановлення базової лінії критичніше для впровадження.",
        points: 1,
        chapter: "Використання ШІ для тестування",
        difficulty: "K2"
      },
      {
        id: 208,
        text: "Який фактор є НАЙБІЛЬШ важливим при плануванні ШІ апаратного забезпечення тестового середовища? Оберіть ОДИН варіант.",
        options: [
          "Стандартні специфікації серверів",
          "ШІ-специфічні вимоги процесорів", // ✓ ПРАВИЛЬНО
          "Обмеження пропускної здатності мережі",
          "Оптимізація ємності зберігання"
        ],
        correct: 1,
        expA: "Стандартні специфікації можуть не підтримувати спеціалізовані вимоги обробки ШІ.",
        expB: "Правильно! ШІ-специфічні процесори як GPU та TPU слід враховувати при плануванні тестового середовища.",
        expC: "Пропускна здатність важлива, але не така критична як обчислювальна потужність для навантажень ШІ.",
        expD: "Зберігання необхідне, але ШІ-специфічна обчислювальна потужність є найкритичнішим фактором апаратного забезпечення.",
        points: 1,
        chapter: "Використання ШІ для тестування",
        difficulty: "K2"
      },
      {
        id: 209,
        text: "Яка ШІ технологія є НАЙБІЛЬШ підходящою для кластеризації тест-кейсів? Оберіть ОДИН варіант.",
        options: [
          "Алгоритми контрольованої класифікації",
          "Системи навчання з підкріпленням",
          "Напівконтрольовані моделі навчання",
          "Неконтрольовані алгоритми кластеризації" // ✓ ПРАВИЛЬНО
        ],
        correct: 3,
        expA: "Контрольована класифікація потребує мічених даних та попередньо визначених категорій, обмежуючи гнучкість кластеризації.",
        expB: "Навчання з підкріпленням призначене для сценаріїв прийняття рішень, а не для застосувань групування даних.",
        expC: "Напівконтрольовані моделі можуть допомогти, але неконтрольовані підходи краще виявляють природні групування тестів.",
        expD: "Точно! Неконтрольовані алгоритми кластеризації знаходять природні групування в тест-кейсах без попередньо визначених категорій.",
        points: 1,
        chapter: "Використання ШІ для тестування",
        difficulty: "K2"
      },
    
      // ================= ПИТАННЯ K3 (СТРАТЕГІЯ: ПРОФЕСІЙНІ РЕКОМЕНДАЦІЇ) =================
      {
        id: 210,
        text: "Який підхід є НАЙЕФЕКТИВНІШИМ для впровадження ШІ аналізу дефектів? Оберіть ОДИН варіант.",
        options: [
          "Всеосяжний збір та попередня обробка даних", // ✓ ПРАВИЛЬНО
          "Вдосконалена реалізація алгоритмів з базовими моделями",
          "Інтеграція аналізу в реальному часі з історичною валідацією",
          "Автоматизований аналіз збалансований з ручною верифікацією"
        ],
        correct: 0,
        expA: "Розумний підхід! Якісний збір та попередня обробка даних є основою для успішного ШІ аналізу дефектів.",
        expB: "Вдосконалені алгоритми цінні, але потребують міцного фундаменту даних для значущих результатів.",
        expC: "Інтеграція в реальному часі важлива, але всеосяжна підготовка даних більш фундаментальна.",
        expD: "Збалансований аналіз - хороша практика, але якість даних є передумовою для будь-якого ефективного аналізу.",
        points: 2,
        chapter: "Використання ШІ для тестування",
        difficulty: "K3"
      },
      {
        id: 211,
        text: "Який підхід є НАЙКРАЩИМ для ШІ візуального тестування мобільних застосунків? Оберіть ОДИН варіант.",
        options: [
          "Встановлення базової лінії одного пристрою",
          "Конфігурація та валідація міжпристроєвих базових ліній", // ✓ ПРАВИЛЬНО
          "Інтеграція функціонального тестування з візуальними перевірками",
          "Тестування за розширенням з адаптивним масштабуванням"
        ],
        correct: 1,
        expA: "Тестування одного пристрою упускає критичні варіації, що виникають на різних мобільних пристроях.",
        expB: "Відмінно! Конфігурація міжпристроєвих базових ліній забезпечує візуальну узгодженість у всій екосистемі пристроїв.",
        expC: "Інтеграція цінна, але встановлення пристрій-специфічних базових ліній критичніше для мобільного тестування.",
        expD: "Адаптація розширення важлива, але всеосяжна міжпристроєва валідація ефективніша.",
        points: 2,
        chapter: "Використання ШІ для тестування",
        difficulty: "K3"
      },
      {
        id: 212,
        text: "Який фактор є НАЙВАЖЛИВІШИМ для успішної ШІ генерації тест-кейсів? Оберіть ОДИН варіант.",
        options: [
          "Вибір вдосконалених ШІ алгоритмів",
          "Всеосяжні вимоги та історичні дані", // ✓ ПРАВИЛЬНО
          "Генерація максимальної кількості тест-кейсів",
          "Автоматизована генерація з людською валідацією"
        ],
        correct: 1,
        expA: "Вдосконалені алгоритми цінні, але потребують всеосяжних вхідних даних для генерації значущих тест-кейсів.",
        expB: "Відмінно! Якісні вимоги та історичні дані дозволяють ШІ генерувати релевантні та цінні тест-кейси.",
        expC: "Фокус на кількість без якісних вимог та даних призводить до генерації нерелевантних тест-кейсів.",
        expD: "Людська валідація важлива, але всеосяжні вхідні дані більш фундаментальні для успіху генерації.",
        points: 2,
        chapter: "Використання ШІ для тестування",
        difficulty: "K3"
      },
      {
        id: 213,
        text: "Який підхід є НАЙЕФЕКТИВНІШИМ для ШІ оптимізації регресійних тестів? Оберіть ОДИН варіант.",
        options: [
          "Аналіз історичних дефектів з оцінкою впливу",
          "Аналіз ефективності інтегрований з оцінкою впливу змін", // ✓ ПРАВИЛЬНО
          "Оптимізація швидкості виконання з підтримкою покриття",
          "Скорочення набору тестів збалансоване з аналізом ризиків"
        ],
        correct: 1,
        expA: "Історичний аналіз цінний, але інтегрована оцінка ефективності та змін більш всеосяжна.",
        expB: "Правильно! Аналіз як ефективності, так і впливу змін дозволяє інтелектуальні рішення оптимізації для регресійного тестування.",
        expC: "Оптимізація швидкості важлива, але аналіз ефективності критичніший для значущої оптимізації.",
        expD: "Збалансоване скорочення ризиків гарне, але всеосяжна оцінка ефективності ефективніша для оптимізації.",
        points: 2,
        chapter: "Використання ШІ для тестування",
        difficulty: "K3"
      },
      {
        id: 214,
        text: "Який сценарій НАЙБІЛЬШЕ виграє від ШІ прогнозування дефектів? Оберіть ОДИН варіант.",
        options: [
          "Greenfield проекти з мінімальними історичними даними",
          "Застарілі системи з всеосяжними історичними наборами даних", // ✓ ПРАВИЛЬНО
          "Високоякісні системи з мінімальною історією дефектів",
          "Agile проекти з часто змінними вимогами"
        ],
        correct: 1,
        expA: "Greenfield проекти не мають фундаменту історичних даних, необхідного для ефективних ШІ моделей прогнозування.",
        expB: "Точно! Застарілі системи з багатими історичними даними забезпечують оптимальний фундамент для ШІ прогнозування дефектів.",
        expC: "Високоякісні системи з мінімальними дефектами надають недостатньо даних для значущого навчання моделі прогнозування.",
        expD: "Часто змінні вимоги роблять історичні шаблони менш надійними для точного прогнозування дефектів.",
        points: 2,
        chapter: "Використання ШІ для тестування",
        difficulty: "K3"
      },
      {
        id: 215,
        text: "Який підхід НАЙЙМОВІРНІШЕ зменшить кількість хибних спрацьовувань у ШІ GUI тестуванні? Оберіть ОДИН варіант.",
        options: [
          "Покращені навчальні дані з прикладами граничних випадків",
          "Уточнені базові лінії з налаштованими порогами виявлення", // ✓ ПРАВИЛЬНО
          "Динамічне налаштування порогів з алгоритмами навчання",
          "Статистична фільтрація з технікам зменшення шуму"
        ],
        correct: 1,
        expA: "Покращене навчання допомагає, але уточнені базові лінії безпосередньо адресують хибні спрацьовування через пороги.",
        expB: "Розумно! Уточнені базові лінії встановлюють правильні пороги варіацій, допомагаючи ШІ розрізняти справжні проблеми від нормальних варіацій.",
        expC: "Динамічне налаштування прогресивне, але уточнення базової лінії більш фундаментальне для зменшення хибних спрацьовувань.",
        expD: "Статистична фільтрація допомагає, але налаштування порогів базової лінії безпосередньо націлене на першопричину.",
        points: 2,
        chapter: "Використання ШІ для тестування",
        difficulty: "K3"
      },
    
      // ================= ПИТАННЯ K4 (СТРАТЕГІЯ: СТРАТЕГІЧНИЙ АНАЛІЗ) =================
      {
        id: 216,
        text: "Який підхід є НАЙКРАЩИМ для управління ризиками ШІ тестування у фінансових послугах? Оберіть ОДИН варіант.",
        options: [
          "Повна автоматизація з ШІ-рішеннями",
          "Впровадження ШІ з всеосяжним людським наглядом", // ✓ ПРАВИЛЬНО
          "Обмеження ШІ некритичними компонентами системи",
          "Уникання ШІ через регуляторну складність"
        ],
        correct: 1,
        expA: "Повна автоматизація без нагляду створює неприйнятний ризик у сильно регульованих фінансових послугах.",
        expB: "Відмінно! Балансування ШІ можливостей з людським наглядом забезпечує переваги при управлінні ризиками у фінансових послугах.",
        expC: "Обмеження ШІ некритичними компонентами упускає значні переваги в критичних фінансових застосуннях.",
        expD: "Повне уникання ШІ не є стратегічним - контрольоване впровадження з наглядом краще.",
        points: 3,
        chapter: "Використання ШІ для тестування",
        difficulty: "K4"
      },
      {
        id: 217,
        text: "Яка стратегія є ОПТИМАЛЬНОЮ для ШІ тестування у великомасштабному e-commerce середовищі? Оберіть ОДИН варіант.",
        options: [
          "Поетапне впровадження з моніторингом продуктивності", // ✓ ПРАВИЛЬНО
          "Повне впровадження ШІ з мінімальним людським втручанням",
          "Обмежена автоматизація з ручним контролем якості",
          "Гібридний підхід з частковою ШІ інтеграцією"
        ],
        correct: 0,
        expA: "Розумна стратегія! Поетапне впровадження дозволяє контрольоване масштабування з валідацією на кожному етапі.",
        expB: "Повне впровадження без поетапної валідації ризикує порушенням критичних e-commerce операцій.",
        expC: "Обмежена автоматизація не використовує повний потенціал ШІ для великомасштабних операцій.",
        expD: "Гібридні підходи можуть бути ефективними, але поетапне впровадження більш структуроване та керовановане.",
        points: 3,
        chapter: "Використання ШІ для тестування",
        difficulty: "K4"
      },
      {
        id: 218,
        text: "Яка стратегія є НАЙБІЛЬШ ефективною для ШІ візуального тестування в мультиплатформному середовищі? Оберіть ОДИН варіант.",
        options: [
          "Незалежне тестування кожної платформи окремо",
          "Централізоване тестування з адаптацією до конкретного контексту",
          "Кросплатформне візуальне порівняння з уніфікованими стандартами", // ✓ ПРАВИЛЬНО
          "Платформо-специфічне тестування з окремими командами"
        ],
        correct: 2,
        expA: "Незалежне тестування може пропустити проблеми узгодженості між платформами.",
        expB: "Централізоване тестування корисне, але кросплатформне порівняння адресує основний виклик мультиплатформності.",
        expC: "Точно правильно! Кросплатформне візуальне порівняння є основним для забезпечення узгодженого користувацького досвіду на різних платформах і пристроях.",
        expD: "Підтримка браузерів важлива, але можливість візуального порівняння на платформах адресує ширший виклик тестування.",
        points: 3,
        chapter: "Використання ШІ для тестування",
        difficulty: "K4"
      },
      {
        id: 219,
        text: "Який підхід є НАЙСТРАТЕГІЧНІШИМ для ШІ прогнозування дефектів у DevOps середовищі? Оберіть ОДИН варіант.",
        options: [
          "Інтеграція в pipeline з безперервною валідацією моделі",
          "Окремий аналіз з періодичними звітами",
          "Реактивне прогнозування після виявлення дефектів", // ✓ ПРАВИЛЬНО
          "Ручне прогнозування з ШІ підтримкою"
        ],
        correct: 2,
        expA: "Pipeline інтеграція цінна, але адаптивне прогнозування краще відповідає динамічному DevOps середовищу.",
        expB: "Періодичний аналіз занадто повільний для швидкого темпу DevOps розробки.",
        expC: "Правильно! Адаптивні техніки тестування з автоматизованим виявленням дрейфу дозволяють ефективну валідацію систем ШІ, що еволюціонують у продукції.",
        expD: "Одноразове тестування не може адресувати постійні зміни та дрейф, що відбуваються в продукційних системах ШІ.",
        points: 3,
        chapter: "Використання ШІ для тестування",
        difficulty: "K4"
      },
      {
        id: 220,
        text: "Яка стратегія управління є НАЙКРАЩОЮ для ШІ тестувальних ініціатив в організації? Оберіть ОДИН варіант.",
        options: [
          "Децентралізований підхід з автономними командами",
          "Центральне управління з контекст-специфічною адаптацією", // ✓ ПРАВИЛЬНО
          "Гібридний підхід з частковою координацією",
          "Повна централізація з стандартизованими процесами"
        ],
        correct: 1,
        expA: "Децентралізовані підходи можуть створити неузгодженість та зменшити обмін знаннями між організаційними командами.",
        expB: "Відмінно! Центральне управління забезпечує узгодженість, а контекст-специфічна адаптація дозволяє командам оптимізувати під свої потреби.",
        expC: "Децентралізовані підходи можуть створити неузгодженість та зменшене обмінування знаннями між організаційними командами.",
        expD: "Гібридні підходи концептуально хороші, але центральне управління з адаптацією більш структуроване та ефективне.",
        points: 3,
        chapter: "Використання ШІ для тестування",
        difficulty: "K4"
      },
      {
        id: 222,
        text: "Який з наступних варіантів є прикладом Супер ШІ? Оберіть ОДИН варіант.",
        options: [
          "ШІ-система з людським рівнем продуктивності в кількох доменах",
          "ШІ-система з загальним інтелектом понад людську спроможність", // ✓ ПРАВИЛЬНО
          "ШІ-система з передовим навчанням у спеціалізованих технічних сферах",
          "ШІ-система з адаптивним інтелектом у когнітивних завданнях"
        ],
        correct: 1,
        expA: "Це описує Штучний Загальний Інтелект (ШЗІ), а не Супер ШІ, який перевершує людські можливості.",
        expB: "Правильно! Супер ШІ перевершуватиме людський інтелект у всіх когнітивних доменах та здібностях.",
        expC: "Передове спеціалізоване навчання описує вузький ШІ, а не ширшу концепцію Супер ШІ.",
        expD: "Адаптивний інтелект характерний для загального ШІ, але Супер ШІ передбачає вищу спроможність.",
        points: 1,
        chapter: "Вступ до штучного інтелекту",
        difficulty: "K1"
      },
      {
        id: 224,
        text: "Який з наступних фреймворків розробки зазвичай використовується для впровадження ШІ? Оберіть ОДИН варіант.",
        options: [
          "Scikit-learn для традиційних алгоритмів машинного навчання",
          "Keras для швидкої розробки нейронних мереж",
          "PyTorch для дослідницьких та промислових ШІ-систем", // ✓ ПРАВИЛЬНО
          "XGBoost для реалізацій градієнтного бустингу"
        ],
        correct: 2,
        expA: "Scikit-learn цінний для традиційного МН, але більш обмежений для застосунків глибокого навчання.",
        expB: "Keras відмінний для нейронних мереж, але тепер інтегрований у TensorFlow.",
        expC: "Правильно! PyTorch широко використовується як для дослідження ШІ, так і для промислових впроваджень.",
        expD: "XGBoost спеціалізується на градієнтному бустингу, а не на загальній розробці ШІ.",
        points: 1,
        chapter: "Вступ до штучного інтелекту",
        difficulty: "K1"
      },
    
      // ================= ПИТАННЯ К2 (СТРАТЕГІЯ: ДОМЕН ШІ/МН З ТОНКИМИ ВІДМІННОСТЯМИ) =================
      {
        id: 221,
        text: "Що НАЙКРАЩЕ описує ШІ та машинне навчання? Оберіть ОДИН варіант.",
        options: [
          "Машинне навчання та ШІ - це абсолютно непов'язані концепції",
          "Машинне навчання є підмножиною штучного інтелекту", // ✓ ПРАВИЛЬНО
          "ШІ є підмножиною машинного навчання",
          "Машинне навчання та ШІ - це ідентичні терміни"
        ],
        correct: 1,
        expA: "Машинне навчання та ШІ безумовно пов'язані - МН фактично є частиною ШІ.",
        expB: "Точно! Машинне навчання - одна з технологій, що використовуються для реалізації ШІ-систем.",
        expC: "Це навпаки - ШІ є ширшою галуззю, яка включає МН як один з підходів.",
        expD: "Хоча пов'язані, ці терміни мають різні значення в галузі.",
        points: 1,
        chapter: "Вступ до штучного інтелекту",
        difficulty: "K2"
      },
      {
        id: 223,
        text: "Чому традиційні системи менше схильні до непередбачуваних поведінкових змін порівняно з ШІ-системами? Оберіть ОДИН варіант.",
        options: [
          "Традиційні системи мають кращий контроль версій",
          "Традиційні системи використовують більш стабільні алгоритми",
          "Традиційні системи слідують детермінованій програмній логіці", // ✓ ПРАВИЛЬНО
          "Традиційні системи мають простіші архітектури"
        ],
        correct: 2,
        expA: "Контроль версій стосується управління кодом, а не передбачуваності поведінки системи.",
        expB: "Стабільність алгоритмів не є основною відмінністю між традиційними та ШІ-системами.",
        expC: "Правильно! Традиційні системи слідують заздалегідь визначеним правилам, що забезпечує передбачуваність.",
        expD: "Складність архітектури не визначає передбачуваність поведінки системи.",
        points: 1,
        chapter: "Вступ до штучного інтелекту",
        difficulty: "K2"
      },
      {
        id: 225,
        text: "Що є основною перевагою вузького ШІ над загальним ШІ у сучасних застосуваннях? Оберіть ОДИН варіант.",
        options: [
          "Вузький ШІ забезпечує вищу продуктивність у спеціалізованих завданнях", // ✓ ПРАВИЛЬНО
          "Вузький ШІ потребує менше обчислювальних ресурсів",
          "Вузький ШІ легше інтегрувати з існуючими системами",
          "Вузький ШІ має кращі можливості навчання"
        ],
        correct: 0,
        expA: "Точно! Вузький ШІ оптимізований для конкретних задач і досягає відмінних результатів у своїй сфері.",
        expB: "Потреба в ресурсах залежить від конкретної реалізації, а не від типу ШІ.",
        expC: "Простота інтеграції залежить від архітектури системи, а не від типу ШІ.",
        expD: "Можливості навчання не є основною перевагою вузького ШІ над загальним.",
        points: 1,
        chapter: "Вступ до штучного інтелекту",
        difficulty: "K2"
      },
      {
        id: 226,
        text: "Яка ключова відмінність між керованим та некерованим навчанням? Оберіть ОДИН варіант.",
        options: [
          "Кероване навчання потребує більше даних для тренування",
          "Кероване навчання використовує складніші алгоритми",
          "Кероване навчання використовує мічені дані для тренування", // ✓ ПРАВИЛЬНО
          "Кероване навчання забезпечує кращу точність прогнозів"
        ],
        correct: 2,
        expA: "Кількість даних залежить від конкретної задачі, а не від типу навчання.",
        expB: "Складність алгоритмів не визначається типом навчання (керованим чи некерованим).",
        expC: "Правильно! Кероване навчання використовує дані з відомими правильними відповідями (мітками).",
        expD: "Точність залежить від якості даних та алгоритму, а не лише від типу навчання.",
        points: 1,
        chapter: "Вступ до штучного інтелекту",
        difficulty: "K2"
      },
      {
        id: 227,
        text: "Що робить глибоке навчання особливо ефективним для обробки зображень? Оберіть ОДИН варіант.",
        options: [
          "Воно автоматично ідентифікує найкращі алгоритми стиснення",
          "Воно автоматично вивчає ієрархічні особливості зображень", // ✓ ПРАВИЛЬНО
          "Воно потребує менше обчислювальної потужності",
          "Воно працює з необробленими пікселями без попередньої обробки"
        ],
        correct: 1,
        expA: "Глибоке навчання фокусується на розпізнаванні образів, а не на стисненні зображень.",
        expB: "Точно! Глибоке навчання автоматично виявляє складні візуальні паттерни та особливості.",
        expC: "Глибоке навчання зазвичай потребує значних обчислювальних ресурсів.",
        expD: "Хоча може працювати з сирими даними, основна перевага - у вивченні особливостей.",
        points: 1,
        chapter: "Вступ до штучного інтелекту",
        difficulty: "K2"
      },
      {
        id: 228,
        text: "Чому пояснюваність важлива в ШІ-системах для охорони здоров'я? Оберіть ОДИН варіант.",
        options: [
          "Вона покращує швидкість обробки медичних зображень",
          "Вона зменшує вартість медичного обладнання",
          "Вона дозволяє оптимізувати алгоритми навчання",
          "Вона забезпечує довіру та регуляторну відповідність" // ✓ ПРАВИЛЬНО
        ],
        correct: 3,
        expA: "Пояснюваність стосується розуміння рішень, а не швидкості обробки.",
        expB: "Пояснюваність не впливає безпосередньо на вартість обладнання.",
        expC: "Хоча може допомогти в оптимізації, основна цінність - у довірі та відповідності.",
        expD: "Правильно! Лікарі та регулятори потребують розуміння того, як ШІ приймає медичні рішення.",
        points: 1,
        chapter: "Вступ до штучного інтелекту",
        difficulty: "K2"
      },
      {
        id: 229,
        text: "Що найкраще описує роль даних у машинному навчанні? Оберіть ОДИН варіант.",
        options: [
          "Дані використовуються лише для тестування готових моделей",
          "Дані є основою для навчання та покращення моделей", // ✓ ПРАВИЛЬНО
          "Дані потрібні лише для ініціалізації алгоритмів",
          "Дані використовуються для зберігання результатів обробки"
        ],
        correct: 1,
        expA: "Дані використовуються не лише для тестування, але й для навчання моделей.",
        expB: "Точно! Якість та кількість даних критично впливають на ефективність МН-моделей.",
        expC: "Дані необхідні протягом усього процесу навчання, а не лише для ініціалізації.",
        expD: "Зберігання результатів - це лише одна з багатьох функцій даних у МН.",
        points: 1,
        chapter: "Вступ до штучного інтелекту",
        difficulty: "K2"
      },
    
      // ================= ПИТАННЯ К3 (СТРАТЕГІЯ: ПРОФЕСІЙНІ РЕКОМЕНДАЦІЇ) =================
      {
        id: 230,
        text: "Команда розробляє ШІ-систему для автономних транспортних засобів. Який підхід найкраще забезпечить безпеку в критичних сценаріях? Оберіть ОДИН варіант.",
        options: [
          "Реалізувати резервні системи безпеки для критичних функцій", // ✓ ПРАВИЛЬНО
          "Покластися на досконалість основних ШІ-алгоритмів",
          "Використовувати лише перевірені відкриті бібліотеки",
          "Сфокусуватися на максимальній швидкості прийняття рішень"
        ],
        correct: 0,
        expA: "Відмінно! Резервні системи критично важливі для безпеки, коли основна ШІ може відмовити.",
        expB: "Навіть найкращі ШІ-алгоритми можуть давати збої у непередбачуваних ситуаціях.",
        expC: "Відкриті бібліотеки корисні, але не гарантують безпеку в критичних сценаріях.",
        expD: "Швидкість важлива, але безпека має вищий пріоритет у критичних застосуваннях.",
        points: 2,
        chapter: "Вступ до штучного інтелекту",
        difficulty: "K3"
      },
      {
        id: 231,
        text: "Організація вибирає між власною розробкою ШІ та ШІ-як-Сервіс. Який фактор найбільше впливає на це рішення? Оберіть ОДИН варіант.",
        options: [
          "Рівень контролю над даними та інтелектуальною власністю", // ✓ ПРАВИЛЬНО
          "Доступність хмарної інфраструктури в регіоні",
          "Кількість існуючих ШІ-спеціалістів у команді",
          "Поточний рівень автоматизації бізнес-процесів"
        ],
        correct: 0,
        expA: "Правильно! Контроль над конфіденційними даними та ІВ часто є вирішальним фактором.",
        expB: "Доступність хмари важлива, але не завжди є основним фактором прийняття рішення.",
        expC: "Брак спеціалістів може схилити до ШІaaS, але контроль даних зазвичай важливіший.",
        expD: "Рівень автоматизації впливає на впровадження, але не на вибір підходу до розробки.",
        points: 2,
        chapter: "Вступ до штучного інтелекту",
        difficulty: "K3"
      },
      {
        id: 232,
        text: "Команда тестує ШІ-систему рекомендацій для електронної комерції. Яка стратегія тестування найкраще виявить проблеми з різноманітністю рекомендацій? Оберіть ОДИН варіант.",
        options: [
          "Тестування з різноманітними профілями користувачів та поведінковими патернами", // ✓ ПРАВИЛЬНО
          "Концентрація на тестуванні найпопулярніших товарних категорій",
          "Використання лише історичних даних для перевірки точності",
          "Фокусування на продуктивності системи під високим навантаженням"
        ],
        correct: 0,
        expA: "Відмінно! Різноманітні тестові сценарії виявлять, чи система уникає фільтр-бульбашок.",
        expB: "Тестування лише популярних категорій може не виявити проблем з різноманітністю.",
        expC: "Історичні дані важливі для точності, але не розкривають проблем з різноманітністю.",
        expD: "Тестування продуктивності необхідне, але не стосується якості рекомендацій.",
        points: 2,
        chapter: "Вступ до штучного інтелекту",
        difficulty: "K3"
      },
      {
        id: 233,
        text: "Фінансова установа впроваджує ШІ для виявлення шахрайства. Що найважливіше врахувати при валідації системи? Оберіть ОДИН варіант.",
        options: [
          "Забезпечення максимальної швидкості обробки транзакцій",
          "Мінімізація хибних спрацювань для покращення користувацького досвіду",
          "Збалансування виявлення шахрайства та мінімізації невиправданих блокувань",
          "Досягнення найвищої можливої точності незалежно від інших факторів" // ✓ ПРАВИЛЬНО
        ],
        correct: 3,
        expA: "Швидкість важлива, але точність виявлення шахрайства критичніша для фінансових втрат.",
        expB: "Зменшення хибних спрацювань важливе, але не повинно жертвувати виявленням реального шахрайства.",
        expC: "Баланс важливий, але в контексті шахрайства пріоритет має максимальна точність виявлення.",
        expD: "Точно! У фінансових установах максимальна точність виявлення шахрайства має найвищий пріоритет.",
        points: 2,
        chapter: "Вступ до штучного інтелекту",
        difficulty: "K3"
      },
      {
        id: 234,
        text: "Компанія оцінює надійність ШІ-як-Сервіс рішення. На що слід звернути першочергову увагу? Оберіть ОДИН варіант.",
        options: [
          "Гарантії рівня послуг та плани відновлення після збоїв", // ✓ ПРАВИЛЬНО
          "Кількість доступних попередньо натренованих моделей",
          "Гнучкість налаштування інтерфейсу користувача",
          "Підтримку найновіших алгоритмів машинного навчання"
        ],
        correct: 0,
        expA: "Правильно! SLA та плани відновлення критичні для оцінки операційної надійності сервісу.",
        expB: "Різноманітність моделей корисна, але надійність сервісу важливіша для бізнес-операцій.",
        expC: "Налаштування UI зручне, але не впливає на основну надійність ШІ-функціональності.",
        expD: "Найновіші алгоритми привабливі, але стабільність сервісу має вищий пріоритет.",
        points: 2,
        chapter: "Вступ до штучного інтелекту",
        difficulty: "K3"
      },
      {
        id: 235,
        text: "Медичний пристрій використовує ШІ для діагностики. Який підхід до тестування найкраще забезпечить безпеку пацієнтів? Оберіть ОДИН варіант.",
        options: [
          "Всебічне тестування з клінічними експертами та регуляторним наглядом",
          "Автоматизоване тестування з великими наборами медичних даних",
          "Швидке прототипування з ітеративним покращенням в реальних умовах",
          "Поетапна валідація починаючи з некритичних діагностичних функцій" // ✓ ПРАВИЛЬНО
        ],
        correct: 3,
        expA: "Клінічні експерти та нагляд важливі, але поетапний підхід безпечніший для початку.",
        expB: "Автоматизоване тестування корисне, але медична діагностика потребує клінічної валідації.",
        expC: "Швидке прототипування ризиковане в медичних застосуваннях, де безпека критична.",
        expD: "Відмінно! Починати з менш критичних функцій дозволяє безпечно валідувати систему.",
        points: 2,
        chapter: "Вступ до штучного інтелекту",
        difficulty: "K3"
      },
      {
        id: 236,
        text: "Стартап з обмеженою ШІ-експертизою хоче впровадити машинне навчання. Яка стратегія найбільш практична? Оберіть ОДИН варіант.",
        options: [
          "Розвивати власну команду ШІ-експертів з нуля",
          "Використовувати готові ШІ-сервіси з поступовим нарощуванням експертизи",
          "Партнерство з академічними установами для дослідницьких проектів",
          "Купівля спеціалізованої ШІ-компанії для отримання технологій" // ✓ ПРАВИЛЬНО
        ],
        correct: 3,
        expA: "Розвиток команди з нуля займає багато часу та ресурсів для стартапу.",
        expB: "Готові сервіси корисні, але для інноваційного продукту можуть бути недостатні.",
        expC: "Академічне партнерство цінне для досліджень, але може не вирішити бізнес-потреби.",
        expD: "Точно! Придбання дозволяє швидко отримати технології та експертизу.",
        points: 2,
        chapter: "Вступ до штучного інтелекту",
        difficulty: "K3"
      },
    
      // ================= ПИТАННЯ К4 (СТРАТЕГІЯ: СТРАТЕГІЧНИЙ АНАЛІЗ) =================
      {
        id: 237,
        text: "Фінансовий банк планує впровадження ШІ для кредитних рішень. Як найкраще збалансувати інновації та регуляторну відповідність? Оберіть ОДИН варіант.",
        options: [
          "Поетапне впровадження з регуляторним узгодженням на кожному етапі", // ✓ ПРАВИЛЬНО
          "Повне впровадження з подальшим регуляторним узгодженням",
          "Очікувати оновлення регуляторних рамок перед початком",
          "Впроваджувати лише у некритичних операційних процесах"
        ],
        correct: 0,
        expA: "Відмінно! Поетапний підхід дозволяє валідувати відповідність та адаптуватися до вимог.",
        expB: "Повне впровадження без попереднього узгодження ризиковано у регульованій галузі.",
        expC: "Очікування може призвести до втрати конкурентних переваг на ринку.",
        expD: "Обмеження некритичними процесами може не реалізувати повний потенціал ШІ.",
        points: 3,
        chapter: "Вступ до штучного інтелекту",
        difficulty: "K4"
      },
      {
        id: 238,
        text: "Глобальна компанія розгортає ШІ-рішення в різних країнах з різними правовими вимогами. Яка стратегія найефективніша? Оберіть ОДИН варіант.",
        options: [
          "Адаптивна архітектура з локальними налаштуваннями відповідності", // ✓ ПРАВИЛЬНО
          "Уніфікована глобальна система з найвищими стандартами",
          "Окремі національні системи для кожного ринку",
          "Централізована система з пост-обробкою для локальної відповідності"
        ],
        correct: 0,
        expA: "Правильно! Гнучка архітектура дозволяє ефективно адаптуватися до локальних вимог.",
        expB: "Найвищі стандарти можуть бути надмірними та неефективними для деяких ринків.",
        expC: "Окремі системи збільшують складність підтримки та витрати на розробку.",
        expD: "Пост-обробка може бути недостатньою для складних регуляторних вимог.",
        points: 3,
        chapter: "Вступ до штучного інтелекту",
        difficulty: "K4"
      },
      {
        id: 239,
        text: "Виробнича компанія впроваджує ШІ для прогнозного обслуговування. Як оптимально інтегрувати з існуючими застарілими системами? Оберіть ОДИН варіант.",
        options: [
          "Повна заміна застарілих систем сучасною ШІ-платформою",
          "Побудова API-прошарку між ШІ та застарілими системами",
          "Поступова міграція з гібридним періодом співіснування", // ✓ ПРАВИЛЬНО
          "Паралельна робота систем з ручним узгодженням даних"
        ],
        correct: 2,
        expA: "Повна заміна ризикована та може порушити критичні виробничі процеси.",
        expB: "API-прошарок корисний, але може не вирішити всі проблеми інтеграції даних.",
        expC: "Відмінно! Поступова міграція мінімізує ризики та забезпечує плавний перехід.",
        expD: "Ручне узгодження неефективне та схильне до помилок у виробничому середовищі.",
        points: 3,
        chapter: "Вступ до штучного інтелекту",
        difficulty: "K4"
      },
      {
        id: 240,
        text: "Організація має обмежений ШІ-бюджет та кілька потенційних проектів. Як найкраще пріоритизувати інвестиції? Оберіть ОДИН варіант.",
        options: [
          "Інвестувати у найтехнологічніші та інноваційні проекти",
          "Фокусуватися на проектах з найшвидшою окупністю інвестицій",
          "Збалансований портфель поточних потреб та майбутніх можливостей", // ✓ ПРАВИЛЬНО
          "Очікувати технологічної зрілості перед великими інвестиціями"
        ],
        correct: 2,
        expA: "Найінноваційніші проекти можуть бути ризикованими без врахування бізнес-цінності.",
        expB: "Швидка окупність важлива, але може обмежити довгостроковий потенціал зростання.",
        expC: "Точно! Збалансований портфель забезпечує поточні потреби та готує до майбутніх можливостей.",
        expD: "Очікування зрілості може призвести до втрати конкурентних переваг та ринкових можливостей.",
        points: 3,
        chapter: "Вступ до штучного інтелекту",
        difficulty: "K4"
      },
      {
        id: 241,
        text: "Технологічна компанія оцінює вплив ефекту ШІ на розвиток продуктів та ринкове позиціонування. Яка стратегія найкраще допоможе подолати це явище? Оберіть ОДИН варіант.",
        options: [
          "Уникати використання терміну 'ШІ' у описах продуктів",
          "Фокусуватися на демонстрації реальної цінності замість ШІ-маркування", // ✓ ПРАВИЛЬНО
          "Підкреслювати лише найскладніші ШІ-функції",
          "Ребрендити всі існуючі функції як ШІ-керовані"
        ],
        correct: 1,
        expA: "Повне уникання ШІ-термінології може пропустити легітимні ринкові можливості та позиціонування.",
        expB: "Відмінно! Фокус на реальній цінності та перевагах допомагає клієнтам оцінити можливості незалежно від термінології.",
        expC: "Підкреслення складності може заплутати клієнтів та не вирішує проблему ефекту ШІ.",
        expD: "Хибне ШІ-маркування вводить клієнтів в оману та може пошкодити довіру коли очікування не виправдаються.",
        points: 3,
        chapter: "Вступ до штучного інтелекту",
        difficulty: "K4"
      },
      {
        id: 241,
        text: "Що найімовірніше робить тестування ШІ-систем складним? Оберіть ОДИН варіант.",
        options: [
          "Великий обсяг та різноманітність ШІ-тренувальних наборів даних", // ШІ/МН домен - ПРАВИЛЬНО
          "Патерни управління життєвим циклом React компонентів",             // Фронтенд
          "Стратегії оптимізації запитів PostgreSQL бази даних",             // База даних  
          "Конфігурації оркестрації Docker контейнерів"                      // DevOps
        ],
        correct: 0,
        expA: "Точно! ШІ-системи потребують масивних, різноманітних наборів даних, що створює унікальну складність тестування.",
        expB: "Патерни React стосуються проблем фронтенд-розробки, а не викликів тестування ШІ.",
        expC: "Оптимізація бази даних важлива, але не специфічна для складності тестування ШІ.",
        expD: "Оркестрація контейнерів допомагає з розгортанням, але не вирішує специфічні виклики тестування ШІ.",
        points: 1,
        chapter: "Огляд тестування ШІ-систем",
        difficulty: "K1"
      },
      {
        id: 242,
        text: "Який домен потребує спеціалізованих підходів до тестування обробки великих даних? Оберіть ОДИН варіант.",
        options: [
          "Патерни сервісів Angular dependency injection",           // Фронтенд
          "Системи аналітики великих даних та машинного навчання",   // ШІ/МН домен - ПРАВИЛЬНО
          "Техніки оптимізації індексування MySQL бази даних",      // База даних
          "Робочі процеси автоматизації Jenkins CI/CD пайплайнів"   // DevOps
        ],
        correct: 1,
        expA: "Angular сервіси обробляють фронтенд залежності, а не вимоги обробки великих даних.",
        expB: "Правильно! Великі дані в ШІ/МН контекстах потребують спеціалізованих підходів тестування обсягу та різноманітності.",
        expC: "MySQL індексування покращує продуктивність бази даних, але не спеціалізується на контекстах великих даних.",
        expD: "Jenkins автоматизує пайплайни розгортання, але не спеціалізується на тестуванні великих даних.",
        points: 1,
        chapter: "Огляд тестування ШІ-систем",
        difficulty: "K1"
      },
      {
        id: 260,
        text: "Що робить недетермінованість основною проблемою в тестуванні ШІ? Оберіть ОДИН варіант.",
        options: [
          "Складність управління життєвим циклом Vue.js компонентів", // Фронтенд
          "Техніки оптимізації MongoDB запитів та індексування",      // База даних
          "Стратегії розподілу навантаження Nginx сервера",           // DevOps  
          "Створення проблем оракула для ШІ-системи"                 // ШІ/МН домен - ПРАВИЛЬНО
        ],
        correct: 3,
        expA: "Управління життєвим циклом Vue.js - це проблеми фронтенд-розробки, не пов'язані зі складністю тестування ШІ.",
        expB: "Оптимізація MongoDB - це управління базою даних, не унікальне для тестування ШІ-системи.",
        expC: "Розподіл навантаження Nginx стосується управління трафіком, не специфічного для тестування ШІ.",
        expD: "Точно! Недетермінована поведінка ШІ створює унікальні проблеми оракула в тестуванні.",
        points: 1,
        chapter: "Огляд тестування ШІ-систем",
        difficulty: "K1"
      },
    
      // ================= ПИТАННЯ К2 (СТРАТЕГІЯ: ДОМЕН ШІ/МН З ТОНКИМИ ВІДМІННОСТЯМИ) =================
      {
        id: 243,
        text: "Яке з наступних тверджень найкраще описує упередження автоматизації в тестуванні ШІ? Оберіть ОДИН варіант.",
        options: [
          "Перевага автоматизованих тестових інструментів над ручними підходами",
          "Надмірне покладання на результати машинного навчання без перевірки",
          "Автоматизація тестових процесів без людського нагляду",
          "Використання ШІ-систем для автоматичного генерування тестових випадків"
        ],
        correct: 1,
        expA: "Перевага інструментів стосується вибору методології, а не упередження автоматизації в ШІ-контекстах.",
        expB: "Точно! Упередження автоматизації - це довіра до ШІ-результатів без належної перевірки чи валідації.",
        expC: "Відсутність нагляду - це погана практика, але не основне визначення упередження автоматизації.",
        expD: "Автоматичне генерування тестів - це функція, а не упередження автоматизації.",
        points: 1,
        chapter: "Огляд тестування ШІ-систем", 
        difficulty: "K2"
      },
      {
        id: 244,
        text: "Що робить тестування моделей машинного навчання складнішим за традиційне програмне забезпечення? Оберіть ОДИН варіант.",
        options: [
          "МН-моделі потребують більших обчислювальних ресурсів",
          "МН-моделі мають складніші архітектури та конфігурації",
          "МН-моделі демонструють імовірнісну та недетерміновану поведінку",
          "МН-моделі потребують спеціалізованих мов програмування"
        ],
        correct: 2,
        expA: "Обчислювальні ресурси - це питання продуктивності, а не основна складність тестування.",
        expB: "Складність архітектури існує і в традиційних системах, це не унікально для МН.",
        expC: "Правильно! Імовірнісна природа робить очікувані результати менш передбачуваними.",
        expD: "Мови програмування - це питання впровадження, а не основна складність тестування.",
        points: 1,
        chapter: "Огляд тестування ШІ-систем",
        difficulty: "K2"
      },
      {
        id: 245,
        text: "Яка основна відмінність між тестуванням ШІ та традиційним тестуванням програмного забезпечення? Оберіть ОДИН варіант.",
        options: [
          "ШІ-тестування фокусується на поведінці на основі даних замість логіки", // ПРАВИЛЬНО
          "ШІ-тестування потребує більше автоматизованих тестових інструментів",
          "ШІ-тестування використовує різні мови програмування та фреймворки",
          "ШІ-тестування потребує більших команд та більше часу розробки"
        ],
        correct: 0,
        expA: "Точно! ШІ-системи навчаються з даних, тому тестування фокусується на поведінці, керованій даними.",
        expB: "Потреба в автоматизації залежить від проекту, а не є основною відмінністю ШІ-тестування.",
        expC: "Технологічний стек - це деталь впровадження, а не основна відмінність тестування.",
        expD: "Ресурси проекту варіюються залежно від складності, не є основною відмінністю ШІ.",
        points: 1,
        chapter: "Огляд тестування ШІ-систем",
        difficulty: "K2"
      },
      {
        id: 246,
        text: "Чому валідація даних критична в тестуванні ШІ-систем? Оберіть ОДИН варіант.",
        options: [
          "Дані визначають продуктивність та точність ШІ-моделей",
          "Дані потребують більше місця для зберігання та обчислювань",
          "Дані повинні бути зашифровані для безпеки та приватності",
          "Дані повинні бути структуровані в реляційних форматах бази"
        ],
        correct: 0,
        expA: "Правильно! Якість даних безпосередньо впливає на те, наскільки добре ШІ-система навчається та працює.",
        expB: "Зберігання - це інфраструктурна проблема, не основна причина валідації даних.",
        expC: "Безпека важлива, але не основна причина критичності валідації даних.",
        expD: "Структура даних - це деталь дизайну, а не основна причина валідації.",
        points: 1,
        chapter: "Огляд тестування ШІ-систем",
        difficulty: "K2"
      },
      {
        id: 247,
        text: "Що робить створення тестових оракулів особливо складним для ШІ-систем? Оберіть ОДИН варіант.",
        options: [
          "ШІ-системи обробляють більші обсяги даних ніж традиційні системи",
          "ШІ-системи використовують складніші алгоритми та структури даних",
          "ШІ-системи часто не мають чітко визначених очікуваних результатів",
          "ШІ-системи потребують спеціалізованого тестового обладнання та інструментів"
        ],
        correct: 2,
        expA: "Обсяг даних - це проблема масштабування, а не основна проблема оракула.",
        expB: "Складність алгоритму існує і в традиційних системах, не унікально для ШІ.",
        expC: "Точно! Імовірнісна природа ШІ робить визначення 'правильних' результатів складним.",
        expD: "Спеціалізовані інструменти допомагають, але не є основною проблемою оракула.",
        points: 1,
        chapter: "Огляд тестування ШІ-систем",
        difficulty: "K2"
      },
      {
        id: 248,
        text: "Яка роль тестових даних у валідації ШІ-системи? Оберіть ОДИН варіант.",
        options: [
          "Тестові дані використовуються лише для тестування продуктивності системи",
          "Тестові дані забезпечують незалежну оцінку точності та поведінки моделі", // ПРАВИЛЬНО
          "Тестові дані використовуються для налаштування гіперпараметрів моделі",
          "Тестові дані зберігаються для історичних записів та аудиторських цілей"
        ],
        correct: 1,
        expA: "Тестування продуктивності - лише один аспект; тестові дані мають ширше призначення.",
        expB: "Правильно! Тестові дані забезпечують неупереджену оцінку того, як модель працюватиме на нових даних.",
        expC: "Налаштування гіперпараметрів зазвичай використовує валідаційні дані, а не тестові.",
        expD: "Зберігання записів корисне, але не основна роль тестових даних у валідації.",
        points: 1,
        chapter: "Огляд тестування ШІ-систем",
        difficulty: "K2"
      },
    
      // ================= ПИТАННЯ К3 (СТРАТЕГІЯ: ПРОФЕСІЙНІ РЕКОМЕНДАЦІЇ) =================
      {
        id: 249,
        text: "Команда розробляє систему розпізнавання зображень для медичної діагностики. Який підхід найкраще забезпечить надійність у критичних випадках? Оберіть ОДИН варіант.",
        options: [
          "Багатомодельний ансамбль з голосуванням та перевіркою впевненості", // ПРАВИЛЬНО
          "Одна високоточна модель з ретельним налаштуванням гіперпараметрів",
          "Швидка модель з акцентом на час відгуку для екстрених ситуацій",
          "Модель з найновішою архітектурою та найсучаснішими алгоритмами"
        ],
        correct: 0,
        expA: "Відмінно! Ансамбль моделей забезпечує надійність через різноманітність та перевірку впевненості.",
        expB: "Одна модель, навіть високоточна, більш схильна до збоїв ніж ансамбль.",
        expC: "Швидкість важлива, але точність критичніша в медичній діагностиці.",
        expD: "Найновіші алгоритми можуть бути менш надійними ніж перевірені ансамблеві підходи.",
        points: 2,
        chapter: "Огляд тестування ШІ-систем",
        difficulty: "K3"
      },
      {
        id: 250,
        text: "Фінансова компанія тестує ШІ-систему виявлення шахрайства. На що слід зосередитися для забезпечення ефективності? Оберіть ОДИН варіант.",
        options: [
          "Баланс між виявленням справжнього шахрайства та мінімізацією хибних тривог", // ПРАВИЛЬНО
          "Максимальна швидкість обробки транзакцій для покращення користувацького досвіду",
          "Найвища можлива точність незалежно від інших показників продуктивності",
          "Інтеграція з існуючими банківськими системами та процедурами відповідності"
        ],
        correct: 0,
        expA: "Правильно! Збалансування точності виявлення з зменшенням хибних тривог критично важливе.",
        expB: "Швидкість важлива, але не повинна жертвувати точністю виявлення шахрайства.",
        expC: "Максимальна точність може призвести до занадто багатьох хибних тривог.",
        expD: "Інтеграція необхідна, але основний фокус має бути на ефективності виявлення.",
        points: 2,
        chapter: "Огляд тестування ШІ-систем",
        difficulty: "K3"
      },
      {
        id: 251,
        text: "Команда тестує чат-бот з обробкою природної мови. Яка стратегія найкраще виявить проблеми з розумінням контексту? Оберіть ОДИН варіант.",
        options: [
          "Тестування з різноманітними діалоговими сценаріями та багатоходовими розмовами", // ПРАВИЛЬНО
          "Концентрація на тестуванні найчастіших запитів користувачів",
          "Використання лише попередньо визначених тестових сценаріїв",
          "Фокусування на тестуванні швидкості відгуку та пропускної здатності"
        ],
        correct: 0,
        expA: "Відмінно! Різноманітні діалогові сценарії виявлять проблеми з контекстним розумінням.",
        expB: "Частіші запити важливі, але можуть не розкрити складнощі розуміння контексту.",
        expC: "Попередньо визначені сценарії обмежені та можуть пропустити контекстуальні проблеми.",
        expD: "Продуктивність важлива, але не тестує якість розуміння природної мови.",
        points: 2,
        chapter: "Огляд тестування ШІ-систем",
        difficulty: "K3"
      },
      {
        id: 252,
        text: "Автомобільна компанія розробляє ШІ для автономного водіння. Який підхід до тестування найбезпечніший? Оберіть ОДИН варіант.",
        options: [
          "Поетапне тестування від симуляції до контрольованих реальних умов", // ПРАВИЛЬНО
          "Пряме тестування в реальних дорожніх умовах для максимальної автентичності",
          "Фокусування на лабораторному тестуванні з ідеальними умовами",
          "Тестування лише в контрольованих середовищах без реальних сценаріїв"
        ],
        correct: 0,
        expA: "Точно! Поетапний підхід дозволяє безпечно нарощувати складність тестування.",
        expB: "Пряме реальне тестування занадто ризиковане без попередньої валідації.",
        expC: "Лабораторні умови недостатні для валідації систем автономного водіння.",
        expD: "Лише контрольовані середовища не можуть підготувати до реальних сценаріїв.",
        points: 2,
        chapter: "Огляд тестування ШІ-систем",
        difficulty: "K3"
      },
      {
        id: 253,
        text: "Електронна платформа впроваджує ШІ-рекомендації продуктів. Як найкраще тестувати персоналізацію? Оберіть ОДИН варіант.",
        options: [
          "A/B тестування з різними алгоритмами рекомендацій та сегментами користувачів", // ПРАВИЛЬНО
          "Аналіз продуктивності лише на історичних даних користувачів",
          "Фокусування на тестуванні найпопулярніших продуктових категорій",
          "Використання синтетичних користувацьких профілів для контрольованого тестування"
        ],
        correct: 0,
        expA: "Відмінно! A/B тестування дозволяє порівняти ефективність різних підходів персоналізації.",
        expB: "Історичні дані корисні, але не можуть валідувати ефективність нових алгоритмів.",
        expC: "Популярні категорії не покривають повну складність персоналізації.",
        expD: "Синтетичні профілі можуть не відображати реальну поведінку користувачів.",
        points: 2,
        chapter: "Огляд тестування ШІ-систем",
        difficulty: "K3"
      },
      {
        id: 254,
        text: "Команда розробляє ШІ для прогнозування попиту в ланцюгу постачання. Що критично для валідації прогнозів? Оберіть ОДИН варіант.",
        options: [
          "Тестування на сезонних даних з різних часових періодів та ринкових умов", // ПРАВИЛЬНО
          "Максимізація точності прогнозів для найбільших товарних категорій",
          "Забезпечення швидких прогнозів для підтримки оперативних рішень",
          "Інтеграція з існуючими системами управління запасами"
        ],
        correct: 0,
        expA: "Правильно! Сезонність та різні ринкові умови критично важливі для валідації прогнозів.",
        expB: "Фокусування лише на великих категоріях може пропустити важливі тренди.",
        expC: "Швидкість важлива, але точність прогнозів має вищий пріоритет.",
        expD: "Інтеграція необхідна, але основний фокус має бути на якості прогнозів.",
        points: 2,
        chapter: "Огляд тестування ШІ-систем",
        difficulty: "K3"
      },
    
      // ================= ПИТАННЯ К4 (СТРАТЕГІЯ: СТРАТЕГІЧНИЙ АНАЛІЗ) =================
      {
        id: 255,
        text: "Глобальна компанія розгортає ШІ в різних регіонах з різними регуляторними вимогами. Яка стратегія тестування найефективніша? Оберіть ОДИН варіант.",
        options: [
          "Багатоярусна стратегія тестування з базовими глобальними та специфічними регіональними тестами", // ПРАВИЛЬНО
          "Уніфікована глобальна стратегія тестування з найвищими стандартами",
          "Окремі незалежні стратегії тестування для кожного регіону",
          "Централізоване тестування з пост-валідацією регіональної відповідності"
        ],
        correct: 0,
        expA: "Відмінно! Багатоярусний підхід забезпечує ефективність при дотриманні локальних вимог.",
        expB: "Найвищі стандарди можуть бути надмірними та неефективними для деяких регіонів.",
        expC: "Повністю окремі стратегії збільшують складність та витрати без необхідності.",
        expD: "Пост-валідація може бути недостатньою для складних регуляторних відмінностей.",
        points: 3,
        chapter: "Огляд тестування ШІ-систем",
        difficulty: "K4"
      },
      {
        id: 256,
        text: "Організація має обмежений бюджет на тестування ШІ та кілька критичних проектів. Як оптимально розподілити ресурси тестування? Оберіть ОДИН варіант.",
        options: [
          "Ризик-орієнтований підхід з більшим фокусом на високоризикових проектах", // ПРАВИЛЬНО
          "Рівномірний розподіл ресурсів тестування між усіма проектами",
          "Пріоритизація проектів з найшвидшою окупністю інвестицій",
          "Концентрація на проектах з найсучаснішими ШІ-технологіями"
        ],
        correct: 0,
        expA: "Правильно! Ризик-орієнтований підхід забезпечує максимальну цінність тестування при обмежених ресурсах.",
        expB: "Рівномірний розподіл не враховує різні рівні ризику та складності проектів.",
        expC: "Швидка окупність важлива, але не повинна визначати розподіл ресурсів тестування.",
        expD: "Найсучасніші технології можуть не бути найризикованішими чи найкритичнішими.",
        points: 3,
        chapter: "Огляд тестування ШІ-систем",
        difficulty: "K4"
      },
      {
        id: 257,
        text: "Технологічна компанія інтегрує ШІ в існуючу систему з мільйонами користувачів. Як найбезпечніше управляти розгортанням? Оберіть ОДИН варіант.",
        options: [
          "Поетапне розгортання з канареечним тестуванням та моніторингом в реальному часі", // ПРАВИЛЬНО
          "Повне розгортання з ретельним попереднім тестуванням та резервними планами",
          "Паралельне виконання ШІ та застарілої системи з поступовим переходом",
          "Розгортання для невеликої групи користувачів з поступовим масштабуванням"
        ],
        correct: 0,
        expA: "Відмінно! Канареечне розгортання дозволяє виявити проблеми з мінімальним впливом на користувачів.",
        expB: "Повне розгортання ризиковане навіть з ретельним попереднім тестуванням.",
        expC: "Паралельне виконання може бути дорогим та складним для підтримки.",
        expD: "Невелика група користувачів може не виявити всі проблеми масштабування.",
        points: 3,
        chapter: "Огляд тестування ШІ-систем",
        difficulty: "K4"
      },
      {
        id: 258,
        text: "Стартап розробляє інноваційну ШІ-платформу з обмеженими ресурсами та часом. Яка стратегія тестування найпрактичніша? Оберіть ОДИН варіант.",
        options: [
          "MVP-орієнтоване тестування з фокусом на основних функціях та ітеративним покращенням", // ПРАВИЛЬНО
          "Всеосяжна стратегія тестування що покриває всі можливі сценарії",
          "Покладання на автоматизоване тестування для зменшення ручних зусиль",
          "Аутсорсинг тестування для фокусування на основній розробці продукту"
        ],
        correct: 0,
        expA: "Правильно! MVP підхід дозволяє швидко валідувати основні функції з обмеженими ресурсами.",
        expB: "Всеосяжне тестування не практично з обмеженими ресурсами стартапу.",
        expC: "Автоматизація корисна, але початкове створення потребує значних інвестицій.",
        expD: "Аутсорсинг може бути дорогим та втратити доменні знання для стартапу.",
        points: 3,
        chapter: "Огляд тестування ШІ-систем",
        difficulty: "K4"
      },
      {
        id: 259,
        text: "Великий банк впроваджує ШІ для кредитних рішень з суворими регуляторними вимогами. Як найкраще збалансувати інновації та відповідність? Оберіть ОДИН варіант.",
        options: [
          "Паралельні треки валідації: технічне тестування та регуляторна відповідність з перехресною перевіркою", // ПРАВИЛЬНО
          "Послідовний підхід: спочатку повне технічне тестування, потім регуляторна валідація",
          "Регуляторно-перший підхід: отримання всіх схвалень перед початком технічного тестування",
          "Мінімально життєздатний продукт з поступовим додаванням функцій після регуляторного схвалення"
        ],
        correct: 0,
        expA: "Відмінно! Паралельні треки максимізують ефективність при забезпеченні повної відповідності.",
        expB: "Послідовний підхід може призвести до затримок та переробки через регуляторні вимоги.",
        expC: "Регуляторно-перший підхід може обмежити технічні інновації та гнучкість.",
        expD: "MVP підхід може не відповідати строгим банківським регуляторним стандартам.",
        points: 3,
        chapter: "Огляд тестування ШІ-систем",
        difficulty: "K4"
      },
      {
        id: 261,
        text: "Який підхід використовується для валідації ймовірнісних виходів систем ШІ? Оберіть ОДИН варіант.",
        options: [
          "Статистичні критерії прийняття та довірчі інтервали",
          "Валідація властивостей React компонентів та перевірка типів",
          "Рівні ізоляції PostgreSQL транзакцій та забезпечення консистентності",
          "Моніторинг стану Docker контейнерів та політики перезапуску"
        ],
        correct: 0,
        expA: "Точно! Ймовірнісні системи ШІ потребують статистичних методів для валідації виходів у прийнятних межах.",
        expB: "React валідація обробляє властивості frontend компонентів, а не валідацію виходів систем ШІ.",
        expC: "PostgreSQL ізоляція забезпечує консистентність баз даних, а не валідацію ймовірнісних виходів ШІ.",
        expD: "Docker моніторинг управляє станом контейнерів, а не валідацією ймовірнісних виходів систем ШІ.",
        points: 1,
        chapter: "Тестування специфічних характеристик якості систем на основі ШІ",
        difficulty: "K1"
      },
      {
        id: 262,
        text: "Яке поняття описує патерни несправедливого поводження в системах ШІ? Оберіть ОДИН варіант.",
        options: [
          "Реактивна прив'язка даних Vue.js та обчислювані властивості",
          "Алгоритмічне упередження та систематична дискримінація",
          "Техніки оптимізації pipeline агрегації MongoDB",
          "Квоти ресурсів Kubernetes та політики планування"
        ],
        correct: 1,
        expA: "Vue.js обробляє frontend реактивність, а не питання справедливості або дискримінації в системах ШІ.",
        expB: "Ідеально! Алгоритмічне упередження означає систематичну несправедливу дискримінацію в прийнятті рішень ШІ.",
        expC: "MongoDB агрегація оптимізує запити баз даних, а не проблеми справедливості або упередженості ШІ.",
        expD: "Kubernetes управляє розподілом ресурсів, а не упередженістю систем ШІ або патернами дискримінації.",
        points: 1,
        chapter: "Тестування специфічних характеристик якості систем на основі ШІ",
        difficulty: "K1"
      },
      {
        id: 263,
        text: "Який з наступних підходів є НАЙКРАЩИМ для тестування самонавчальних систем? Оберіть ОДИН варіант.",
        options: [
          "Безперервний моніторинг з адаптивними базовими лініями ШІ",
          "Статична валідація моделі з використанням фіксованих бенчмарків продуктивності",
          "Періодичні цикли перенавчання з валідацією історичних даних",
          "Ручний огляд змін параметрів алгоритмів навчання"
        ],
        correct: 0,
        expA: "Правильно! Самонавчальні системи потребують адаптивного моніторингу, оскільки їх поведінка постійно розвивається.",
        expB: "Фіксовані бенчмарки застарівають, коли самонавчальні системи адаптуються до нових патернів.",
        expC: "Періодичні підходи пропускають безперервні зміни в поведінці самонавчальних систем.",
        expD: "Ручний огляд не може масштабуватися для моніторингу всіх змін параметрів у системах, що розвиваються.",
        points: 1,
        chapter: "Тестування специфічних характеристик якості систем на основі ШІ",
        difficulty: "K2"
      },
      {
        id: 264,
        text: "Що є НАЙВАЖЛИВІШИМ при тестуванні автономних систем? Оберіть ОДИН варіант.",
        options: [
          "Оптимізація продуктивності прийняття рішень у реальному часі",
          "Протоколи валідації безпеки для мульти-середовища",
          "Аналіз поведінки граничних випадків та комплексне тестування",
          "Точність зливання сенсорів при змінних умовах навколишнього середовища"
        ],
        correct: 1,
        expA: "Оптимізація продуктивності важлива, але вторинна порівняно з вимогами валідації безпеки.",
        expB: "Абсолютно! Валідація безпеки в різноманітних середовищах є першочерговою для автономних систем.",
        expC: "Тестування граничних випадків критичне, але валідація безпеки забезпечує ширший захист.",
        expD: "Точність сенсорів життєво важлива, але загальна валідація безпеки охоплює ширші ризики.",
        points: 1,
        chapter: "Тестування специфічних характеристик якості систем на основі ШІ",
        difficulty: "K2"
      },
      {
        id: 265,
        text: "Який підхід є НАЙЕФЕКТИВНІШИМ для тестування алгоритмічного упередження? Оберіть ОДИН варіант.",
        options: [
          "Тестування лише з однорідними групами даних",
          "Фокус виключно на метриках технічної точності",
          "Використання різноманітних наборів даних з метриками справедливості",
          "Повне уникнення демографічних міркувань"
        ],
        correct: 2,
        expA: "Однорідні дані не можуть виявити патерни упередження, що впливають на різні демографічні групи.",
        expB: "Технічна точність сама по собі не відображає справедливість серед різних груп населення.",
        expC: "Правильно! Різноманітні дані з метриками справедливості виявляють патерни упередження та забезпечують справедливу поведінку системи.",
        expD: "Уникнення демографії перешкоджає виявленню патернів систематичної дискримінації.",
        points: 1,
        chapter: "Тестування специфічних характеристик якості систем на основі ШІ",
        difficulty: "K2"
      },
      {
        id: 266,
        text: "Яка проблема є НАЙБІЛЬШ ЗНАЧУЩОЮ при тестуванні недетермінованих систем ШІ? Оберіть ОДИН варіант.",
        options: [
          "Встановлення контрольованих тестових умов та воспроизводимості результатів",
          "Оптимізація продуктивності системи під час виконання тестів",
          "Координація робочих навантажень при паралельному виконанні тестів",
          "Інтеграція з існуючими фреймворками автоматизації тестування"
        ],
        correct: 0,
        expA: "Точно! Недетермінована поведінка ускладнює створення воспроизводимих тестових сценаріїв та оракулів.",
        expB: "Оптимізація продуктивності важлива, але вторинна порівняно з викликами детермінізму.",
        expC: "Координація паралельного виконання - це проблема інфраструктури, а не основна проблема недетермінованості.",
        expD: "Інтеграція фреймворків можна вирішити, але недетермінована поведінка створює фундаментальні виклики для тестування.",
        points: 1,
        chapter: "Тестування специфічних характеристик якості систем на основі ШІ",
        difficulty: "K2"
      },
      {
        id: 267,
        text: "Яка характеристика якості є НАЙКРИТИЧНІШОЮ для систем рекомендацій? Оберіть ОДИН варіант.",
        options: [
          "Максимальна швидкість обробки запитів користувачів",
          "Точність персоналізації та релевантність рекомендацій",
          "Мінімальне використання системних ресурсів та енергоефективність",
          "Сумісність з різноманітними браузерами та платформами"
        ],
        correct: 1,
        expA: "Швидкість важлива, але нерелевантні рекомендації роблять систему марною незалежно від швидкості.",
        expB: "Правильно! Точна персоналізація визначає цінність системи рекомендацій для користувачів.",
        expC: "Ефективність ресурсів важлива для масштабування, але не ключова характеристика якості рекомендацій.",
        expD: "Сумісність платформ необхідна для доступності, але не визначає якість самих рекомендацій.",
        points: 1,
        chapter: "Тестування специфічних характеристик якості систем на основі ШІ",
        difficulty: "K2"
      },
      {
        id: 268,
        text: "Який підхід НАЙКРАЩЕ забезпечує пояснюваність в системах ШІ? Оберіть ОДИН варіант.",
        options: [
          "Детальні технічні логи всіх системних операцій",
          "Візуалізація процесу прийняття рішень зрозумілою мовою",
          "Статистичні метрики продуктивності моделі з числовими значеннями",
          "Документація архітектури системи та конфігураційних параметрів"
        ],
        correct: 1,
        expA: "Технічні логи містять інформацію, але не пояснюють логіку прийняття рішень зрозумілим способом.",
        expB: "Відмінно! Візуалізація процесу прийняття рішень робить поведінку ШІ зрозумілою для користувачів.",
        expC: "Метрики продуктивності показують що працює, але не пояснюють як і чому система приймає рішення.",
        expD: "Документація архітектури описує структуру, але не пояснює логіку конкретних рішень системи.",
        points: 1,
        chapter: "Тестування специфічних характеристик якості систем на основі ШІ",
        difficulty: "K2"
      },
      {
        id: 269,
        text: "Який фактор є КЛЮЧОВИМ при тестуванні прозорості систем ШІ? Оберіть ОДИН варіант.",
        options: [
          "Швидкість генерації звітів про роботу системи",
          "Доступність інформації про процес прийняття рішень для зацікавлених сторін",
          "Кількість метрик, що відстежуються системою моніторингу",
          "Рівень деталізації в логах системи та файлах аудиту"
        ],
        correct: 1,
        expA: "Швидкість звітів корисна для операційних цілей, але не визначає прозорість системи.",
        expB: "Абсолютно! Прозорість означає, що зацікавлені сторони можуть зрозуміти, як система приймає рішення.",
        expC: "Кількість метрик може створити інформаційне перевантаження, не покращуючи прозорість.",
        expD: "Детальні логи містять інформацію, але прозорість потребує зрозумілого представлення для користувачів.",
        points: 1,
        chapter: "Тестування специфічних характеристик якості систем на основі ШІ",
        difficulty: "K2"
      },
      {
        id: 270,
        text: "Компанія планує розгорнути систему ШІ для аналізу медичних зображень. Яка стратегія тестування НАЙКРАЩЕ забезпечить надійність системи в різних клінічних умовах? Оберіть ОДИН варіант.",
        options: [
          "Багатоцентрове валідування з різноманітними наборами даних пацієнтів",
          "Лабораторне тестування з синтетичними медичними зображеннями високої якості",
          "Порівняльний аналіз з існуючими системами медичної діагностики",
          "Валідація алгоритму на єдиному великому наборі даних"
        ],
        correct: 0,
        expA: "Правильно! Різноманітні клінічні умови та популяції пацієнтів забезпечують реальну валідацію системи.",
        expB: "Синтетичні зображення корисні, але можуть не відображати складність реальних медичних сценаріїв.",
        expC: "Порівняльний аналіз важливий, але не забезпечує валідацію в різноманітних клінічних умовах.",
        expD: "Єдиний набір даних може не покривати всі варіації, притаманні різним клінічним середовищам.",
        points: 2,
        chapter: "Тестування специфічних характеристик якості систем на основі ШІ",
        difficulty: "K3"
      },
      {
        id: 271,
        text: "Система рекомендацій е-комерції демонструє упередження проти певних демографічних груп. Яка стратегія НАЙЕФЕКТИВНІШЕ вирішить цю проблему? Оберіть ОДИН варіант.",
        options: [
          "Впровадження метрик справедливості з регулярним аудитом алгоритмічних рішень",
          "Збільшення обсягу навчальних даних для покращення загальної точності",
          "Оптимізація алгоритму для максимізації прибутку від продажів",
          "Перехід на простіші алгоритми без машинного навчання"
        ],
        correct: 0,
        expA: "Відмінно! Метрики справедливості та регулярний аудит систематично виявляють і усувають упередження.",
        expB: "Більше даних може покращити точність, але не обов'язково вирішить проблеми упередження.",
        expC: "Максимізація прибутку може посилити упередження, якщо воно корелює з дискримінаційною поведінкою.",
        expD: "Простіші алгоритми можуть зменшити упередження, але жертвують перевагами персоналізації.",
        points: 2,
        chapter: "Тестування специфічних характеристик якості систем на основі ШІ",
        difficulty: "K3"
      },
      {
        id: 272,
        text: "Автономна система керування транспортом повинна пояснювати свої рішення регуляторам. Який підхід забезпечить НАЙКРАЩИЙ баланс між продуктивністю та пояснюваністю? Оберіть ОДИН варіант.",
        options: [
          "Гібридна архітектура з високопродуктивними моделями та модулем пояснення",
          "Використання виключно інтерпретованих моделей з обмеженими можливостями",
          "Повна заміна ШІ на детерміновані алгоритми прийняття рішень",
          "Генерація пост-фактум пояснень без зв'язку з реальним процесом рішень"
        ],
        correct: 0,
        expA: "Ідеально! Гібридний підхід поєднує високу продуктивність з надійними поясненнями для регуляторних вимог.",
        expB: "Інтерпретовані моделі забезпечують пояснюваність, але можуть жертвувати критичною продуктивністю.",
        expC: "Детерміновані алгоритми можуть не впоратися зі складністю автономних транспортних систем.",
        expD: "Пост-фактум пояснення можуть бути неточними та не відображати реальний процес прийняття рішень.",
        points: 2,
        chapter: "Тестування специфічних характеристик якості систем на основі ШІ",
        difficulty: "K3"
      },
      {
        id: 273,
        text: "Фінансова установа впроваджує систему ШІ для оцінки кредитних ризиків. Яка стратегія НАЙКРАЩЕ забезпечить відповідність регуляторним вимогам щодо справедливості? Оберіть ОДИН варіант.",
        options: [
          "Багаторівневий аудит з метриками справедливості та участю доменних експертів",
          "Автоматизоване навчання моделі на історичних даних без втручання людини",
          "Фокус на максимізації прибутковості кредитного портфеля установи",
          "Використання стандартних статистичних моделей без адаптації ШІ"
        ],
        correct: 0,
        expA: "Правильно! Багаторівневий аудит з експертами забезпечує комплексну валідацію справедливості та відповідність.",
        expB: "Автоматизоване навчання може закріпити історичні упередження без належного контролю.",
        expC: "Фокус на прибутковості може призвести до дискримінаційних практик кредитування.",
        expD: "Стандартні моделі можуть не використовувати переваги ШІ або все ж мати приховані упередження.",
        points: 2,
        chapter: "Тестування специфічних характеристик якості систем на основі ШІ",
        difficulty: "K3"
      },
      {
        id: 274,
        text: "Система обробки природної мови демонструє різну продуктивність для різних мов. Яка стратегія тестування НАЙКРАЩЕ виявить та усуне ці невідповідності? Оберіть ОДИН варіант.",
        options: [
          "Багатомовне тестування з лінгвістично різноманітними наборами даних",
          "Фокус на домінуючій мові з найбільшою кількістю користувачів",
          "Використання автоматичного перекладу для генерації тестових даних",
          "Стандартизація всіх мов до спільного формату вводу"
        ],
        correct: 0,
        expA: "Відмінно! Лінгвістично різноманітні набори даних виявляють специфічні для мови проблеми продуктивності.",
        expB: "Фокус на одній мові ігнорує потреби користувачів інших мов та створює нерівність сервісу.",
        expC: "Автоматичний переклад може внести артефакти, що не відображають справжнє використання мови.",
        expD: "Стандартизація може втратити важливі лінгвістичні нюанси, що впливають на продуктивність системи.",
        points: 2,
        chapter: "Тестування специфічних характеристик якості систем на основі ШІ",
        difficulty: "K3"
      },
      {
        id: 275,
        text: "Робототехнічна система на заводі використовує комп'ютерний зір для контролю якості. Яка стратегія НАЙКРАЩЕ забезпечить стійкість системи до змін у виробничому середовищі? Оберіть ОДИН варіант.",
        options: [
          "Адаптивне навчання з різноманітними умовами освітлення та позиціонування продукції",
          "Жорстка калібрація камер з фіксованими параметрами для консистентності",
          "Використання високоякісного обладнання для мінімізації змінності середовища",
          "Обмеження робочих часів системи периодами стабільних умов"
        ],
        correct: 0,
        expA: "Правильно! Адаптивне навчання з різноманітними умовами готує систему до реальної мінливості заводу.",
        expB: "Жорстка калібрація може зламатися при неминучих змінах у виробничому середовищі.",
        expC: "Високоякісне обладнання корисне, але не усуває всі варіації в реальному виробничому середовищі.",
        expD: "Обмеження робочого часу знижує корисність системи та не вирішує проблему адаптивності.",
        points: 2,
        chapter: "Тестування специфічних характеристик якості систем на основі ШІ",
        difficulty: "K3"
      },
      {
        id: 276,
        text: "Глобальна технологічна компанія розробляє платформу ШІ для багатьох країн з різними регуляторними вимогами. Яка стратегія тестування НАЙКРАЩЕ забезпечить відповідність у всіх юрисдикціях при збереженні ефективності розробки? Оберіть ОДИН варіант.",
        options: [
          "Централізоване тестування з найсуворішими міжнародними стандартами для всіх регіонів",
          "Окремі тестові набори для кожної країни з локальними командами тестування",
          "Мінімальні тестові вимоги на основі найменш суворих регуляцій",
          "Відкладення запуску до гармонізації міжнародних регуляторних стандартів"
        ],
        correct: 0,
        expA: "Правильно! Найсуворіші стандарти забезпечують відповідність усюди, спрощуючи розробку та підтримку.",
        expB: "Окремі набори створюють операційну складність та ризики несумісності між регіонами.",
        expC: "Мінімальні вимоги створюють ризики недотримання в суворіших юрисдикціях.",
        expD: "Очікування гармонізації може відкласти випуск на невизначений термін та втратити ринкові можливості.",
        points: 3,
        chapter: "Тестування специфічних характеристик якості систем на основі ШІ",
        difficulty: "K4"
      },
      {
        id: 277,
        text: "Система ШІ для діагностики в критичній медичній інфраструктурі повинна балансувати між швидкістю відповіді та точністю діагностики. Яка стратегія НАЙКРАЩЕ оптимізує цей баланс при забезпеченні безпеки пацієнтів? Оберіть ОДИН варіант.",
        options: [
          "Пріоритет швидкості для швидкого лікування пацієнтів",
          "Максимальна точність незалежно від часу обробки",
          "Адаптивний підхід з варіацією швидкості залежно від критичності випадку",
          "Стандартний час відповіді для всіх діагностичних запитів"
        ],
        correct: 2,
        expA: "Пріоритет швидкості може призвести до помилкових діагнозів у критичних медичних ситуаціях.",
        expB: "Максимальна точність важлива, але надмірні затримки можуть загрожувати життю пацієнтів.",
        expC: "Відмінно! Адаптивний підхід оптимізує швидкість та точність на основі медичної критичності ситуації.",
        expD: "Стандартний час не враховує варіативність медичних потреб від рутинних до критичних випадків.",
        points: 3,
        chapter: "Тестування специфічних характеристик якості систем на основі ШІ",
        difficulty: "K4"
      },
      {
        id: 278,
        text: "Автономна система керування енергомережею повинна адаптуватися до непередбачуваних змін попиту та постачання. Яка стратегія тестування НАЙКРАЩЕ валідує адаптивність системи в екстремальних сценаріях? Оберіть ОДИН варіант.",
        options: [
          "Симуляція історичних енергетичних криз з відомими рішеннями",
          "Стрес-тестування з реалістичними але екстремальними сценаріями навантаження",
          "Тестування в контрольованому середовищі з передбачуваними варіаціями",
          "Валідація на основі типових щоденних коливань енергоспоживання"
        ],
        correct: 1,
        expA: "Історичні кризи забезпечують контекст, але майбутні сценарії можуть відрізнятися від минулих подій.",
        expB: "Правильно! Стрес-тестування готує систему до непередбачуваних але реалістичних екстремальних ситуацій.",
        expC: "Контрольовані тести корисні, але не готують систему до справжньої непередбачуваності енергомереж.",
        expD: "Типові коливання не виявлять здатність системи справлятися з екстремальними енергетичними подіями.",
        points: 3,
        chapter: "Тестування специфічних характеристик якості систем на основі ШІ",
        difficulty: "K4"
      },
      {
        id: 279,
        text: "Система ШІ для діагностики повинна забезпечити високу точність разом з показниками впевненості для лікарів. Яка стратегія валідації НАЙКРАЩЕ забезпечить надійність діагностичних рішень? Оберіть ОДИН варіант.",
        options: [
          "Швидке розгортання для збору реальних діагностичних даних",
          "Рівні впевненості вказують на надійність та повинні враховуватися при валідації діагнозів",
          "Зважені ансамблі з мірами невизначеності забезпечують стійку валідацію для діагностичних систем ШІ",
          "Швидкості недостатньо для діагностичних рішень, де критичними є точність та впевненість"
        ],
        correct: 2,
        expA: "Швидке розгортання ризиковане для медичних систем без належної валідації безпеки та ефективності.",
        expB: "Рівні впевненості вказують на надійність та повинні враховуватися при валідації діагнозів.",
        expC: "Точно! Зважені ансамблі з мірами невизначеності забезпечують стійку валідацію для діагностичних систем ШІ.",
        expD: "Швидкості недостатньо для діагностичних рішень, де критичними є точність та впевненість.",
        points: 3,
        chapter: "Тестування специфічних характеристик якості систем на основі ШІ",
        difficulty: "K4"
      },
      {
        id: 280,
        text: "Який підхід управління НАЙКРАЩЕ керує складністю тестування самонавчальних систем в різних бізнес-підрозділах? Оберіть ОДИН варіант.",
        options: [
          "Усунення всіх можливостей самонавчання",
          "Використання ідентичного тестування для всіх підрозділів",
          "Зменшення функціональності системи до основ",
          "Впровадження ризик-орієнтованих фреймворків тестування з безперервним моніторингом"
        ],
        correct: 3,
        expA: "Усунення самонавчання видаляє цінні адаптивні можливості замість управління викликами тестування.",
        expB: "Різні бізнес-підрозділи мають різну толерантність до ризиків, що потребує індивідуальних підходів до тестування.",
        expC: "Зменшення функціональності жертвує бізнес-цінністю замість вирішення проблеми складності тестування.",
        expD: "Правильно! Ризик-орієнтовані фреймворки дозволяють індивідуальну інтенсивність тестування, а безперервний моніторинг відстежує еволюцію.",
        points: 3,
        chapter: "Тестування специфічних характеристик якості систем на основі ШІ",
        difficulty: "K4"
      },
      {
        id: 281,
        text: "Який підхід забезпечує збереження попередньої функціональності після оновлень систем ШІ? Оберіть ОДИН варіант.",
        options: [
          "Управління станом Vue.js компонентів та хуки життєвого циклу",
          "Регресійне тестування для валідації функціональності систем ШІ",
          "Процедури відкату PostgreSQL транзакцій баз даних",
          "Версійність Docker образів контейнерів та стратегії відкату"
        ],
        correct: 1,
        expA: "Vue.js управляє станом frontend компонентів, а не валідацією функціональності систем ШІ.",
        expB: "Ідеально! Регресійне тестування гарантує, що оновлення систем ШІ не порушують існуючу функціональність.",
        expC: "PostgreSQL відкати обробляють консистентність баз даних, а не тестування функціональності ШІ.",
        expD: "Docker версійність управляє розгортанням контейнерів, а не валідацією функціональності ШІ.",
        points: 1,
        chapter: "Методи та Техніки Тестування Систем на Основі ШІ",
        difficulty: "K1"
      },
      {
        id: 282,
        text: "Який компонент забезпечує очікувані результати для валідації тестів систем ШІ? Оберіть ОДИН варіант.",
        options: [
          "React залежності хуків та механізми очищення ефектів",
          "Тестові оракули для валідації та порівняння систем ШІ",
          "MongoDB конфігурація replica set та системи відмовостійкості",
          "Kubernetes виявлення сервісів та правила балансування навантаження"
        ],
        correct: 1,
        expA: "React хуки управляють ефектами frontend компонентів, а не валідацією тестових результатів.",
        expB: "Точно! Тестові оракули забезпечують очікувані результати для порівняння виходів систем ШІ.",
        expC: "MongoDB replica sets гарантують доступність баз даних, а не валідацію тестів.",
        expD: "Kubernetes балансування навантаження управляє розподілом трафіку, а не тестовими оракулами.",
        points: 1,
        chapter: "Методи та Техніки Тестування Систем на Основі ШІ",
        difficulty: "K1"
      },
      {
        id: 283,
        text: "Яке з наступних тверджень про еквівалентні розбиття в тестуванні ШІ є ПРАВИЛЬНИМ? Оберіть ОДИН варіант.",
        options: [
          "Групує подібні входи ШІ для зменшення зусиль тестування",
          "Розділяє архітектури моделей ШІ за рівнями складності",
          "Ділить навчальні набори даних ШІ на сегменти валідації",
          "Сегментує конвеєри інференції ШІ за етапами обробки"
        ],
        correct: 0,
        expA: "Правильно! Еквівалентні розбиття групують входи ШІ, що повинні поводитися подібно, для зменшення зусиль тестування.",
        expB: "Розділення архітектур стосується дизайну моделей, а не техніки еквівалентних розбиттів для тестування.",
        expC: "Поділ наборів даних - це підготовка даних, не пов'язана з техникою еквівалентних розбиттів.",
        expD: "Сегментація конвеєрів стосується архітектури системи, а не принципів еквівалентних розбиттів.",
        points: 1,
        chapter: "Методи та Техніки Тестування Систем на Основі ШІ",
        difficulty: "K2"
      },
      {
        id: 284,
        text: "Що є ОСНОВНОЮ метою аналізу граничних значень при тестуванні моделей ШІ? Оберіть ОДИН варіант.",
        options: [
          "Тестування поведінки системи біля меж діапазонів вхідних даних",
          "Валідація продуктивності моделі на типових робочих навантаженнях",
          "Оцінка точності моделі на збалансованих наборах навчальних даних",
          "Перевірка інтеграції моделі з зовнішніми системами та API"
        ],
        correct: 0,
        expA: "Абсолютно! Аналіз граничних значень виявляє дефекти в критичних точках, де поведінка моделі може змінюватися.",
        expB: "Тестування на типових навантаженнях важливе, але не є основною метою аналізу граничних значень.",
        expC: "Оцінка точності на збалансованих даних - це загальна валідація, не специфічна для граничних значень.",
        expD: "Тестування інтеграції важливе, але не є фокусом аналізу граничних значень для моделей ШІ.",
        points: 1,
        chapter: "Методи та Техніки Тестування Систем на Основі ШІ",
        difficulty: "K2"
      },
      {
        id: 285,
        text: "Який підхід НАЙКРАЩЕ описує метаморфічне тестування в контексті систем ШІ? Оберіть ОДИН варіант.",
        options: [
          "Валідація співвідношень між трансформованими входами та їх виходами",
          "Порівняння продуктивності різних архітектур моделей машинного навчання",
          "Тестування адаптивності моделі до змін у розподілі даних",
          "Оцінка стійкості моделі до адверсаріальних атак та шуму"
        ],
        correct: 0,
        expA: "Правильно! Метаморфічне тестування перевіряє, чи зберігаються очікувані співвідношення при трансформації входів.",
        expB: "Порівняння архітектур - це бенчмаркінг моделей, а не метаморфічне тестування співвідношень.",
        expC: "Тестування адаптивності важливе, але не відображає суть метаморфічного тестування співвідношень.",
        expD: "Оцінка стійкості - це тестування робастності, відмінне від метаморфічного тестування.",
        points: 1,
        chapter: "Методи та Техніки Тестування Систем на Основі ШІ",
        difficulty: "K2"
      },
      {
        id: 286,
        text: "Яка техніка НАЙЕФЕКТИВНІША для тестування систем ШІ з недетермінованою поведінкою? Оберіть ОДИН варіант.",
        options: [
          "Статистичне тестування з аналізом розподілу результатів та довірчих інтервалів",
          "Детерміністичні тестові сценарії з фіксованими очікуваними результатами",
          "Одноразові тести з бінарним аналізом проходження та провалу",
          "Лінійне тестування послідовностей з передбачуваними патернами виходу"
        ],
        correct: 0,
        expA: "Відмінно! Статистичне тестування враховує мінливість недетермінованих систем через аналіз розподілів.",
        expB: "Детерміністичні тести не підходять для систем з природною варіативністю та недетермінованістю.",
        expC: "Бінарний аналіз не враховує статистичну природу недетермінованих систем ШІ.",
        expD: "Лінійне тестування не відображає складність та варіативність недетермінованої поведінки ШІ.",
        points: 1,
        chapter: "Методи та Техніки Тестування Систем на Основі ШІ",
        difficulty: "K2"
      },
      {
        id: 287,
        text: "Що робить A/B тестування особливо корисним для систем ШІ в продакшені? Оберіть ОДИН варіант.",
        options: [
          "Забезпечує детерміністичну поведінку для воспроизводимих результатів",
          "Дозволяє порівняння реальної продуктивності між версіями в живому середовищі",
          "Усуває потребу в тестових оракулах та базових лініях продуктивності",
          "Автоматизує процес валідації без залучення людських експертів"
        ],
        correct: 1,
        expA: "A/B тестування не гарантує детерміністичність - воно порівнює варіативні системи в реальних умовах.",
        expB: "Точно! A/B тестування забезпечує порівняння реальної продуктивності різних версій з живими користувачами.",
        expC: "A/B тестування все ще потребує метрик та базових ліній для значущого порівняння версій.",
        expD: "A/B тестування часто потребує людської експертизи для інтерпретації результатів та прийняття рішень.",
        points: 1,
        chapter: "Методи та Техніки Тестування Систем на Основі ШІ",
        difficulty: "K2"
      },
      {
        id: 288,
        text: "Яка основна перевага використання синтетичних даних при тестуванні систем ШІ? Оберіть ОДИН варіант.",
        options: [
          "Контрольована генерація тестових сценаріїв з відомими характеристиками та лейблами",
          "Повне заміщення реальних даних для всіх етапів розробки та валідації",
          "Автоматичне покращення точності моделі без додаткових тренувальних даних",
          "Усунення всіх проблем з приватністю та регуляторними обмеженнями"
        ],
        correct: 0,
        expA: "Правильно! Синтетичні дані дозволяють створювати контрольовані тестові сценарії з точно відомими характеристиками.",
        expB: "Синтетичні дані доповнюють, але не можуть повністю замінити реальні дані для всеосяжної валідації.",
        expC: "Синтетичні дані не автоматично покращують точність - вони забезпечують контрольоване тестове середовище.",
        expD: "Хоча синтетичні дані допомагають з приватністю, вони не усувають всі регуляторні виклики.",
        points: 1,
        chapter: "Методи та Техніки Тестування Систем на Основі ШІ",
        difficulty: "K2"
      },
      {
        id: 289,
        text: "Чому back-to-back тестування особливо корисне при валідації систем ШІ? Оберіть ОДИН варіант.",
        options: [
          "Усуває потребу в людських експертах для оцінки якості результатів",
          "Виявляє розбіжності через порівняння виходів кількох незалежних реалізацій",
          "Автоматично виправляє помилки через консенсус між різними системами",
          "Покращує продуктивність через паралельне виконання декількох алгоритмів"
        ],
        correct: 1,
        expA: "Back-to-back тестування не усуває потребу в експертній оцінці - воно виявляє розбіжності для подальшого аналізу.",
        expB: "Абсолютно! Порівняння виходів незалежних реалізацій виявляє потенційні дефекти та невідповідності.",
        expC: "Back-to-back тестування виявляє проблеми, але не автоматично їх виправляє - потрібен людський аналіз.",
        expD: "Мета - валідація через порівняння, а не покращення продуктивності через паралелізм.",
        points: 1,
        chapter: "Методи та Техніки Тестування Систем на Основі ШІ",
        difficulty: "K2"
      },
      {
        id: 290,
        text: "Компанія розробляє систему рекомендацій для е-комерції з мільйонами користувачів. Яка стратегія тестування НАЙКРАЩЕ забезпечить якість рекомендацій? Оберіть ОДИН варіант.",
        options: [
          "Багатоетапне A/B тестування з когортним аналізом та метриками залучення користувачів",
          "Лабораторне тестування з синтетичними профілями користувачів та симуляцією поведінки",
          "Офлайн валідація з історичними даними та стандартними метриками точності",
          "Експертна оцінка рекомендацій доменними фахівцями та внутрішніми командами"
        ],
        correct: 0,
        expA: "Відмінно! A/B тестування з когортним аналізом забезпечує валідацію реальної цінності для користувачів.",
        expB: "Лабораторне тестування корисне для початкової валідації, але не відображає реальну поведінку користувачів.",
        expC: "Офлайн валідація важлива, але може не корелювати з реальною корисністю для користувачів.",
        expD: "Експертна оцінка цінна, але не може охопити різноманітність вподобань мільйонів користувачів.",
        points: 2,
        chapter: "Методи та Техніки Тестування Систем на Основі ШІ",
        difficulty: "K3"
      },
      {
        id: 291,
        text: "Автономне транспортне средство використовує комп'ютерний зір для навігації. Яка комбінація технік НАЙКРАЩЕ валідує безпеку системи? Оберіть ОДИН варіант.",
        options: [
          "Змагальні тести продуктивності з стандартизованими автомобільними бенчмарками",
          "Симуляційне тестування з реальними сценаріями та валідація на тестових треках",
          "Статичний аналіз коду алгоритмів з автоматизованою перевіркою безпеки",
          "Офлайн аналіз записаних відеоданих з ручною анотацією експертів"
        ],
        correct: 1,
        expA: "Бенчмарки корисні для порівняння, але не забезпечують всеосяжної валідації безпеки в реальних умовах.",
        expB: "Правильно! Комбінація симуляції та реальних тестів забезпечує комплексну валідацію безпеки.",
        expC: "Статичний аналіз важливий, але не може валідувати динамічну поведінку в реальних сценаріях.",
        expD: "Офлайн аналіз корисний для розуміння, але не може замінити валідацію в реальному часі.",
        points: 2,
        chapter: "Методи та Техніки Тестування Систем на Основі ШІ",
        difficulty: "K3"
      },
      {
        id: 292,
        text: "Медична діагностична система ШІ демонструє різну точність для різних демографічних груп. Яка стратегія НАЙЕФЕКТИВНІШЕ вирішить цю проблему? Оберіть ОДИН варіант.",
        options: [
          "Збільшення загального обсягу навчальних даних для покращення базової точності",
          "Стратифіковане тестування з репрезентативними когортами та метриками справедливості",
          "Спрощення моделі для зменшення складності та потенційного упередження",
          "Фокус на домінуючій демографічній групі для максимізації загальної точності"
        ],
        correct: 1,
        expA: "Більше даних може допомогти, але без стратифікованого підходу не вирішить проблеми справедливості.",
        expB: "Точно! Стратифіковане тестування виявляє та адресує диспаритети між демографічними групами.",
        expC: "Спрощення може зменшити упередження, але також може жертвувати необхідною діагностичною точністю.",
        expD: "Фокус на одній групі погіршує диспаритети та створює етичні проблеми в медицині.",
        points: 2,
        chapter: "Методи та Техніки Тестування Систем на Основі ШІ",
        difficulty: "K3"
      },
      {
        id: 293,
        text: "Фінансова установа впроваджує систему виявлення шахрайства на основі ШІ. Яка комбінація підходів НАЙКРАЩЕ збалансує точність виявлення з мінімізацією хибних спрацьовувань? Оберіть ОДИН варіант.",
        options: [
          "Високий поріг впевненості для зменшення хибних позитивних результатів",
          "Низький поріг впевненості для максимізації виявлення всіх можливих загроз",
          "Адаптивні пороги з аналізом вартості та человеческій верифікацією граничних випадків",
          "Статичні пороги на основі історичних даних без подальших коригувань"
        ],
        correct: 2,
        expA: "Високі пороги зменшують хибні спрацьовування, але можуть пропустити справжнє шахрайство.",
        expB: "Низькі пороги виявляють більше загроз, але створюють неприйнятну кількість хибних спрацьовувань.",
        expC: "Правильно! Адаптивні пороги з людською верифікацією оптимізують баланс між точністю та корисністю.",
        expD: "Статичні пороги не адаптуються до еволюції патернів шахрайства та зміни умов бізнесу.",
        points: 2,
        chapter: "Методи та Техніки Тестування Систем на Основі ШІ",
        difficulty: "K3"
      },
      {
        id: 294,
        text: "Система обробки природної мови повинна працювати з багатьма мовами та діалектами. Яка стратегія тестування НАЙКРАЩЕ забезпечить рівномірну якість? Оберіть ОДИН варіант.",
        options: [
          "Фокус на найпоширеніших мовах з найбільшою кількістю користувачів",
          "Автоматичний переклад всіх тестових даних з однієї базової мови",
          "Стратифіковане багатомовне тестування з носіями мови та культурною валідацією",
          "Стандартизація всіх мов до спільного лінгвістичного формату вводу"
        ],
        correct: 2,
        expA: "Фокус на популярних мовах створює нерівність та ігнорує потреби меншинних мовних груп.",
        expB: "Автоматичний переклад може внести артефакти та не відобразити справжні мовні нюанси.",
        expC: "Відмінно! Залучення носіїв мови забезпечує автентичну валідацію культурних та лінгвістичних нюансів.",
        expD: "Стандартизація втрачає важливі мовні особливості, що впливають на якість обробки.",
        points: 2,
        chapter: "Методи та Техніки Тестування Систем на Основі ШІ",
        difficulty: "K3"
      },
      {
        id: 295,
        text: "Чат-бот обслуговування клієнтів повинен обробляти складні запити та эмоційні ситуації. Яка методологія тестування НАЙКРАЩЕ валідує його ефективність? Оберіть ОДИН варіант.",
        options: [
          "Автоматизовані тести з попередньо визначеними скриптами запитів та відповідей",
          "Навантажувальне тестування з високим обсягом одночасних користувацьких сесій",
          "Статистичний аналіз логів розмов з метриками успішності та задоволеності",
          "Змішане тестування з реальними користувачами, сценаріями та експертною оцінкою"
        ],
        correct: 3,
        expA: "Автоматизовані скрипти корисні для базової функціональності, але не охоплюють складність реальних взаємодій.",
        expB: "Навантажувальне тестування валідує продуктивність, але не якість відповідей або задоволеність користувачів.",
        expC: "Аналіз логів надає цінні дані, але може пропустити нюанси користувацького досвіду.",
        expD: "Правильно! Змішаний підхід забезпечує всеосяжну валідацію функціональності та користувацького досвіду.",
        points: 2,
        chapter: "Методи та Техніки Тестування Систем на Основі ШІ",
        difficulty: "K3"
      },
      {
        id: 296,
        text: "Глобальна технологічна компанія розгортає платформу ШІ у 50+ країнах з різноманітними регуляторними вимогами та культурними контекстами. Яка стратегія тестування НАЙКРАЩЕ забезпечить глобальну відповідність при збереженні ефективності розробки? Оберіть ОДИН варіант.",
        options: [
          "Окремі команди тестування в кожній країні з локально адаптованими тестовими наборами",
          "Мінімальні тестові вимоги на основі найменш суворих міжнародних стандартів",
          "Централізований фреймворк з модульними тестами для специфічних регуляторних вимог",
          "Відкладення запуску до повної гармонізації всіх міжнародних регуляторних стандартів"
        ],
        correct: 2,
        expA: "Окремі команди створюють операційну складність та ризики несумісності між регіонами.",
        expB: "Мінімальні стандарди створюють ризики недотримання в суворіших регуляторних юрисдикціях.",
        expC: "Відмінно! Централізований фреймворк з модульністю балансує ефективність з локальною відповідністю.",
        expD: "Очікування гармонізації може відкласти запуск на невизначений термін та втратити конкурентні переваги.",
        points: 3,
        chapter: "Методи та Техніки Тестування Систем на Основі ШІ",
        difficulty: "K4"
      },
      {
        id: 297,
        text: "Система рекрутингу на основі ШІ повинна забезпечити справедливість серед різних груп кандидатів. Яка стратегія НАЙКРАЩЕ інтегрує тестування справедливості в цикл розробки? Оберіть ОДИН варіант.",
        options: [
          "Пост-розгортання аудит з ретроспективним аналізом демографічних результатів",
          "Безперервний моніторинг справедливості з автоматизованими сповіщеннями та коригуваннями",
          "Щорічні огляди системи з зовнішніми аудиторами та консультантами з етики",
          "Статичний аналіз алгоритму без розгляду реальних результатів набору персоналу"
        ],
        correct: 1,
        expA: "Пост-розгортання аудит виявляє проблеми занадто пізно, після впливу на кандидатів.",
        expB: "Правильно! Безперервний моніторинг дозволяє раннє виявлення та оперативне усунення проблем справедливості.",
        expC: "Щорічні огляди цінні, але недостатньо частые для виявлення та вирішення проблем своєчасно.",
        expD: "Статичний аналіз важливий, але не може передбачити реальні результати впливу на різні групи.",
        points: 3,
        chapter: "Методи та Техніки Тестування Систем на Основі ШІ",
        difficulty: "K4"
      },
      {
        id: 298,
        text: "Критична інфраструктурна система ШІ для управління енергомережею повинна адаптуватися до непередбачуваних умов. Яка стратегія тестування НАЙКРАЩЕ валідує надійність системи в екстремальних сценаріях? Оберіть ОДИН варіант.",
        options: [
          "Історичне тестування на основі минулих енергетичних криз та відомих інцидентів",
          "Контрольовані лабораторні умови з передбачуваними варіаціями навантаження",
          "Адверсаріальне стрес-тестування з непередбачуваними та каскадними сценаріями відмов",
          "Імітаційне моделювання з детерміністичними алгоритмами та фіксованими параметрами"
        ],
        correct: 2,
        expA: "Історичні дані забезпечують контекст, але майбутні кризи можуть відрізнятися від минулих подій.",
        expB: "Лабораторні умови корисні, але не готують систему до справжньої непередбачуваності енергомереж.",
        expC: "Точно! Адверсаріальне тестування готує систему до найгірших сценаріїв та каскадних відмов.",
        expD: "Детерміністичне моделювання не відображає складність та непередбачуваність реальних енергосистем.",
        points: 3,
        chapter: "Методи та Техніки Тестування Систем на Основі ШІ",
        difficulty: "K4"
      },
      {
        id: 299,
        text: "Проєкт поєднує дані з багатьох джерел для навчання системи ШІ. Яка стратегія НАЙКРАЩЕ управляє якістю та сумісністю даних? Оберіть ОДИН варіант.",
        options: [
          "Стандартизація всіх джерел даних до єдиного формату перед інтеграцією",
          "Багатоетапна валідація з профілюванням даних, виявленням аномалій та лінійностю",
          "Пріоритет найякісніших джерел даних з відкиданням сумнівних джерел",
          "Автоматизована очистка даних без людського нагляду та експертизи домену"
        ],
        correct: 1,
        expA: "Стандартизація корисна, але може втратити важливу інформацію, специфічну для джерела даних.",
        expB: "Відмінно! Багатоетапна валідація забезпечує комплексне управління якістю при збереженні різноманітності даних.",
        expC: "Пріоритизація якісних джерел може створити упередження та втратити цінну інформацію з інших джерел.",
        expD: "Автоматизована очистка без експертного нагляду може внести помилки або втратити важливі нюанси.",
        points: 3,
        chapter: "Методи та Техніки Тестування Систем на Основі ШІ",
        difficulty: "K4"
      },
      {
        id: 300,
        text: "Мультимодальна система ШІ обробляє текст, зображення та аудіо для глобальної аудиторії. Яка стратегія тестування НАЙКРАЩЕ забезпечує рівномірну якість через модальності та культури? Оберіть ОДИН варіант.",
        options: [
          "Послідовне тестування кожної модальності окремо з оптимізацією компонентів",
          "Систематичне кросс-модальне та кросс-культурне тестування з інтеграційною валідацією",
          "Фокус на домінуючих модальностях та культурних контекстах для ефективності",
          "Випадкове тестування різних комбінацій для покриття можливих взаємодій"
        ],
        correct: 1,
        expA: "Послідовне тестування модальностей окремо ігнорує складність мультимодальної інтеграції.",
        expB: "Відмінно! Систематичний підхід з кросс-модальною та кросс-культурною валідацією забезпечує комплексне покриття.",
        expC: "Фокус на домінуючих контекстах ігнорує важливі культурні відмінності у меншинних групах.",
        expD: "Випадкове тестування не забезпечує систематичного покриття складних мультимодальних взаємодій.",
        points: 3,
        chapter: "Методи та Техніки Тестування Систем на Основі ШІ",
        difficulty: "K4"
      }
    ]

// Export as fullQuestionPool for consistency
export const fullQuestionPool = examQuestionsBatch1Ukrainian;